/*! jQuery v3.7.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
function getFocusableElements(e) {
    return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}! function(e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document) throw Error("jQuery requires a window with a document");
        return t(e)
    } : t(e)
}("undefined" != typeof window ? window : this, function(e, t) {
    "use strict";
    var i = [],
        n = Object.getPrototypeOf,
        o = i.slice,
        s = i.flat ? function(e) {
            return i.flat.call(e)
        } : function(e) {
            return i.concat.apply([], e)
        },
        r = i.push,
        a = i.indexOf,
        l = {},
        d = l.toString,
        c = l.hasOwnProperty,
        u = c.toString,
        p = u.call(Object),
        h = {},
        f = function(e) {
            return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item
        },
        m = function(e) {
            return null != e && e === e.window
        },
        y = e.document,
        v = {
            type: !0,
            src: !0,
            nonce: !0,
            noModule: !0
        };

    function g(e, t, i) {
        var n, o, s = (i = i || y).createElement("script");
        if (s.text = e, t)
            for (n in v)(o = t[n] || t.getAttribute && t.getAttribute(n)) && s.setAttribute(n, o);
        i.head.appendChild(s).parentNode.removeChild(s)
    }

    function b(e) {
        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? l[d.call(e)] || "object" : typeof e
    }
    var w = "3.7.1",
        S = /HTML$/i,
        T = function(e, t) {
            return new T.fn.init(e, t)
        };

    function x(e) {
        var t = !!e && "length" in e && e.length,
            i = b(e);
        return !f(e) && !m(e) && ("array" === i || 0 === t || "number" == typeof t && 0 < t && t - 1 in e)
    }

    function k(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
    }
    T.fn = T.prototype = {
        jquery: w,
        constructor: T,
        length: 0,
        toArray: function() {
            return o.call(this)
        },
        get: function(e) {
            return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e]
        },
        pushStack: function(e) {
            var t = T.merge(this.constructor(), e);
            return t.prevObject = this, t
        },
        each: function(e) {
            return T.each(this, e)
        },
        map: function(e) {
            return this.pushStack(T.map(this, function(t, i) {
                return e.call(t, i, t)
            }))
        },
        slice: function() {
            return this.pushStack(o.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        even: function() {
            return this.pushStack(T.grep(this, function(e, t) {
                return (t + 1) % 2
            }))
        },
        odd: function() {
            return this.pushStack(T.grep(this, function(e, t) {
                return t % 2
            }))
        },
        eq: function(e) {
            var t = this.length,
                i = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= i && i < t ? [this[i]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: r,
        sort: i.sort,
        splice: i.splice
    }, T.extend = T.fn.extend = function() {
        var e, t, i, n, o, s, r = arguments[0] || {},
            a = 1,
            l = arguments.length,
            d = !1;
        for ("boolean" == typeof r && (d = r, r = arguments[a] || {}, a++), "object" == typeof r || f(r) || (r = {}), a === l && (r = this, a--); a < l; a++)
            if (null != (e = arguments[a]))
                for (t in e) n = e[t], "__proto__" !== t && r !== n && (d && n && (T.isPlainObject(n) || (o = Array.isArray(n))) ? (i = r[t], s = o && !Array.isArray(i) ? [] : o || T.isPlainObject(i) ? i : {}, o = !1, r[t] = T.extend(d, s, n)) : void 0 !== n && (r[t] = n));
        return r
    }, T.extend({
        expando: "jQuery" + (w + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw Error(e)
        },
        noop: function() {},
        isPlainObject: function(e) {
            var t, i;
            return !(!e || "[object Object]" !== d.call(e) || (t = n(e)) && ("function" != typeof(i = c.call(t, "constructor") && t.constructor) || u.call(i) !== p))
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e) return !1;
            return !0
        },
        globalEval: function(e, t, i) {
            g(e, {
                nonce: t && t.nonce
            }, i)
        },
        each: function(e, t) {
            var i, n = 0;
            if (x(e))
                for (i = e.length; n < i && !1 !== t.call(e[n], n, e[n]); n++);
            else
                for (n in e)
                    if (!1 === t.call(e[n], n, e[n])) break;
            return e
        },
        text: function(e) {
            var t, i = "",
                n = 0,
                o = e.nodeType;
            if (!o)
                for (; t = e[n++];) i += T.text(t);
            return 1 === o || 11 === o ? e.textContent : 9 === o ? e.documentElement.textContent : 3 === o || 4 === o ? e.nodeValue : i
        },
        makeArray: function(e, t) {
            var i = t || [];
            return null != e && (x(Object(e)) ? T.merge(i, "string" == typeof e ? [e] : e) : r.call(i, e)), i
        },
        inArray: function(e, t, i) {
            return null == t ? -1 : a.call(t, e, i)
        },
        isXMLDoc: function(e) {
            var t = e && e.namespaceURI,
                i = e && (e.ownerDocument || e).documentElement;
            return !S.test(t || i && i.nodeName || "HTML")
        },
        merge: function(e, t) {
            for (var i = +t.length, n = 0, o = e.length; n < i; n++) e[o++] = t[n];
            return e.length = o, e
        },
        grep: function(e, t, i) {
            for (var n = [], o = 0, s = e.length, r = !i; o < s; o++) !t(e[o], o) !== r && n.push(e[o]);
            return n
        },
        map: function(e, t, i) {
            var n, o, r = 0,
                a = [];
            if (x(e))
                for (n = e.length; r < n; r++) null != (o = t(e[r], r, i)) && a.push(o);
            else
                for (r in e) null != (o = t(e[r], r, i)) && a.push(o);
            return s(a)
        },
        guid: 1,
        support: h
    }), "function" == typeof Symbol && (T.fn[Symbol.iterator] = i[Symbol.iterator]), T.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
        l["[object " + t + "]"] = t.toLowerCase()
    });
    var C = i.pop,
        $ = i.sort,
        E = i.splice,
        A = "[\\x20\\t\\r\\n\\f]",
        L = RegExp("^" + A + "+|((?:^|[^\\\\])(?:\\\\.)*)" + A + "+$", "g");
    T.contains = function(e, t) {
        var i = t && t.parentNode;
        return e === i || !(!i || 1 !== i.nodeType || !(e.contains ? e.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)))
    };
    var P = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

    function D(e, t) {
        return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
    }
    T.escapeSelector = function(e) {
        return (e + "").replace(P, D)
    };
    var O = y,
        I = r;
    ! function() {
        var t, n, s, r, l, d, u, p, f, m, y = I,
            v = T.expando,
            g = 0,
            b = 0,
            w = ee(),
            S = ee(),
            x = ee(),
            P = ee(),
            D = function(e, t) {
                return e === t && (l = !0), 0
            },
            q = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            M = "(?:\\\\[\\da-fA-F]{1,6}" + A + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            H = "\\[" + A + "*(" + M + ")(?:" + A + "*([*^$|!~]?=)" + A + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + M + "))|)" + A + "*\\]",
            B = ":(" + M + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + H + ")*)|.*)\\)|)",
            j = RegExp(A + "+", "g"),
            N = RegExp("^" + A + "*," + A + "*"),
            R = RegExp("^" + A + "*([>+~]|" + A + ")" + A + "*"),
            _ = RegExp(A + "|>"),
            W = RegExp(B),
            F = RegExp("^" + M + "$"),
            z = {
                ID: RegExp("^#(" + M + ")"),
                CLASS: RegExp("^\\.(" + M + ")"),
                TAG: RegExp("^(" + M + "|[*])"),
                ATTR: RegExp("^" + H),
                PSEUDO: RegExp("^" + B),
                CHILD: RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + A + "*(even|odd|(([+-]|)(\\d*)n|)" + A + "*(?:([+-]|)" + A + "*(\\d+)|))" + A + "*\\)|)", "i"),
                bool: RegExp("^(?:" + q + ")$", "i"),
                needsContext: RegExp("^" + A + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + A + "*((?:-\\d)?\\d*)" + A + "*\\)|)(?=[^-]|$)", "i")
            },
            U = /^(?:input|select|textarea|button)$/i,
            V = /^h\d$/i,
            X = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            Y = /[+~]/,
            G = RegExp("\\\\[\\da-fA-F]{1,6}" + A + "?|\\\\([^\\r\\n\\f])", "g"),
            Q = function(e, t) {
                var i = "0x" + e.slice(1) - 65536;
                return t || (i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320))
            },
            K = function() {
                le()
            },
            J = pe(function(e) {
                return !0 === e.disabled && k(e, "fieldset")
            }, {
                dir: "parentNode",
                next: "legend"
            });
        try {
            y.apply(i = o.call(O.childNodes), O.childNodes), i[O.childNodes.length].nodeType
        } catch (e) {
            y = {
                apply: function(e, t) {
                    I.apply(e, o.call(t))
                },
                call: function(e) {
                    I.apply(e, o.call(arguments, 1))
                }
            }
        }

        function Z(e, t, i, n) {
            var o, s, r, a, l, c, u, m = t && t.ownerDocument,
                g = t ? t.nodeType : 9;
            if (i = i || [], "string" != typeof e || !e || 1 !== g && 9 !== g && 11 !== g) return i;
            if (!n && (le(t), t = t || d, p)) {
                if (11 !== g && (l = X.exec(e)))
                    if (o = l[1]) {
                        if (9 === g) {
                            if (!(r = t.getElementById(o))) return i;
                            if (r.id === o) return y.call(i, r), i
                        } else if (m && (r = m.getElementById(o)) && Z.contains(t, r) && r.id === o) return y.call(i, r), i
                    } else {
                        if (l[2]) return y.apply(i, t.getElementsByTagName(e)), i;
                        if ((o = l[3]) && t.getElementsByClassName) return y.apply(i, t.getElementsByClassName(o)), i
                    } if (!(P[e + " "] || f && f.test(e))) {
                    if (u = e, m = t, 1 === g && (_.test(e) || R.test(e))) {
                        for ((m = Y.test(e) && ae(t.parentNode) || t) == t && h.scope || ((a = t.getAttribute("id")) ? a = T.escapeSelector(a) : t.setAttribute("id", a = v)), s = (c = ce(e)).length; s--;) c[s] = (a ? "#" + a : ":scope") + " " + ue(c[s]);
                        u = c.join(",")
                    }
                    try {
                        return y.apply(i, m.querySelectorAll(u)), i
                    } catch (t) {
                        P(e, !0)
                    } finally {
                        a === v && t.removeAttribute("id")
                    }
                }
            }
            return ge(e.replace(L, "$1"), t, i, n)
        }

        function ee() {
            var e = [];
            return function t(i, o) {
                return e.push(i + " ") > n.cacheLength && delete t[e.shift()], t[i + " "] = o
            }
        }

        function te(e) {
            return e[v] = !0, e
        }

        function ie(e) {
            var t = d.createElement("fieldset");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t), t = null
            }
        }

        function ne(e) {
            return function(t) {
                return k(t, "input") && t.type === e
            }
        }

        function oe(e) {
            return function(t) {
                return (k(t, "input") || k(t, "button")) && t.type === e
            }
        }

        function se(e) {
            return function(t) {
                return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || !e !== t.isDisabled && J(t) === e : t.disabled === e : "label" in t && t.disabled === e
            }
        }

        function re(e) {
            return te(function(t) {
                return t = +t, te(function(i, n) {
                    for (var o, s = e([], i.length, t), r = s.length; r--;) i[o = s[r]] && (i[o] = !(n[o] = i[o]))
                })
            })
        }

        function ae(e) {
            return e && void 0 !== e.getElementsByTagName && e
        }

        function le(e) {
            var t, i = e ? e.ownerDocument || e : O;
            return i != d && 9 === i.nodeType && i.documentElement && (u = (d = i).documentElement, p = !T.isXMLDoc(d), m = u.matches || u.webkitMatchesSelector || u.msMatchesSelector, u.msMatchesSelector && O != d && (t = d.defaultView) && t.top !== t && t.addEventListener("unload", K), h.getById = ie(function(e) {
                return u.appendChild(e).id = T.expando, !d.getElementsByName || !d.getElementsByName(T.expando).length
            }), h.disconnectedMatch = ie(function(e) {
                return m.call(e, "*")
            }), h.scope = ie(function() {
                return d.querySelectorAll(":scope")
            }), h.cssHas = ie(function() {
                try {
                    return d.querySelector(":has(*,:jqfake)"), !1
                } catch (e) {
                    return !0
                }
            }), h.getById ? (n.filter.ID = function(e) {
                var t = e.replace(G, Q);
                return function(e) {
                    return e.getAttribute("id") === t
                }
            }, n.find.ID = function(e, t) {
                if (void 0 !== t.getElementById && p) {
                    var i = t.getElementById(e);
                    return i ? [i] : []
                }
            }) : (n.filter.ID = function(e) {
                var t = e.replace(G, Q);
                return function(e) {
                    var i = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                    return i && i.value === t
                }
            }, n.find.ID = function(e, t) {
                if (void 0 !== t.getElementById && p) {
                    var i, n, o, s = t.getElementById(e);
                    if (s) {
                        if ((i = s.getAttributeNode("id")) && i.value === e) return [s];
                        for (o = t.getElementsByName(e), n = 0; s = o[n++];)
                            if ((i = s.getAttributeNode("id")) && i.value === e) return [s]
                    }
                    return []
                }
            }), n.find.TAG = function(e, t) {
                return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : t.querySelectorAll(e)
            }, n.find.CLASS = function(e, t) {
                if (void 0 !== t.getElementsByClassName && p) return t.getElementsByClassName(e)
            }, f = [], ie(function(e) {
                var t;
                u.appendChild(e).innerHTML = "<a id='" + v + "' href='' disabled='disabled'></a><select id='" + v + "-\r\\' disabled='disabled'><option selected=''></option></select>", e.querySelectorAll("[selected]").length || f.push("\\[" + A + "*(?:value|" + q + ")"), e.querySelectorAll("[id~=" + v + "-]").length || f.push("~="), e.querySelectorAll("a#" + v + "+*").length || f.push(".#.+[+~]"), e.querySelectorAll(":checked").length || f.push(":checked"), (t = d.createElement("input")).setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), u.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && f.push(":enabled", ":disabled"), (t = d.createElement("input")).setAttribute("name", ""), e.appendChild(t), e.querySelectorAll("[name='']").length || f.push("\\[" + A + "*name" + A + "*=" + A + "*(?:''|\"\")")
            }), h.cssHas || f.push(":has"), f = f.length && RegExp(f.join("|")), D = function(e, t) {
                if (e === t) return l = !0, 0;
                var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return i || (1 & (i = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !h.sortDetached && t.compareDocumentPosition(e) === i ? e === d || e.ownerDocument == O && Z.contains(O, e) ? -1 : t === d || t.ownerDocument == O && Z.contains(O, t) ? 1 : r ? a.call(r, e) - a.call(r, t) : 0 : 4 & i ? -1 : 1)
            }), d
        }
        for (t in Z.matches = function(e, t) {
                return Z(e, null, null, t)
            }, Z.matchesSelector = function(e, t) {
                if (le(e), p && !P[t + " "] && (!f || !f.test(t))) try {
                    var i = m.call(e, t);
                    if (i || h.disconnectedMatch || e.document && 11 !== e.document.nodeType) return i
                } catch (e) {
                    P(t, !0)
                }
                return 0 < Z(t, d, null, [e]).length
            }, Z.contains = function(e, t) {
                return (e.ownerDocument || e) != d && le(e), T.contains(e, t)
            }, Z.attr = function(e, t) {
                (e.ownerDocument || e) != d && le(e);
                var i = n.attrHandle[t.toLowerCase()],
                    o = i && c.call(n.attrHandle, t.toLowerCase()) ? i(e, t, !p) : void 0;
                return void 0 !== o ? o : e.getAttribute(t)
            }, Z.error = function(e) {
                throw Error("Syntax error, unrecognized expression: " + e)
            }, T.uniqueSort = function(e) {
                var t, i = [],
                    n = 0,
                    s = 0;
                if (l = !h.sortStable, r = !h.sortStable && o.call(e, 0), $.call(e, D), l) {
                    for (; t = e[s++];) t === e[s] && (n = i.push(s));
                    for (; n--;) E.call(e, i[n], 1)
                }
                return r = null, e
            }, T.fn.uniqueSort = function() {
                return this.pushStack(T.uniqueSort(o.apply(this)))
            }, (n = T.expr = {
                cacheLength: 50,
                createPseudo: te,
                match: z,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {
                        dir: "parentNode",
                        first: !0
                    },
                    " ": {
                        dir: "parentNode"
                    },
                    "+": {
                        dir: "previousSibling",
                        first: !0
                    },
                    "~": {
                        dir: "previousSibling"
                    }
                },
                preFilter: {
                    ATTR: function(e) {
                        return e[1] = e[1].replace(G, Q), e[3] = (e[3] || e[4] || e[5] || "").replace(G, Q), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
                    },
                    CHILD: function(e) {
                        return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || Z.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && Z.error(e[0]), e
                    },
                    PSEUDO: function(e) {
                        var t, i = !e[6] && e[2];
                        return z.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : i && W.test(i) && (t = ce(i, !0)) && (t = i.indexOf(")", i.length - t) - i.length) && (e[0] = e[0].slice(0, t), e[2] = i.slice(0, t)), e.slice(0, 3))
                    }
                },
                filter: {
                    TAG: function(e) {
                        var t = e.replace(G, Q).toLowerCase();
                        return "*" === e ? function() {
                            return !0
                        } : function(e) {
                            return k(e, t)
                        }
                    },
                    CLASS: function(e) {
                        var t = w[e + " "];
                        return t || (t = RegExp("(^|" + A + ")" + e + "(" + A + "|$)"), w(e, function(e) {
                            return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                        }))
                    },
                    ATTR: function(e, t, i) {
                        return function(n) {
                            var o = Z.attr(n, e);
                            return null == o ? "!=" === t : !t || (o += "", "=" === t ? o === i : "!=" === t ? o !== i : "^=" === t ? i && 0 === o.indexOf(i) : "*=" === t ? i && -1 < o.indexOf(i) : "$=" === t ? i && o.slice(-i.length) === i : "~=" === t ? -1 < (" " + o.replace(j, " ") + " ").indexOf(i) : "|=" === t && (o === i || o.slice(0, i.length + 1) === i + "-"))
                        }
                    },
                    CHILD: function(e, t, i, n, o) {
                        var s = "nth" !== e.slice(0, 3),
                            r = "last" !== e.slice(-4),
                            a = "of-type" === t;
                        return 1 === n && 0 === o ? function(e) {
                            return !!e.parentNode
                        } : function(t, i, l) {
                            var d, c, u, p, h, f = s !== r ? "nextSibling" : "previousSibling",
                                m = t.parentNode,
                                y = a && t.nodeName.toLowerCase(),
                                b = !l && !a,
                                w = !1;
                            if (m) {
                                if (s) {
                                    for (; f;) {
                                        for (u = t; u = u[f];)
                                            if (a ? k(u, y) : 1 === u.nodeType) return !1;
                                        h = f = "only" === e && !h && "nextSibling"
                                    }
                                    return !0
                                }
                                if (h = [r ? m.firstChild : m.lastChild], r && b) {
                                    for (w = (p = (d = (c = m[v] || (m[v] = {}))[e] || [])[0] === g && d[1]) && d[2], u = p && m.childNodes[p]; u = ++p && u && u[f] || (w = p = 0) || h.pop();)
                                        if (1 === u.nodeType && ++w && u === t) {
                                            c[e] = [g, p, w];
                                            break
                                        }
                                } else if (b && (w = p = (d = (c = t[v] || (t[v] = {}))[e] || [])[0] === g && d[1]), !1 === w)
                                    for (;
                                        (u = ++p && u && u[f] || (w = p = 0) || h.pop()) && (!(a ? k(u, y) : 1 === u.nodeType) || !++w || (b && ((c = u[v] || (u[v] = {}))[e] = [g, w]), u !== t)););
                                return (w -= o) === n || w % n == 0 && 0 <= w / n
                            }
                        }
                    },
                    PSEUDO: function(e, t) {
                        var i, o = n.pseudos[e] || n.setFilters[e.toLowerCase()] || Z.error("unsupported pseudo: " + e);
                        return o[v] ? o(t) : 1 < o.length ? (i = [e, e, "", t], n.setFilters.hasOwnProperty(e.toLowerCase()) ? te(function(e, i) {
                            for (var n, s = o(e, t), r = s.length; r--;) e[n = a.call(e, s[r])] = !(i[n] = s[r])
                        }) : function(e) {
                            return o(e, 0, i)
                        }) : o
                    }
                },
                pseudos: {
                    not: te(function(e) {
                        var t = [],
                            i = [],
                            n = ve(e.replace(L, "$1"));
                        return n[v] ? te(function(e, t, i, o) {
                            for (var s, r = n(e, null, o, []), a = e.length; a--;)(s = r[a]) && (e[a] = !(t[a] = s))
                        }) : function(e, o, s) {
                            return t[0] = e, n(t, null, s, i), t[0] = null, !i.pop()
                        }
                    }),
                    has: te(function(e) {
                        return function(t) {
                            return 0 < Z(e, t).length
                        }
                    }),
                    contains: te(function(e) {
                        return e = e.replace(G, Q),
                            function(t) {
                                return -1 < (t.textContent || T.text(t)).indexOf(e)
                            }
                    }),
                    lang: te(function(e) {
                        return F.test(e || "") || Z.error("unsupported lang: " + e), e = e.replace(G, Q).toLowerCase(),
                            function(t) {
                                var i;
                                do {
                                    if (i = p ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (i = i.toLowerCase()) === e || 0 === i.indexOf(e + "-")
                                } while ((t = t.parentNode) && 1 === t.nodeType);
                                return !1
                            }
                    }),
                    target: function(t) {
                        var i = e.location && e.location.hash;
                        return i && i.slice(1) === t.id
                    },
                    root: function(e) {
                        return e === u
                    },
                    focus: function(e) {
                        return e === function() {
                            try {
                                return d.activeElement
                            } catch (e) {}
                        }() && d.hasFocus() && !!(e.type || e.href || ~e.tabIndex)
                    },
                    enabled: se(!1),
                    disabled: se(!0),
                    checked: function(e) {
                        return k(e, "input") && !!e.checked || k(e, "option") && !!e.selected
                    },
                    selected: function(e) {
                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
                    },
                    empty: function(e) {
                        for (e = e.firstChild; e; e = e.nextSibling)
                            if (e.nodeType < 6) return !1;
                        return !0
                    },
                    parent: function(e) {
                        return !n.pseudos.empty(e)
                    },
                    header: function(e) {
                        return V.test(e.nodeName)
                    },
                    input: function(e) {
                        return U.test(e.nodeName)
                    },
                    button: function(e) {
                        return k(e, "input") && "button" === e.type || k(e, "button")
                    },
                    text: function(e) {
                        var t;
                        return k(e, "input") && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                    },
                    first: re(function() {
                        return [0]
                    }),
                    last: re(function(e, t) {
                        return [t - 1]
                    }),
                    eq: re(function(e, t, i) {
                        return [i < 0 ? i + t : i]
                    }),
                    even: re(function(e, t) {
                        for (var i = 0; i < t; i += 2) e.push(i);
                        return e
                    }),
                    odd: re(function(e, t) {
                        for (var i = 1; i < t; i += 2) e.push(i);
                        return e
                    }),
                    lt: re(function(e, t, i) {
                        var n;
                        for (n = i < 0 ? i + t : t < i ? t : i; 0 <= --n;) e.push(n);
                        return e
                    }),
                    gt: re(function(e, t, i) {
                        for (var n = i < 0 ? i + t : i; ++n < t;) e.push(n);
                        return e
                    })
                }
            }).pseudos.nth = n.pseudos.eq, {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            }) n.pseudos[t] = ne(t);
        for (t in {
                submit: !0,
                reset: !0
            }) n.pseudos[t] = oe(t);

        function de() {}

        function ce(e, t) {
            var i, o, s, r, a, l, d, c = S[e + " "];
            if (c) return t ? 0 : c.slice(0);
            for (a = e, l = [], d = n.preFilter; a;) {
                for (r in (!i || (o = N.exec(a))) && (o && (a = a.slice(o[0].length) || a), l.push(s = [])), i = !1, (o = R.exec(a)) && (i = o.shift(), s.push({
                        value: i,
                        type: o[0].replace(L, " ")
                    }), a = a.slice(i.length)), n.filter)(o = z[r].exec(a)) && (!d[r] || (o = d[r](o))) && (i = o.shift(), s.push({
                    value: i,
                    type: r,
                    matches: o
                }), a = a.slice(i.length));
                if (!i) break
            }
            return t ? a.length : a ? Z.error(e) : S(e, l).slice(0)
        }

        function ue(e) {
            for (var t = 0, i = e.length, n = ""; t < i; t++) n += e[t].value;
            return n
        }

        function pe(e, t, i) {
            var n = t.dir,
                o = t.next,
                s = o || n,
                r = i && "parentNode" === s,
                a = b++;
            return t.first ? function(t, i, o) {
                for (; t = t[n];)
                    if (1 === t.nodeType || r) return e(t, i, o);
                return !1
            } : function(t, i, l) {
                var d, c, u = [g, a];
                if (l) {
                    for (; t = t[n];)
                        if ((1 === t.nodeType || r) && e(t, i, l)) return !0
                } else
                    for (; t = t[n];)
                        if (1 === t.nodeType || r)
                            if (c = t[v] || (t[v] = {}), o && k(t, o)) t = t[n] || t;
                            else {
                                if ((d = c[s]) && d[0] === g && d[1] === a) return u[2] = d[2];
                                if ((c[s] = u)[2] = e(t, i, l)) return !0
                            } return !1
            }
        }

        function he(e) {
            return 1 < e.length ? function(t, i, n) {
                for (var o = e.length; o--;)
                    if (!e[o](t, i, n)) return !1;
                return !0
            } : e[0]
        }

        function fe(e, t, i, n, o) {
            for (var s, r = [], a = 0, l = e.length, d = null != t; a < l; a++)(s = e[a]) && (i && !i(s, n, o) || (r.push(s), d && t.push(a)));
            return r
        }

        function me(e, t, i, n, o, s) {
            return n && !n[v] && (n = me(n)), o && !o[v] && (o = me(o, s)), te(function(s, r, l, d) {
                var c, u, p, h, f = [],
                    m = [],
                    v = r.length,
                    g = s || function(e, t, i) {
                        for (var n = 0, o = t.length; n < o; n++) Z(e, t[n], i);
                        return i
                    }(t || "*", l.nodeType ? [l] : l, []),
                    b = !e || !s && t ? g : fe(g, f, e, l, d);
                if (i ? i(b, h = o || (s ? e : v || n) ? [] : r, l, d) : h = b, n)
                    for (c = fe(h, m), n(c, [], l, d), u = c.length; u--;)(p = c[u]) && (h[m[u]] = !(b[m[u]] = p));
                if (s) {
                    if (o || e) {
                        if (o) {
                            for (c = [], u = h.length; u--;)(p = h[u]) && c.push(b[u] = p);
                            o(null, h = [], c, d)
                        }
                        for (u = h.length; u--;)(p = h[u]) && -1 < (c = o ? a.call(s, p) : f[u]) && (s[c] = !(r[c] = p))
                    }
                } else h = fe(h === r ? h.splice(v, h.length) : h), o ? o(null, r, h, d) : y.apply(r, h)
            })
        }

        function ye(e) {
            for (var t, i, o, r = e.length, l = n.relative[e[0].type], d = l || n.relative[" "], c = l ? 1 : 0, u = pe(function(e) {
                    return e === t
                }, d, !0), p = pe(function(e) {
                    return -1 < a.call(t, e)
                }, d, !0), h = [function(e, i, n) {
                    var o = !l && (n || i != s) || ((t = i).nodeType ? u(e, i, n) : p(e, i, n));
                    return t = null, o
                }]; c < r; c++)
                if (i = n.relative[e[c].type]) h = [pe(he(h), i)];
                else {
                    if ((i = n.filter[e[c].type].apply(null, e[c].matches))[v]) {
                        for (o = ++c; o < r && !n.relative[e[o].type]; o++);
                        return me(1 < c && he(h), 1 < c && ue(e.slice(0, c - 1).concat({
                            value: " " === e[c - 2].type ? "*" : ""
                        })).replace(L, "$1"), i, c < o && ye(e.slice(c, o)), o < r && ye(e = e.slice(o)), o < r && ue(e))
                    }
                    h.push(i)
                } return he(h)
        }

        function ve(e, t) {
            var i, o, r, a, l, c, u = [],
                h = [],
                f = x[e + " "];
            if (!f) {
                for (t || (t = ce(e)), i = t.length; i--;)(f = ye(t[i]))[v] ? u.push(f) : h.push(f);
                (f = x(e, (o = h, a = 0 < (r = u).length, l = 0 < o.length, c = function(e, t, i, c, u) {
                    var h, f, m, v = 0,
                        b = "0",
                        w = e && [],
                        S = [],
                        x = s,
                        k = e || l && n.find.TAG("*", u),
                        $ = g += null == x ? 1 : Math.random() || .1,
                        E = k.length;
                    for (u && (s = t == d || t || u); b !== E && null != (h = k[b]); b++) {
                        if (l && h) {
                            for (f = 0, t || h.ownerDocument == d || (le(h), i = !p); m = o[f++];)
                                if (m(h, t || d, i)) {
                                    y.call(c, h);
                                    break
                                } u && (g = $)
                        }
                        a && ((h = !m && h) && v--, e && w.push(h))
                    }
                    if (v += b, a && b !== v) {
                        for (f = 0; m = r[f++];) m(w, S, t, i);
                        if (e) {
                            if (0 < v)
                                for (; b--;) w[b] || S[b] || (S[b] = C.call(c));
                            S = fe(S)
                        }
                        y.apply(c, S), u && !e && 0 < S.length && 1 < v + r.length && T.uniqueSort(c)
                    }
                    return u && (g = $, s = x), w
                }, a ? te(c) : c))).selector = e
            }
            return f
        }

        function ge(e, t, i, o) {
            var s, r, a, l, d, c = "function" == typeof e && e,
                u = !o && ce(e = c.selector || e);
            if (i = i || [], 1 === u.length) {
                if (2 < (r = u[0] = u[0].slice(0)).length && "ID" === (a = r[0]).type && 9 === t.nodeType && p && n.relative[r[1].type]) {
                    if (!(t = (n.find.ID(a.matches[0].replace(G, Q), t) || [])[0])) return i;
                    c && (t = t.parentNode), e = e.slice(r.shift().value.length)
                }
                for (s = z.needsContext.test(e) ? 0 : r.length; s-- && (a = r[s], !n.relative[l = a.type]);)
                    if ((d = n.find[l]) && (o = d(a.matches[0].replace(G, Q), Y.test(r[0].type) && ae(t.parentNode) || t))) {
                        if (r.splice(s, 1), !(e = o.length && ue(r))) return y.apply(i, o), i;
                        break
                    }
            }
            return (c || ve(e, u))(o, t, !p, i, !t || Y.test(e) && ae(t.parentNode) || t), i
        }
        de.prototype = n.filters = n.pseudos, n.setFilters = new de, h.sortStable = v.split("").sort(D).join("") === v, le(), h.sortDetached = ie(function(e) {
            return 1 & e.compareDocumentPosition(d.createElement("fieldset"))
        }), T.find = Z, T.expr[":"] = T.expr.pseudos, T.unique = T.uniqueSort, Z.compile = ve, Z.select = ge, Z.setDocument = le, Z.tokenize = ce, Z.escape = T.escapeSelector, Z.getText = T.text, Z.isXML = T.isXMLDoc, Z.selectors = T.expr, Z.support = T.support, Z.uniqueSort = T.uniqueSort
    }();
    var q = function(e, t, i) {
            for (var n = [], o = void 0 !== i;
                (e = e[t]) && 9 !== e.nodeType;)
                if (1 === e.nodeType) {
                    if (o && T(e).is(i)) break;
                    n.push(e)
                } return n
        },
        M = function(e, t) {
            for (var i = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && i.push(e);
            return i
        },
        H = T.expr.match.needsContext,
        B = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

    function j(e, t, i) {
        return f(t) ? T.grep(e, function(e, n) {
            return !!t.call(e, n, e) !== i
        }) : t.nodeType ? T.grep(e, function(e) {
            return e === t !== i
        }) : "string" != typeof t ? T.grep(e, function(e) {
            return -1 < a.call(t, e) !== i
        }) : T.filter(t, e, i)
    }
    T.filter = function(e, t, i) {
        var n = t[0];
        return i && (e = ":not(" + e + ")"), 1 === t.length && 1 === n.nodeType ? T.find.matchesSelector(n, e) ? [n] : [] : T.find.matches(e, T.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }, T.fn.extend({
        find: function(e) {
            var t, i, n = this.length,
                o = this;
            if ("string" != typeof e) return this.pushStack(T(e).filter(function() {
                for (t = 0; t < n; t++)
                    if (T.contains(o[t], this)) return !0
            }));
            for (i = this.pushStack([]), t = 0; t < n; t++) T.find(e, o[t], i);
            return 1 < n ? T.uniqueSort(i) : i
        },
        filter: function(e) {
            return this.pushStack(j(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(j(this, e || [], !0))
        },
        is: function(e) {
            return !!j(this, "string" == typeof e && H.test(e) ? T(e) : e || [], !1).length
        }
    });
    var N, R = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (T.fn.init = function(e, t, i) {
        var n, o;
        if (!e) return this;
        if (i = i || N, "string" == typeof e) {
            if (!(n = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : R.exec(e)) || !n[1] && t) return !t || t.jquery ? (t || i).find(e) : this.constructor(t).find(e);
            if (n[1]) {
                if (t = t instanceof T ? t[0] : t, T.merge(this, T.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : y, !0)), B.test(n[1]) && T.isPlainObject(t))
                    for (n in t) f(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
                return this
            }
            return (o = y.getElementById(n[2])) && (this[0] = o, this.length = 1), this
        }
        return e.nodeType ? (this[0] = e, this.length = 1, this) : f(e) ? void 0 !== i.ready ? i.ready(e) : e(T) : T.makeArray(e, this)
    }).prototype = T.fn, N = T(y);
    var _ = /^(?:parents|prev(?:Until|All))/,
        W = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };

    function F(e, t) {
        for (;
            (e = e[t]) && 1 !== e.nodeType;);
        return e
    }
    T.fn.extend({
        has: function(e) {
            var t = T(e, this),
                i = t.length;
            return this.filter(function() {
                for (var e = 0; e < i; e++)
                    if (T.contains(this, t[e])) return !0
            })
        },
        closest: function(e, t) {
            var i, n = 0,
                o = this.length,
                s = [],
                r = "string" != typeof e && T(e);
            if (!H.test(e))
                for (; n < o; n++)
                    for (i = this[n]; i && i !== t; i = i.parentNode)
                        if (i.nodeType < 11 && (r ? -1 < r.index(i) : 1 === i.nodeType && T.find.matchesSelector(i, e))) {
                            s.push(i);
                            break
                        } return this.pushStack(1 < s.length ? T.uniqueSort(s) : s)
        },
        index: function(e) {
            return e ? "string" == typeof e ? a.call(T(e), this[0]) : a.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(T.uniqueSort(T.merge(this.get(), T(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }), T.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return q(e, "parentNode")
        },
        parentsUntil: function(e, t, i) {
            return q(e, "parentNode", i)
        },
        next: function(e) {
            return F(e, "nextSibling")
        },
        prev: function(e) {
            return F(e, "previousSibling")
        },
        nextAll: function(e) {
            return q(e, "nextSibling")
        },
        prevAll: function(e) {
            return q(e, "previousSibling")
        },
        nextUntil: function(e, t, i) {
            return q(e, "nextSibling", i)
        },
        prevUntil: function(e, t, i) {
            return q(e, "previousSibling", i)
        },
        siblings: function(e) {
            return M((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return M(e.firstChild)
        },
        contents: function(e) {
            return null != e.contentDocument && n(e.contentDocument) ? e.contentDocument : (k(e, "template") && (e = e.content || e), T.merge([], e.childNodes))
        }
    }, function(e, t) {
        T.fn[e] = function(i, n) {
            var o = T.map(this, t, i);
            return "Until" !== e.slice(-5) && (n = i), n && "string" == typeof n && (o = T.filter(n, o)), 1 < this.length && (W[e] || T.uniqueSort(o), _.test(e) && o.reverse()), this.pushStack(o)
        }
    });
    var z = /[^\x20\t\r\n\f]+/g;

    function U(e) {
        return e
    }

    function V(e) {
        throw e
    }

    function X(e, t, i, n) {
        var o;
        try {
            e && f(o = e.promise) ? o.call(e).done(t).fail(i) : e && f(o = e.then) ? o.call(e, t, i) : t.apply(void 0, [e].slice(n))
        } catch (e) {
            i.apply(void 0, [e])
        }
    }
    T.Callbacks = function(e) {
        e = "string" == typeof e ? (t = e, i = {}, T.each(t.match(z) || [], function(e, t) {
            i[t] = !0
        }), i) : T.extend({}, e);
        var t, i, n, o, s, r, a = [],
            l = [],
            d = -1,
            c = function() {
                for (r = r || e.once, s = n = !0; l.length; d = -1)
                    for (o = l.shift(); ++d < a.length;) !1 === a[d].apply(o[0], o[1]) && e.stopOnFalse && (d = a.length, o = !1);
                e.memory || (o = !1), n = !1, r && (a = o ? [] : "")
            },
            u = {
                add: function() {
                    return a && (o && !n && (d = a.length - 1, l.push(o)), function t(i) {
                        T.each(i, function(i, n) {
                            f(n) ? e.unique && u.has(n) || a.push(n) : n && n.length && "string" !== b(n) && t(n)
                        })
                    }(arguments), o && !n && c()), this
                },
                remove: function() {
                    return T.each(arguments, function(e, t) {
                        for (var i; - 1 < (i = T.inArray(t, a, i));) a.splice(i, 1), i <= d && d--
                    }), this
                },
                has: function(e) {
                    return e ? -1 < T.inArray(e, a) : 0 < a.length
                },
                empty: function() {
                    return a && (a = []), this
                },
                disable: function() {
                    return r = l = [], a = o = "", this
                },
                disabled: function() {
                    return !a
                },
                lock: function() {
                    return r = l = [], o || n || (a = o = ""), this
                },
                locked: function() {
                    return !!r
                },
                fireWith: function(e, t) {
                    return r || (t = [e, (t = t || []).slice ? t.slice() : t], l.push(t), n || c()), this
                },
                fire: function() {
                    return u.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!s
                }
            };
        return u
    }, T.extend({
        Deferred: function(t) {
            var i = [
                    ["notify", "progress", T.Callbacks("memory"), T.Callbacks("memory"), 2],
                    ["resolve", "done", T.Callbacks("once memory"), T.Callbacks("once memory"), 0, "resolved"],
                    ["reject", "fail", T.Callbacks("once memory"), T.Callbacks("once memory"), 1, "rejected"]
                ],
                n = "pending",
                o = {
                    state: function() {
                        return n
                    },
                    always: function() {
                        return s.done(arguments).fail(arguments), this
                    },
                    catch: function(e) {
                        return o.then(null, e)
                    },
                    pipe: function() {
                        var e = arguments;
                        return T.Deferred(function(t) {
                            T.each(i, function(i, n) {
                                var o = f(e[n[4]]) && e[n[4]];
                                s[n[1]](function() {
                                    var e = o && o.apply(this, arguments);
                                    e && f(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[n[0] + "With"](this, o ? [e] : arguments)
                                })
                            }), e = null
                        }).promise()
                    },
                    then: function(t, n, o) {
                        var s = 0;

                        function r(t, i, n, o) {
                            return function() {
                                var a = this,
                                    l = arguments,
                                    d = function() {
                                        var e, d;
                                        if (!(t < s)) {
                                            if ((e = n.apply(a, l)) === i.promise()) throw TypeError("Thenable self-resolution");
                                            f(d = e && ("object" == typeof e || "function" == typeof e) && e.then) ? o ? d.call(e, r(s, i, U, o), r(s, i, V, o)) : (s++, d.call(e, r(s, i, U, o), r(s, i, V, o), r(s, i, U, i.notifyWith))) : (n !== U && (a = void 0, l = [e]), (o || i.resolveWith)(a, l))
                                        }
                                    },
                                    c = o ? d : function() {
                                        try {
                                            d()
                                        } catch (e) {
                                            T.Deferred.exceptionHook && T.Deferred.exceptionHook(e, c.error), s <= t + 1 && (n !== V && (a = void 0, l = [e]), i.rejectWith(a, l))
                                        }
                                    };
                                t ? c() : (T.Deferred.getErrorHook ? c.error = T.Deferred.getErrorHook() : T.Deferred.getStackHook && (c.error = T.Deferred.getStackHook()), e.setTimeout(c))
                            }
                        }
                        return T.Deferred(function(e) {
                            i[0][3].add(r(0, e, f(o) ? o : U, e.notifyWith)), i[1][3].add(r(0, e, f(t) ? t : U)), i[2][3].add(r(0, e, f(n) ? n : V))
                        }).promise()
                    },
                    promise: function(e) {
                        return null != e ? T.extend(e, o) : o
                    }
                },
                s = {};
            return T.each(i, function(e, t) {
                var r = t[2],
                    a = t[5];
                o[t[1]] = r.add, a && r.add(function() {
                    n = a
                }, i[3 - e][2].disable, i[3 - e][3].disable, i[0][2].lock, i[0][3].lock), r.add(t[3].fire), s[t[0]] = function() {
                    return s[t[0] + "With"](this === s ? void 0 : this, arguments), this
                }, s[t[0] + "With"] = r.fireWith
            }), o.promise(s), t && t.call(s, s), s
        },
        when: function(e) {
            var t = arguments.length,
                i = t,
                n = Array(i),
                s = o.call(arguments),
                r = T.Deferred(),
                a = function(e) {
                    return function(i) {
                        n[e] = this, s[e] = 1 < arguments.length ? o.call(arguments) : i, --t || r.resolveWith(n, s)
                    }
                };
            if (t <= 1 && (X(e, r.done(a(i)).resolve, r.reject, !t), "pending" === r.state() || f(s[i] && s[i].then))) return r.then();
            for (; i--;) X(s[i], a(i), r.reject);
            return r.promise()
        }
    });
    var Y = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    T.Deferred.exceptionHook = function(t, i) {
        e.console && e.console.warn && t && Y.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, i)
    }, T.readyException = function(t) {
        e.setTimeout(function() {
            throw t
        })
    };
    var G = T.Deferred();

    function Q() {
        y.removeEventListener("DOMContentLoaded", Q), e.removeEventListener("load", Q), T.ready()
    }
    T.fn.ready = function(e) {
        return G.then(e).catch(function(e) {
            T.readyException(e)
        }), this
    }, T.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(e) {
            (!0 === e ? --T.readyWait : T.isReady) || (T.isReady = !0) !== e && 0 < --T.readyWait || G.resolveWith(y, [T])
        }
    }), T.ready.then = G.then, "complete" === y.readyState || "loading" !== y.readyState && !y.documentElement.doScroll ? e.setTimeout(T.ready) : (y.addEventListener("DOMContentLoaded", Q), e.addEventListener("load", Q));
    var K = function(e, t, i, n, o, s, r) {
            var a = 0,
                l = e.length,
                d = null == i;
            if ("object" === b(i))
                for (a in o = !0, i) K(e, t, a, i[a], !0, s, r);
            else if (void 0 !== n && (o = !0, f(n) || (r = !0), d && (r ? (t.call(e, n), t = null) : (d = t, t = function(e, t, i) {
                    return d.call(T(e), i)
                })), t))
                for (; a < l; a++) t(e[a], i, r ? n : n.call(e[a], a, t(e[a], i)));
            return o ? e : d ? t.call(e) : l ? t(e[0], i) : s
        },
        J = /^-ms-/,
        Z = /-([a-z])/g;

    function ee(e, t) {
        return t.toUpperCase()
    }

    function te(e) {
        return e.replace(J, "ms-").replace(Z, ee)
    }
    var ie = function(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
    };

    function ne() {
        this.expando = T.expando + ne.uid++
    }
    ne.uid = 1, ne.prototype = {
        cache: function(e) {
            var t = e[this.expando];
            return t || (t = {}, ie(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
            }))), t
        },
        set: function(e, t, i) {
            var n, o = this.cache(e);
            if ("string" == typeof t) o[te(t)] = i;
            else
                for (n in t) o[te(n)] = t[n];
            return o
        },
        get: function(e, t) {
            return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][te(t)]
        },
        access: function(e, t, i) {
            return void 0 === t || t && "string" == typeof t && void 0 === i ? this.get(e, t) : (this.set(e, t, i), void 0 !== i ? i : t)
        },
        remove: function(e, t) {
            var i, n = e[this.expando];
            if (void 0 !== n) {
                if (void 0 !== t)
                    for ((i = (t = Array.isArray(t) ? t.map(te) : (t = te(t)) in n ? [t] : t.match(z) || []).length); i--;) delete n[t[i]];
                (void 0 === t || T.isEmptyObject(n)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
            }
        },
        hasData: function(e) {
            var t = e[this.expando];
            return void 0 !== t && !T.isEmptyObject(t)
        }
    };
    var oe = new ne,
        se = new ne,
        re = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        ae = /[A-Z]/g;

    function le(e, t, i) {
        var n, o;
        if (void 0 === i && 1 === e.nodeType)
            if (n = "data-" + t.replace(ae, "-$&").toLowerCase(), "string" == typeof(i = e.getAttribute(n))) {
                try {
                    i = "true" === (o = i) || "false" !== o && ("null" === o ? null : o === +o + "" ? +o : re.test(o) ? JSON.parse(o) : o)
                } catch (e) {}
                se.set(e, t, i)
            } else i = void 0;
        return i
    }
    T.extend({
        hasData: function(e) {
            return se.hasData(e) || oe.hasData(e)
        },
        data: function(e, t, i) {
            return se.access(e, t, i)
        },
        removeData: function(e, t) {
            se.remove(e, t)
        },
        _data: function(e, t, i) {
            return oe.access(e, t, i)
        },
        _removeData: function(e, t) {
            oe.remove(e, t)
        }
    }), T.fn.extend({
        data: function(e, t) {
            var i, n, o, s = this[0],
                r = s && s.attributes;
            if (void 0 === e) {
                if (this.length && (o = se.get(s), 1 === s.nodeType && !oe.get(s, "hasDataAttrs"))) {
                    for (i = r.length; i--;) r[i] && 0 === (n = r[i].name).indexOf("data-") && le(s, n = te(n.slice(5)), o[n]);
                    oe.set(s, "hasDataAttrs", !0)
                }
                return o
            }
            return "object" == typeof e ? this.each(function() {
                se.set(this, e)
            }) : K(this, function(t) {
                var i;
                if (s && void 0 === t) return void 0 !== (i = se.get(s, e)) || void 0 !== (i = le(s, e)) ? i : void 0;
                this.each(function() {
                    se.set(this, e, t)
                })
            }, null, t, 1 < arguments.length, null, !0)
        },
        removeData: function(e) {
            return this.each(function() {
                se.remove(this, e)
            })
        }
    }), T.extend({
        queue: function(e, t, i) {
            var n;
            if (e) return t = (t || "fx") + "queue", n = oe.get(e, t), i && (!n || Array.isArray(i) ? n = oe.access(e, t, T.makeArray(i)) : n.push(i)), n || []
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var i = T.queue(e, t),
                n = i.length,
                o = i.shift(),
                s = T._queueHooks(e, t);
            "inprogress" === o && (o = i.shift(), n--), o && ("fx" === t && i.unshift("inprogress"), delete s.stop, o.call(e, function() {
                T.dequeue(e, t)
            }, s)), !n && s && s.empty.fire()
        },
        _queueHooks: function(e, t) {
            var i = t + "queueHooks";
            return oe.get(e, i) || oe.access(e, i, {
                empty: T.Callbacks("once memory").add(function() {
                    oe.remove(e, [t + "queue", i])
                })
            })
        }
    }), T.fn.extend({
        queue: function(e, t) {
            var i = 2;
            return "string" != typeof e && (t = e, e = "fx", i--), arguments.length < i ? T.queue(this[0], e) : void 0 === t ? this : this.each(function() {
                var i = T.queue(this, e, t);
                T._queueHooks(this, e), "fx" === e && "inprogress" !== i[0] && T.dequeue(this, e)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                T.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            var i, n = 1,
                o = T.Deferred(),
                s = this,
                r = this.length,
                a = function() {
                    --n || o.resolveWith(s, [s])
                };
            for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; r--;)(i = oe.get(s[r], e + "queueHooks")) && i.empty && (n++, i.empty.add(a));
            return a(), o.promise(t)
        }
    });
    var de = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        ce = RegExp("^(?:([+-])=|)(" + de + ")([a-z%]*)$", "i"),
        ue = ["Top", "Right", "Bottom", "Left"],
        pe = y.documentElement,
        he = function(e) {
            return T.contains(e.ownerDocument, e)
        },
        fe = {
            composed: !0
        };
    pe.getRootNode && (he = function(e) {
        return T.contains(e.ownerDocument, e) || e.getRootNode(fe) === e.ownerDocument
    });
    var me = function(e, t) {
        return "none" === (e = t || e).style.display || "" === e.style.display && he(e) && "none" === T.css(e, "display")
    };

    function ye(e, t, i, n) {
        var o, s, r = 20,
            a = n ? function() {
                return n.cur()
            } : function() {
                return T.css(e, t, "")
            },
            l = a(),
            d = i && i[3] || (T.cssNumber[t] ? "" : "px"),
            c = e.nodeType && (T.cssNumber[t] || "px" !== d && +l) && ce.exec(T.css(e, t));
        if (c && c[3] !== d) {
            for (l /= 2, d = d || c[3], c = +l || 1; r--;) T.style(e, t, c + d), (1 - s) * (1 - (s = a() / l || .5)) <= 0 && (r = 0), c /= s;
            c *= 2, T.style(e, t, c + d), i = i || []
        }
        return i && (c = +c || +l || 0, o = i[1] ? c + (i[1] + 1) * i[2] : +i[2], n && (n.unit = d, n.start = c, n.end = o)), o
    }
    var ve = {};

    function ge(e, t) {
        for (var i, n, o, s, r, a, l, d = [], c = 0, u = e.length; c < u; c++)(n = e[c]).style && (i = n.style.display, t ? ("none" === i && (d[c] = oe.get(n, "display") || null, d[c] || (n.style.display = "")), "" === n.style.display && me(n) && (d[c] = (l = r = s = void 0, r = (o = n).ownerDocument, (l = ve[a = o.nodeName]) || (s = r.body.appendChild(r.createElement(a)), l = T.css(s, "display"), s.parentNode.removeChild(s), "none" === l && (l = "block"), ve[a] = l)))) : "none" !== i && (d[c] = "none", oe.set(n, "display", i)));
        for (c = 0; c < u; c++) null != d[c] && (e[c].style.display = d[c]);
        return e
    }
    T.fn.extend({
        show: function() {
            return ge(this, !0)
        },
        hide: function() {
            return ge(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                me(this) ? T(this).show() : T(this).hide()
            })
        }
    });
    var be, we, Se = /^(?:checkbox|radio)$/i,
        Te = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        xe = /^$|^module$|\/(?:java|ecma)script/i;
    be = y.createDocumentFragment().appendChild(y.createElement("div")), (we = y.createElement("input")).setAttribute("type", "radio"), we.setAttribute("checked", "checked"), we.setAttribute("name", "t"), be.appendChild(we), h.checkClone = be.cloneNode(!0).cloneNode(!0).lastChild.checked, be.innerHTML = "<textarea>x</textarea>", h.noCloneChecked = !!be.cloneNode(!0).lastChild.defaultValue, be.innerHTML = "<option></option>", h.option = !!be.lastChild;
    var ke = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };

    function Ce(e, t) {
        var i;
        return i = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && k(e, t) ? T.merge([e], i) : i
    }

    function $e(e, t) {
        for (var i = 0, n = e.length; i < n; i++) oe.set(e[i], "globalEval", !t || oe.get(t[i], "globalEval"))
    }
    ke.tbody = ke.tfoot = ke.colgroup = ke.caption = ke.thead, ke.th = ke.td, h.option || (ke.optgroup = ke.option = [1, "<select multiple='multiple'>", "</select>"]);
    var Ee = /<|&#?\w+;/;

    function Ae(e, t, i, n, o) {
        for (var s, r, a, l, d, c = t.createDocumentFragment(), u = [], p = 0, h = e.length; p < h; p++)
            if ((s = e[p]) || 0 === s)
                if ("object" === b(s)) T.merge(u, s.nodeType ? [s] : s);
                else if (Ee.test(s)) {
            for (r = r || c.appendChild(t.createElement("div")), a = ke[(Te.exec(s) || ["", ""])[1].toLowerCase()] || ke._default, r.innerHTML = a[1] + T.htmlPrefilter(s) + a[2], d = a[0]; d--;) r = r.lastChild;
            T.merge(u, r.childNodes), (r = c.firstChild).textContent = ""
        } else u.push(t.createTextNode(s));
        for (c.textContent = "", p = 0; s = u[p++];)
            if (n && -1 < T.inArray(s, n)) o && o.push(s);
            else if (l = he(s), r = Ce(c.appendChild(s), "script"), l && $e(r), i)
            for (d = 0; s = r[d++];) xe.test(s.type || "") && i.push(s);
        return c
    }
    var Le = /^([^.]*)(?:\.(.+)|)/;

    function Pe() {
        return !0
    }

    function De() {
        return !1
    }

    function Oe(e, t, i, n, o, s) {
        var r, a;
        if ("object" == typeof t) {
            for (a in "string" != typeof i && (n = n || i, i = void 0), t) Oe(e, a, i, n, t[a], s);
            return e
        }
        if (null == n && null == o ? (o = i, n = i = void 0) : null == o && ("string" == typeof i ? (o = n, n = void 0) : (o = n, n = i, i = void 0)), !1 === o) o = De;
        else if (!o) return e;
        return 1 === s && (r = o, (o = function(e) {
            return T().off(e), r.apply(this, arguments)
        }).guid = r.guid || (r.guid = T.guid++)), e.each(function() {
            T.event.add(this, t, o, n, i)
        })
    }

    function Ie(e, t, i) {
        i ? (oe.set(e, t, !1), T.event.add(e, t, {
            namespace: !1,
            handler: function(e) {
                var i, n = oe.get(this, t);
                if (1 & e.isTrigger && this[t]) {
                    if (n)(T.event.special[t] || {}).delegateType && e.stopPropagation();
                    else if (n = o.call(arguments), oe.set(this, t, n), this[t](), i = oe.get(this, t), oe.set(this, t, !1), n !== i) return e.stopImmediatePropagation(), e.preventDefault(), i
                } else n && (oe.set(this, t, T.event.trigger(n[0], n.slice(1), this)), e.stopPropagation(), e.isImmediatePropagationStopped = Pe)
            }
        })) : void 0 === oe.get(e, t) && T.event.add(e, t, Pe)
    }
    T.event = {
        global: {},
        add: function(e, t, i, n, o) {
            var s, r, a, l, d, c, u, p, h, f, m, y = oe.get(e);
            if (ie(e))
                for (i.handler && (i = (s = i).handler, o = s.selector), o && T.find.matchesSelector(pe, o), i.guid || (i.guid = T.guid++), (l = y.events) || (l = y.events = Object.create(null)), (r = y.handle) || (r = y.handle = function(t) {
                        return T.event.triggered !== t.type ? T.event.dispatch.apply(e, arguments) : void 0
                    }), d = (t = (t || "").match(z) || [""]).length; d--;) h = m = (a = Le.exec(t[d]) || [])[1], f = (a[2] || "").split(".").sort(), h && (u = T.event.special[h] || {}, h = (o ? u.delegateType : u.bindType) || h, u = T.event.special[h] || {}, c = T.extend({
                    type: h,
                    origType: m,
                    data: n,
                    handler: i,
                    guid: i.guid,
                    selector: o,
                    needsContext: o && T.expr.match.needsContext.test(o),
                    namespace: f.join(".")
                }, s), (p = l[h]) || ((p = l[h] = []).delegateCount = 0, u.setup && !1 !== u.setup.call(e, n, f, r) || e.addEventListener && e.addEventListener(h, r)), u.add && (u.add.call(e, c), c.handler.guid || (c.handler.guid = i.guid)), o ? p.splice(p.delegateCount++, 0, c) : p.push(c), T.event.global[h] = !0)
        },
        remove: function(e, t, i, n, o) {
            var s, r, a, l, d, c, u, p, h, f, m, y = oe.hasData(e) && oe.get(e);
            if (y && (l = y.events)) {
                for (d = (t = (t || "").match(z) || [""]).length; d--;)
                    if (h = m = (a = Le.exec(t[d]) || [])[1], f = (a[2] || "").split(".").sort(), h) {
                        for (u = T.event.special[h] || {}, p = l[h = (n ? u.delegateType : u.bindType) || h] || [], a = a[2] && RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), r = s = p.length; s--;) c = p[s], !o && m !== c.origType || i && i.guid !== c.guid || a && !a.test(c.namespace) || n && n !== c.selector && ("**" !== n || !c.selector) || (p.splice(s, 1), c.selector && p.delegateCount--, u.remove && u.remove.call(e, c));
                        r && !p.length && (u.teardown && !1 !== u.teardown.call(e, f, y.handle) || T.removeEvent(e, h, y.handle), delete l[h])
                    } else
                        for (h in l) T.event.remove(e, h + t[d], i, n, !0);
                T.isEmptyObject(l) && oe.remove(e, "handle events")
            }
        },
        dispatch: function(e) {
            var t, i, n, o, s, r, a = Array(arguments.length),
                l = T.event.fix(e),
                d = (oe.get(this, "events") || Object.create(null))[l.type] || [],
                c = T.event.special[l.type] || {};
            for (a[0] = l, t = 1; t < arguments.length; t++) a[t] = arguments[t];
            if (l.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, l)) {
                for (r = T.event.handlers.call(this, l, d), t = 0;
                    (o = r[t++]) && !l.isPropagationStopped();)
                    for (l.currentTarget = o.elem, i = 0;
                        (s = o.handlers[i++]) && !l.isImmediatePropagationStopped();) l.rnamespace && !1 !== s.namespace && !l.rnamespace.test(s.namespace) || (l.handleObj = s, l.data = s.data, void 0 !== (n = ((T.event.special[s.origType] || {}).handle || s.handler).apply(o.elem, a)) && !1 === (l.result = n) && (l.preventDefault(), l.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, l), l.result
            }
        },
        handlers: function(e, t) {
            var i, n, o, s, r, a = [],
                l = t.delegateCount,
                d = e.target;
            if (l && d.nodeType && !("click" === e.type && 1 <= e.button))
                for (; d !== this; d = d.parentNode || this)
                    if (1 === d.nodeType && ("click" !== e.type || !0 !== d.disabled)) {
                        for (s = [], r = {}, i = 0; i < l; i++) void 0 === r[o = (n = t[i]).selector + " "] && (r[o] = n.needsContext ? -1 < T(o, this).index(d) : T.find(o, this, null, [d]).length), r[o] && s.push(n);
                        s.length && a.push({
                            elem: d,
                            handlers: s
                        })
                    } return d = this, l < t.length && a.push({
                elem: d,
                handlers: t.slice(l)
            }), a
        },
        addProp: function(e, t) {
            Object.defineProperty(T.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: f(t) ? function() {
                    if (this.originalEvent) return t(this.originalEvent)
                } : function() {
                    if (this.originalEvent) return this.originalEvent[e]
                },
                set: function(t) {
                    Object.defineProperty(this, e, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: t
                    })
                }
            })
        },
        fix: function(e) {
            return e[T.expando] ? e : new T.Event(e)
        },
        special: {
            load: {
                noBubble: !0
            },
            click: {
                setup: function(e) {
                    var t = this || e;
                    return Se.test(t.type) && t.click && k(t, "input") && Ie(t, "click", !0), !1
                },
                trigger: function(e) {
                    var t = this || e;
                    return Se.test(t.type) && t.click && k(t, "input") && Ie(t, "click"), !0
                },
                _default: function(e) {
                    var t = e.target;
                    return Se.test(t.type) && t.click && k(t, "input") && oe.get(t, "click") || k(t, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        }
    }, T.removeEvent = function(e, t, i) {
        e.removeEventListener && e.removeEventListener(t, i)
    }, T.Event = function(e, t) {
        if (!(this instanceof T.Event)) return new T.Event(e, t);
        e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Pe : De, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && T.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[T.expando] = !0
    }, T.Event.prototype = {
        constructor: T.Event,
        isDefaultPrevented: De,
        isPropagationStopped: De,
        isImmediatePropagationStopped: De,
        isSimulated: !1,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = Pe, e && !this.isSimulated && e.preventDefault()
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = Pe, e && !this.isSimulated && e.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = Pe, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation()
        }
    }, T.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: !0
    }, T.event.addProp), T.each({
        focus: "focusin",
        blur: "focusout"
    }, function(e, t) {
        function i(e) {
            if (y.documentMode) {
                var i = oe.get(this, "handle"),
                    n = T.event.fix(e);
                n.type = "focusin" === e.type ? "focus" : "blur", n.isSimulated = !0, i(e), n.target === n.currentTarget && i(n)
            } else T.event.simulate(t, e.target, T.event.fix(e))
        }
        T.event.special[e] = {
            setup: function() {
                var n;
                if (Ie(this, e, !0), !y.documentMode) return !1;
                (n = oe.get(this, t)) || this.addEventListener(t, i), oe.set(this, t, (n || 0) + 1)
            },
            trigger: function() {
                return Ie(this, e), !0
            },
            teardown: function() {
                var e;
                if (!y.documentMode) return !1;
                (e = oe.get(this, t) - 1) ? oe.set(this, t, e): (this.removeEventListener(t, i), oe.remove(this, t))
            },
            _default: function(t) {
                return oe.get(t.target, e)
            },
            delegateType: t
        }, T.event.special[t] = {
            setup: function() {
                var n = this.ownerDocument || this.document || this,
                    o = y.documentMode ? this : n,
                    s = oe.get(o, t);
                s || (y.documentMode ? this.addEventListener(t, i) : n.addEventListener(e, i, !0)), oe.set(o, t, (s || 0) + 1)
            },
            teardown: function() {
                var n = this.ownerDocument || this.document || this,
                    o = y.documentMode ? this : n,
                    s = oe.get(o, t) - 1;
                s ? oe.set(o, t, s) : (y.documentMode ? this.removeEventListener(t, i) : n.removeEventListener(e, i, !0), oe.remove(o, t))
            }
        }
    }), T.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, t) {
        T.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function(e) {
                var i, n = e.relatedTarget,
                    o = e.handleObj;
                return n && (n === this || T.contains(this, n)) || (e.type = o.origType, i = o.handler.apply(this, arguments), e.type = t), i
            }
        }
    }), T.fn.extend({
        on: function(e, t, i, n) {
            return Oe(this, e, t, i, n)
        },
        one: function(e, t, i, n) {
            return Oe(this, e, t, i, n, 1)
        },
        off: function(e, t, i) {
            var n, o;
            if (e && e.preventDefault && e.handleObj) return n = e.handleObj, T(e.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
            if ("object" == typeof e) {
                for (o in e) this.off(o, t, e[o]);
                return this
            }
            return !1 !== t && "function" != typeof t || (i = t, t = void 0), !1 === i && (i = De), this.each(function() {
                T.event.remove(this, e, i, t)
            })
        }
    });
    var qe = /<script|<style|<link/i,
        Me = /checked\s*(?:[^=]|=\s*.checked.)/i,
        He = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

    function Be(e, t) {
        return k(e, "table") && k(11 !== t.nodeType ? t : t.firstChild, "tr") && T(e).children("tbody")[0] || e
    }

    function je(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
    }

    function Ne(e) {
        return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e
    }

    function Re(e, t) {
        var i, n, o, s, r, a;
        if (1 === t.nodeType) {
            if (oe.hasData(e) && (a = oe.get(e).events))
                for (o in oe.remove(t, "handle events"), a)
                    for (i = 0, n = a[o].length; i < n; i++) T.event.add(t, o, a[o][i]);
            se.hasData(e) && (s = se.access(e), r = T.extend({}, s), se.set(t, r))
        }
    }

    function _e(e, t, i, n) {
        t = s(t);
        var o, r, a, l, d, c, u = 0,
            p = e.length,
            m = p - 1,
            y = t[0],
            v = f(y);
        if (v || 1 < p && "string" == typeof y && !h.checkClone && Me.test(y)) return e.each(function(o) {
            var s = e.eq(o);
            v && (t[0] = y.call(this, o, s.html())), _e(s, t, i, n)
        });
        if (p && (r = (o = Ae(t, e[0].ownerDocument, !1, e, n)).firstChild, 1 === o.childNodes.length && (o = r), r || n)) {
            for (l = (a = T.map(Ce(o, "script"), je)).length; u < p; u++) d = o, u !== m && (d = T.clone(d, !0, !0), l && T.merge(a, Ce(d, "script"))), i.call(e[u], d, u);
            if (l)
                for (c = a[a.length - 1].ownerDocument, T.map(a, Ne), u = 0; u < l; u++) d = a[u], xe.test(d.type || "") && !oe.access(d, "globalEval") && T.contains(c, d) && (d.src && "module" !== (d.type || "").toLowerCase() ? T._evalUrl && !d.noModule && T._evalUrl(d.src, {
                    nonce: d.nonce || d.getAttribute("nonce")
                }, c) : g(d.textContent.replace(He, ""), d, c))
        }
        return e
    }

    function We(e, t, i) {
        for (var n, o = t ? T.filter(t, e) : e, s = 0; null != (n = o[s]); s++) i || 1 !== n.nodeType || T.cleanData(Ce(n)), n.parentNode && (i && he(n) && $e(Ce(n, "script")), n.parentNode.removeChild(n));
        return e
    }
    T.extend({
        htmlPrefilter: function(e) {
            return e
        },
        clone: function(e, t, i) {
            var n, o, s, r, a, l, d, c = e.cloneNode(!0),
                u = he(e);
            if (!(h.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || T.isXMLDoc(e)))
                for (r = Ce(c), n = 0, o = (s = Ce(e)).length; n < o; n++) a = s[n], "input" === (d = (l = r[n]).nodeName.toLowerCase()) && Se.test(a.type) ? l.checked = a.checked : "input" !== d && "textarea" !== d || (l.defaultValue = a.defaultValue);
            if (t)
                if (i)
                    for (s = s || Ce(e), r = r || Ce(c), n = 0, o = s.length; n < o; n++) Re(s[n], r[n]);
                else Re(e, c);
            return 0 < (r = Ce(c, "script")).length && $e(r, !u && Ce(e, "script")), c
        },
        cleanData: function(e) {
            for (var t, i, n, o = T.event.special, s = 0; void 0 !== (i = e[s]); s++)
                if (ie(i)) {
                    if (t = i[oe.expando]) {
                        if (t.events)
                            for (n in t.events) o[n] ? T.event.remove(i, n) : T.removeEvent(i, n, t.handle);
                        i[oe.expando] = void 0
                    }
                    i[se.expando] && (i[se.expando] = void 0)
                }
        }
    }), T.fn.extend({
        detach: function(e) {
            return We(this, e, !0)
        },
        remove: function(e) {
            return We(this, e)
        },
        text: function(e) {
            return K(this, function(e) {
                return void 0 === e ? T.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                })
            }, null, e, arguments.length)
        },
        append: function() {
            return _e(this, arguments, function(e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Be(this, e).appendChild(e)
            })
        },
        prepend: function() {
            return _e(this, arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = Be(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        },
        before: function() {
            return _e(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return _e(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (T.cleanData(Ce(e, !1)), e.textContent = "");
            return this
        },
        clone: function(e, t) {
            return e = null != e && e, t = null == t ? e : t, this.map(function() {
                return T.clone(this, e, t)
            })
        },
        html: function(e) {
            return K(this, function(e) {
                var t = this[0] || {},
                    i = 0,
                    n = this.length;
                if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                if ("string" == typeof e && !qe.test(e) && !ke[(Te.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = T.htmlPrefilter(e);
                    try {
                        for (; i < n; i++) 1 === (t = this[i] || {}).nodeType && (T.cleanData(Ce(t, !1)), t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var e = [];
            return _e(this, arguments, function(t) {
                var i = this.parentNode;
                0 > T.inArray(this, e) && (T.cleanData(Ce(this)), i && i.replaceChild(t, this))
            }, e)
        }
    }), T.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, t) {
        T.fn[e] = function(e) {
            for (var i, n = [], o = T(e), s = o.length - 1, a = 0; a <= s; a++) i = a === s ? this : this.clone(!0), T(o[a])[t](i), r.apply(n, i.get());
            return this.pushStack(n)
        }
    });
    var Fe = RegExp("^(" + de + ")(?!px)[a-z%]+$", "i"),
        ze = /^--/,
        Ue = function(t) {
            var i = t.ownerDocument.defaultView;
            return i && i.opener || (i = e), i.getComputedStyle(t)
        },
        Ve = function(e, t, i) {
            var n, o, s = {};
            for (o in t) s[o] = e.style[o], e.style[o] = t[o];
            for (o in n = i.call(e), t) e.style[o] = s[o];
            return n
        },
        Xe = RegExp(ue.join("|"), "i");

    function Ye(e, t, i) {
        var n, o, s, r, a = ze.test(t),
            l = e.style;
        return (i = i || Ue(e)) && (r = i.getPropertyValue(t) || i[t], a && r && (r = r.replace(L, "$1") || void 0), "" !== r || he(e) || (r = T.style(e, t)), !h.pixelBoxStyles() && Fe.test(r) && Xe.test(t) && (n = l.width, o = l.minWidth, s = l.maxWidth, l.minWidth = l.maxWidth = l.width = r, r = i.width, l.width = n, l.minWidth = o, l.maxWidth = s)), void 0 !== r ? r + "" : r
    }

    function Ge(e, t) {
        return {
            get: function() {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get
            }
        }
    }! function() {
        function t() {
            if (c) {
                d.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", pe.appendChild(d).appendChild(c);
                var t = e.getComputedStyle(c);
                n = "1%" !== t.top, l = 12 === i(t.marginLeft), c.style.right = "60%", r = 36 === i(t.right), o = 36 === i(t.width), c.style.position = "absolute", s = 12 === i(c.offsetWidth / 3), pe.removeChild(d), c = null
            }
        }

        function i(e) {
            return Math.round(parseFloat(e))
        }
        var n, o, s, r, a, l, d = y.createElement("div"),
            c = y.createElement("div");
        c.style && (c.style.backgroundClip = "content-box", c.cloneNode(!0).style.backgroundClip = "", h.clearCloneStyle = "content-box" === c.style.backgroundClip, T.extend(h, {
            boxSizingReliable: function() {
                return t(), o
            },
            pixelBoxStyles: function() {
                return t(), r
            },
            pixelPosition: function() {
                return t(), n
            },
            reliableMarginLeft: function() {
                return t(), l
            },
            scrollboxSize: function() {
                return t(), s
            },
            reliableTrDimensions: function() {
                var t, i, n, o;
                return null == a && (t = y.createElement("table"), i = y.createElement("tr"), n = y.createElement("div"), t.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", i.style.cssText = "box-sizing:content-box;border:1px solid", i.style.height = "1px", n.style.height = "9px", n.style.display = "block", pe.appendChild(t).appendChild(i).appendChild(n), a = parseInt((o = e.getComputedStyle(i)).height, 10) + parseInt(o.borderTopWidth, 10) + parseInt(o.borderBottomWidth, 10) === i.offsetHeight, pe.removeChild(t)), a
            }
        }))
    }();
    var Qe = ["Webkit", "Moz", "ms"],
        Ke = y.createElement("div").style,
        Je = {};

    function Ze(e) {
        return T.cssProps[e] || Je[e] || (e in Ke ? e : Je[e] = function(e) {
            for (var t = e[0].toUpperCase() + e.slice(1), i = Qe.length; i--;)
                if ((e = Qe[i] + t) in Ke) return e
        }(e) || e)
    }
    var et = /^(none|table(?!-c[ea]).+)/,
        tt = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        it = {
            letterSpacing: "0",
            fontWeight: "400"
        };

    function nt(e, t, i) {
        var n = ce.exec(t);
        return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t
    }

    function ot(e, t, i, n, o, s) {
        var r = "width" === t ? 1 : 0,
            a = 0,
            l = 0,
            d = 0;
        if (i === (n ? "border" : "content")) return 0;
        for (; r < 4; r += 2) "margin" === i && (d += T.css(e, i + ue[r], !0, o)), n ? ("content" === i && (l -= T.css(e, "padding" + ue[r], !0, o)), "margin" !== i && (l -= T.css(e, "border" + ue[r] + "Width", !0, o))) : (l += T.css(e, "padding" + ue[r], !0, o), "padding" !== i ? l += T.css(e, "border" + ue[r] + "Width", !0, o) : a += T.css(e, "border" + ue[r] + "Width", !0, o));
        return !n && 0 <= s && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - s - l - a - .5)) || 0), l + d
    }

    function st(e, t, i) {
        var n = Ue(e),
            o = (!h.boxSizingReliable() || i) && "border-box" === T.css(e, "boxSizing", !1, n),
            s = o,
            r = Ye(e, t, n),
            a = "offset" + t[0].toUpperCase() + t.slice(1);
        if (Fe.test(r)) {
            if (!i) return r;
            r = "auto"
        }
        return (!h.boxSizingReliable() && o || !h.reliableTrDimensions() && k(e, "tr") || "auto" === r || !parseFloat(r) && "inline" === T.css(e, "display", !1, n)) && e.getClientRects().length && (o = "border-box" === T.css(e, "boxSizing", !1, n), (s = a in e) && (r = e[a])), (r = parseFloat(r) || 0) + ot(e, t, i || (o ? "border" : "content"), s, n, r) + "px"
    }

    function rt(e, t, i, n, o) {
        return new rt.prototype.init(e, t, i, n, o)
    }
    T.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var i = Ye(e, "opacity");
                        return "" === i ? "1" : i
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            aspectRatio: !0,
            borderImageSlice: !0,
            columnCount: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            scale: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
            fillOpacity: !0,
            floodOpacity: !0,
            stopOpacity: !0,
            strokeMiterlimit: !0,
            strokeOpacity: !0
        },
        cssProps: {},
        style: function(e, t, i, n) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var o, s, r, a = te(t),
                    l = ze.test(t),
                    d = e.style;
                if (l || (t = Ze(a)), r = T.cssHooks[t] || T.cssHooks[a], void 0 === i) return r && "get" in r && void 0 !== (o = r.get(e, !1, n)) ? o : d[t];
                "string" == (s = typeof i) && (o = ce.exec(i)) && o[1] && (i = ye(e, t, o), s = "number"), null != i && i == i && ("number" !== s || l || (i += o && o[3] || (T.cssNumber[a] ? "" : "px")), h.clearCloneStyle || "" !== i || 0 !== t.indexOf("background") || (d[t] = "inherit"), r && "set" in r && void 0 === (i = r.set(e, i, n)) || (l ? d.setProperty(t, i) : d[t] = i))
            }
        },
        css: function(e, t, i, n) {
            var o, s, r, a = te(t);
            return ze.test(t) || (t = Ze(a)), (r = T.cssHooks[t] || T.cssHooks[a]) && "get" in r && (o = r.get(e, !0, i)), void 0 === o && (o = Ye(e, t, n)), "normal" === o && t in it && (o = it[t]), "" === i || i ? (s = parseFloat(o), !0 === i || isFinite(s) ? s || 0 : o) : o
        }
    }), T.each(["height", "width"], function(e, t) {
        T.cssHooks[t] = {
            get: function(e, i, n) {
                if (i) return !et.test(T.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? st(e, t, n) : Ve(e, tt, function() {
                    return st(e, t, n)
                })
            },
            set: function(e, i, n) {
                var o, s = Ue(e),
                    r = !h.scrollboxSize() && "absolute" === s.position,
                    a = (r || n) && "border-box" === T.css(e, "boxSizing", !1, s),
                    l = n ? ot(e, t, n, a, s) : 0;
                return a && r && (l -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(s[t]) - ot(e, t, "border", !1, s) - .5)), l && (o = ce.exec(i)) && "px" !== (o[3] || "px") && (e.style[t] = i, i = T.css(e, t)), nt(0, i, l)
            }
        }
    }), T.cssHooks.marginLeft = Ge(h.reliableMarginLeft, function(e, t) {
        if (t) return (parseFloat(Ye(e, "marginLeft")) || e.getBoundingClientRect().left - Ve(e, {
            marginLeft: 0
        }, function() {
            return e.getBoundingClientRect().left
        })) + "px"
    }), T.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(e, t) {
        T.cssHooks[e + t] = {
            expand: function(i) {
                for (var n = 0, o = {}, s = "string" == typeof i ? i.split(" ") : [i]; n < 4; n++) o[e + ue[n] + t] = s[n] || s[n - 2] || s[0];
                return o
            }
        }, "margin" !== e && (T.cssHooks[e + t].set = nt)
    }), T.fn.extend({
        css: function(e, t) {
            return K(this, function(e, t, i) {
                var n, o, s = {},
                    r = 0;
                if (Array.isArray(t)) {
                    for (n = Ue(e), o = t.length; r < o; r++) s[t[r]] = T.css(e, t[r], !1, n);
                    return s
                }
                return void 0 !== i ? T.style(e, t, i) : T.css(e, t)
            }, e, t, 1 < arguments.length)
        }
    }), ((T.Tween = rt).prototype = {
        constructor: rt,
        init: function(e, t, i, n, o, s) {
            this.elem = e, this.prop = i, this.easing = o || T.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = n, this.unit = s || (T.cssNumber[i] ? "" : "px")
        },
        cur: function() {
            var e = rt.propHooks[this.prop];
            return e && e.get ? e.get(this) : rt.propHooks._default.get(this)
        },
        run: function(e) {
            var t, i = rt.propHooks[this.prop];
            return this.options.duration ? this.pos = t = T.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), i && i.set ? i.set(this) : rt.propHooks._default.set(this), this
        }
    }).init.prototype = rt.prototype, (rt.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = T.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
            },
            set: function(e) {
                T.fx.step[e.prop] ? T.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !T.cssHooks[e.prop] && null == e.elem.style[Ze(e.prop)] ? e.elem[e.prop] = e.now : T.style(e.elem, e.prop, e.now + e.unit)
            }
        }
    }).scrollTop = rt.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    }, T.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        },
        _default: "swing"
    }, T.fx = rt.prototype.init, T.fx.step = {};
    var at, lt, dt, ct, ut = /^(?:toggle|show|hide)$/,
        pt = /queueHooks$/;

    function ht() {
        return e.setTimeout(function() {
            at = void 0
        }), at = Date.now()
    }

    function ft(e, t) {
        var i, n = 0,
            o = {
                height: e
            };
        for (t = t ? 1 : 0; n < 4; n += 2 - t) o["margin" + (i = ue[n])] = o["padding" + i] = e;
        return t && (o.opacity = o.width = e), o
    }

    function mt(e, t, i) {
        for (var n, o = (yt.tweeners[t] || []).concat(yt.tweeners["*"]), s = 0, r = o.length; s < r; s++)
            if (n = o[s].call(i, t, e)) return n
    }

    function yt(e, t, i) {
        var n, o, s = 0,
            r = yt.prefilters.length,
            a = T.Deferred().always(function() {
                delete l.elem
            }),
            l = function() {
                if (o) return !1;
                for (var t = at || ht(), i = Math.max(0, d.startTime + d.duration - t), n = 1 - (i / d.duration || 0), s = 0, r = d.tweens.length; s < r; s++) d.tweens[s].run(n);
                return a.notifyWith(e, [d, n, i]), n < 1 && r ? i : (r || a.notifyWith(e, [d, 1, 0]), a.resolveWith(e, [d]), !1)
            },
            d = a.promise({
                elem: e,
                props: T.extend({}, t),
                opts: T.extend(!0, {
                    specialEasing: {},
                    easing: T.easing._default
                }, i),
                originalProperties: t,
                originalOptions: i,
                startTime: at || ht(),
                duration: i.duration,
                tweens: [],
                createTween: function(t, i) {
                    var n = T.Tween(e, d.opts, t, i, d.opts.specialEasing[t] || d.opts.easing);
                    return d.tweens.push(n), n
                },
                stop: function(t) {
                    var i = 0,
                        n = t ? d.tweens.length : 0;
                    if (o) return this;
                    for (o = !0; i < n; i++) d.tweens[i].run(1);
                    return t ? (a.notifyWith(e, [d, 1, 0]), a.resolveWith(e, [d, t])) : a.rejectWith(e, [d, t]), this
                }
            }),
            c = d.props;
        for (function(e, t) {
                var i, n, o, s, r;
                for (i in e)
                    if (o = t[n = te(i)], Array.isArray(s = e[i]) && (o = s[1], s = e[i] = s[0]), i !== n && (e[n] = s, delete e[i]), (r = T.cssHooks[n]) && "expand" in r)
                        for (i in s = r.expand(s), delete e[n], s) i in e || (e[i] = s[i], t[i] = o);
                    else t[n] = o
            }(c, d.opts.specialEasing); s < r; s++)
            if (n = yt.prefilters[s].call(d, e, c, d.opts)) return f(n.stop) && (T._queueHooks(d.elem, d.opts.queue).stop = n.stop.bind(n)), n;
        return T.map(c, mt, d), f(d.opts.start) && d.opts.start.call(e, d), d.progress(d.opts.progress).done(d.opts.done, d.opts.complete).fail(d.opts.fail).always(d.opts.always), T.fx.timer(T.extend(l, {
            elem: e,
            anim: d,
            queue: d.opts.queue
        })), d
    }
    T.Animation = T.extend(yt, {
        tweeners: {
            "*": [function(e, t) {
                var i = this.createTween(e, t);
                return ye(i.elem, e, ce.exec(t), i), i
            }]
        },
        tweener: function(e, t) {
            f(e) ? (t = e, e = ["*"]) : e = e.match(z);
            for (var i, n = 0, o = e.length; n < o; n++) i = e[n], yt.tweeners[i] = yt.tweeners[i] || [], yt.tweeners[i].unshift(t)
        },
        prefilters: [function(e, t, i) {
            var n, o, s, r, a, l, d, c, u = "width" in t || "height" in t,
                p = this,
                h = {},
                f = e.style,
                m = e.nodeType && me(e),
                y = oe.get(e, "fxshow");
            for (n in i.queue || (null == (r = T._queueHooks(e, "fx")).unqueued && (r.unqueued = 0, a = r.empty.fire, r.empty.fire = function() {
                    r.unqueued || a()
                }), r.unqueued++, p.always(function() {
                    p.always(function() {
                        r.unqueued--, T.queue(e, "fx").length || r.empty.fire()
                    })
                })), t)
                if (o = t[n], ut.test(o)) {
                    if (delete t[n], s = s || "toggle" === o, o === (m ? "hide" : "show")) {
                        if ("show" !== o || !y || void 0 === y[n]) continue;
                        m = !0
                    }
                    h[n] = y && y[n] || T.style(e, n)
                } if ((l = !T.isEmptyObject(t)) || !T.isEmptyObject(h))
                for (n in u && 1 === e.nodeType && (i.overflow = [f.overflow, f.overflowX, f.overflowY], null == (d = y && y.display) && (d = oe.get(e, "display")), "none" === (c = T.css(e, "display")) && (d ? c = d : (ge([e], !0), d = e.style.display || d, c = T.css(e, "display"), ge([e]))), ("inline" === c || "inline-block" === c && null != d) && "none" === T.css(e, "float") && (l || (p.done(function() {
                        f.display = d
                    }), null == d && (d = "none" === (c = f.display) ? "" : c)), f.display = "inline-block")), i.overflow && (f.overflow = "hidden", p.always(function() {
                        f.overflow = i.overflow[0], f.overflowX = i.overflow[1], f.overflowY = i.overflow[2]
                    })), l = !1, h) l || (y ? "hidden" in y && (m = y.hidden) : y = oe.access(e, "fxshow", {
                    display: d
                }), s && (y.hidden = !m), m && ge([e], !0), p.done(function() {
                    for (n in m || ge([e]), oe.remove(e, "fxshow"), h) T.style(e, n, h[n])
                })), l = mt(m ? y[n] : 0, n, p), n in y || (y[n] = l.start, m && (l.end = l.start, l.start = 0))
        }],
        prefilter: function(e, t) {
            t ? yt.prefilters.unshift(e) : yt.prefilters.push(e)
        }
    }), T.speed = function(e, t, i) {
        var n = e && "object" == typeof e ? T.extend({}, e) : {
            complete: i || !i && t || f(e) && e,
            duration: e,
            easing: i && t || t && !f(t) && t
        };
        return T.fx.off ? n.duration = 0 : "number" != typeof n.duration && (n.duration in T.fx.speeds ? n.duration = T.fx.speeds[n.duration] : n.duration = T.fx.speeds._default), null != n.queue && !0 !== n.queue || (n.queue = "fx"), n.old = n.complete, n.complete = function() {
            f(n.old) && n.old.call(this), n.queue && T.dequeue(this, n.queue)
        }, n
    }, T.fn.extend({
        fadeTo: function(e, t, i, n) {
            return this.filter(me).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, i, n)
        },
        animate: function(e, t, i, n) {
            var o = T.isEmptyObject(e),
                s = T.speed(t, i, n),
                r = function() {
                    var t = yt(this, T.extend({}, e), s);
                    (o || oe.get(this, "finish")) && t.stop(!0)
                };
            return r.finish = r, o || !1 === s.queue ? this.each(r) : this.queue(s.queue, r)
        },
        stop: function(e, t, i) {
            var n = function(e) {
                var t = e.stop;
                delete e.stop, t(i)
            };
            return "string" != typeof e && (i = t, t = e, e = void 0), t && this.queue(e || "fx", []), this.each(function() {
                var t = !0,
                    o = null != e && e + "queueHooks",
                    s = T.timers,
                    r = oe.get(this);
                if (o) r[o] && r[o].stop && n(r[o]);
                else
                    for (o in r) r[o] && r[o].stop && pt.test(o) && n(r[o]);
                for (o = s.length; o--;) s[o].elem !== this || null != e && s[o].queue !== e || (s[o].anim.stop(i), t = !1, s.splice(o, 1));
                !t && i || T.dequeue(this, e)
            })
        },
        finish: function(e) {
            return !1 !== e && (e = e || "fx"), this.each(function() {
                var t, i = oe.get(this),
                    n = i[e + "queue"],
                    o = i[e + "queueHooks"],
                    s = T.timers,
                    r = n ? n.length : 0;
                for (i.finish = !0, T.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = s.length; t--;) s[t].elem === this && s[t].queue === e && (s[t].anim.stop(!0), s.splice(t, 1));
                for (t = 0; t < r; t++) n[t] && n[t].finish && n[t].finish.call(this);
                delete i.finish
            })
        }
    }), T.each(["toggle", "show", "hide"], function(e, t) {
        var i = T.fn[t];
        T.fn[t] = function(e, n, o) {
            return null == e || "boolean" == typeof e ? i.apply(this, arguments) : this.animate(ft(t, !0), e, n, o)
        }
    }), T.each({
        slideDown: ft("show"),
        slideUp: ft("hide"),
        slideToggle: ft("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(e, t) {
        T.fn[e] = function(e, i, n) {
            return this.animate(t, e, i, n)
        }
    }), T.timers = [], T.fx.tick = function() {
        var e, t = 0,
            i = T.timers;
        for (at = Date.now(); t < i.length; t++)(e = i[t])() || i[t] !== e || i.splice(t--, 1);
        i.length || T.fx.stop(), at = void 0
    }, T.fx.timer = function(e) {
        T.timers.push(e), T.fx.start()
    }, T.fx.interval = 13, T.fx.start = function() {
        lt || (lt = !0, function t() {
            lt && (!1 === y.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(t) : e.setTimeout(t, T.fx.interval), T.fx.tick())
        }())
    }, T.fx.stop = function() {
        lt = null
    }, T.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    }, T.fn.delay = function(t, i) {
        return t = T.fx && T.fx.speeds[t] || t, i = i || "fx", this.queue(i, function(i, n) {
            var o = e.setTimeout(i, t);
            n.stop = function() {
                e.clearTimeout(o)
            }
        })
    }, dt = y.createElement("input"), ct = y.createElement("select").appendChild(y.createElement("option")), dt.type = "checkbox", h.checkOn = "" !== dt.value, h.optSelected = ct.selected, (dt = y.createElement("input")).value = "t", dt.type = "radio", h.radioValue = "t" === dt.value;
    var vt, gt = T.expr.attrHandle;
    T.fn.extend({
        attr: function(e, t) {
            return K(this, T.attr, e, t, 1 < arguments.length)
        },
        removeAttr: function(e) {
            return this.each(function() {
                T.removeAttr(this, e)
            })
        }
    }), T.extend({
        attr: function(e, t, i) {
            var n, o, s = e.nodeType;
            if (3 !== s && 8 !== s && 2 !== s) return void 0 === e.getAttribute ? T.prop(e, t, i) : (1 === s && T.isXMLDoc(e) || (o = T.attrHooks[t.toLowerCase()] || (T.expr.match.bool.test(t) ? vt : void 0)), void 0 !== i ? null === i ? void T.removeAttr(e, t) : o && "set" in o && void 0 !== (n = o.set(e, i, t)) ? n : (e.setAttribute(t, i + ""), i) : o && "get" in o && null !== (n = o.get(e, t)) ? n : null == (n = T.find.attr(e, t)) ? void 0 : n)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!h.radioValue && "radio" === t && k(e, "input")) {
                        var i = e.value;
                        return e.setAttribute("type", t), i && (e.value = i), t
                    }
                }
            }
        },
        removeAttr: function(e, t) {
            var i, n = 0,
                o = t && t.match(z);
            if (o && 1 === e.nodeType)
                for (; i = o[n++];) e.removeAttribute(i)
        }
    }), vt = {
        set: function(e, t, i) {
            return !1 === t ? T.removeAttr(e, i) : e.setAttribute(i, i), i
        }
    }, T.each(T.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var i = gt[t] || T.find.attr;
        gt[t] = function(e, t, n) {
            var o, s, r = t.toLowerCase();
            return n || (s = gt[r], gt[r] = o, o = null != i(e, t, n) ? r : null, gt[r] = s), o
        }
    });
    var bt = /^(?:input|select|textarea|button)$/i,
        wt = /^(?:a|area)$/i;

    function St(e) {
        return (e.match(z) || []).join(" ")
    }

    function Tt(e) {
        return e.getAttribute && e.getAttribute("class") || ""
    }

    function xt(e) {
        return Array.isArray(e) ? e : "string" == typeof e && e.match(z) || []
    }
    T.fn.extend({
        prop: function(e, t) {
            return K(this, T.prop, e, t, 1 < arguments.length)
        },
        removeProp: function(e) {
            return this.each(function() {
                delete this[T.propFix[e] || e]
            })
        }
    }), T.extend({
        prop: function(e, t, i) {
            var n, o, s = e.nodeType;
            if (3 !== s && 8 !== s && 2 !== s) return 1 === s && T.isXMLDoc(e) || (t = T.propFix[t] || t, o = T.propHooks[t]), void 0 !== i ? o && "set" in o && void 0 !== (n = o.set(e, i, t)) ? n : e[t] = i : o && "get" in o && null !== (n = o.get(e, t)) ? n : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = T.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : bt.test(e.nodeName) || wt.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }), h.optSelected || (T.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null
        },
        set: function(e) {
            var t = e.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
        }
    }), T.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        T.propFix[this.toLowerCase()] = this
    }), T.fn.extend({
        addClass: function(e) {
            var t, i, n, o, s, r;
            return f(e) ? this.each(function(t) {
                T(this).addClass(e.call(this, t, Tt(this)))
            }) : (t = xt(e)).length ? this.each(function() {
                if (n = Tt(this), i = 1 === this.nodeType && " " + St(n) + " ") {
                    for (s = 0; s < t.length; s++) o = t[s], 0 > i.indexOf(" " + o + " ") && (i += o + " ");
                    n !== (r = St(i)) && this.setAttribute("class", r)
                }
            }) : this
        },
        removeClass: function(e) {
            var t, i, n, o, s, r;
            return f(e) ? this.each(function(t) {
                T(this).removeClass(e.call(this, t, Tt(this)))
            }) : arguments.length ? (t = xt(e)).length ? this.each(function() {
                if (n = Tt(this), i = 1 === this.nodeType && " " + St(n) + " ") {
                    for (s = 0; s < t.length; s++)
                        for (o = t[s]; - 1 < i.indexOf(" " + o + " ");) i = i.replace(" " + o + " ", " ");
                    n !== (r = St(i)) && this.setAttribute("class", r)
                }
            }) : this : this.attr("class", "")
        },
        toggleClass: function(e, t) {
            var i, n, o, s, r = typeof e,
                a = "string" === r || Array.isArray(e);
            return f(e) ? this.each(function(i) {
                T(this).toggleClass(e.call(this, i, Tt(this), t), t)
            }) : "boolean" == typeof t && a ? t ? this.addClass(e) : this.removeClass(e) : (i = xt(e), this.each(function() {
                if (a)
                    for (s = T(this), o = 0; o < i.length; o++) n = i[o], s.hasClass(n) ? s.removeClass(n) : s.addClass(n);
                else void 0 !== e && "boolean" !== r || ((n = Tt(this)) && oe.set(this, "__className__", n), this.setAttribute && this.setAttribute("class", n || !1 === e ? "" : oe.get(this, "__className__") || ""))
            }))
        },
        hasClass: function(e) {
            var t, i, n = 0;
            for (t = " " + e + " "; i = this[n++];)
                if (1 === i.nodeType && -1 < (" " + St(Tt(i)) + " ").indexOf(t)) return !0;
            return !1
        }
    });
    var kt = /\r/g;
    T.fn.extend({
        val: function(e) {
            var t, i, n, o = this[0];
            return arguments.length ? (n = f(e), this.each(function(i) {
                var o;
                1 === this.nodeType && (null == (o = n ? e.call(this, i, T(this).val()) : e) ? o = "" : "number" == typeof o ? o += "" : Array.isArray(o) && (o = T.map(o, function(e) {
                    return null == e ? "" : e + ""
                })), (t = T.valHooks[this.type] || T.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, o, "value") || (this.value = o))
            })) : o ? (t = T.valHooks[o.type] || T.valHooks[o.nodeName.toLowerCase()]) && "get" in t && void 0 !== (i = t.get(o, "value")) ? i : "string" == typeof(i = o.value) ? i.replace(kt, "") : null == i ? "" : i : void 0
        }
    }), T.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = T.find.attr(e, "value");
                    return null != t ? t : St(T.text(e))
                }
            },
            select: {
                get: function(e) {
                    var t, i, n, o = e.options,
                        s = e.selectedIndex,
                        r = "select-one" === e.type,
                        a = r ? null : [],
                        l = r ? s + 1 : o.length;
                    for (n = s < 0 ? l : r ? s : 0; n < l; n++)
                        if (((i = o[n]).selected || n === s) && !i.disabled && (!i.parentNode.disabled || !k(i.parentNode, "optgroup"))) {
                            if (t = T(i).val(), r) return t;
                            a.push(t)
                        } return a
                },
                set: function(e, t) {
                    for (var i, n, o = e.options, s = T.makeArray(t), r = o.length; r--;)((n = o[r]).selected = -1 < T.inArray(T.valHooks.option.get(n), s)) && (i = !0);
                    return i || (e.selectedIndex = -1), s
                }
            }
        }
    }), T.each(["radio", "checkbox"], function() {
        T.valHooks[this] = {
            set: function(e, t) {
                if (Array.isArray(t)) return e.checked = -1 < T.inArray(T(e).val(), t)
            }
        }, h.checkOn || (T.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        })
    });
    var Ct = e.location,
        $t = {
            guid: Date.now()
        },
        Et = /\?/;
    T.parseXML = function(t) {
        var i, n;
        if (!t || "string" != typeof t) return null;
        try {
            i = (new e.DOMParser).parseFromString(t, "text/xml")
        } catch (e) {}
        return n = i && i.getElementsByTagName("parsererror")[0], i && !n || T.error("Invalid XML: " + (n ? T.map(n.childNodes, function(e) {
            return e.textContent
        }).join("\n") : t)), i
    };
    var At = /^(?:focusinfocus|focusoutblur)$/,
        Lt = function(e) {
            e.stopPropagation()
        };
    T.extend(T.event, {
        trigger: function(t, i, n, o) {
            var s, r, a, l, d, u, p, h, v = [n || y],
                g = c.call(t, "type") ? t.type : t,
                b = c.call(t, "namespace") ? t.namespace.split(".") : [];
            if (r = h = a = n = n || y, 3 !== n.nodeType && 8 !== n.nodeType && !At.test(g + T.event.triggered) && (-1 < g.indexOf(".") && (g = (b = g.split(".")).shift(), b.sort()), d = 0 > g.indexOf(":") && "on" + g, (t = t[T.expando] ? t : new T.Event(g, "object" == typeof t && t)).isTrigger = o ? 2 : 3, t.namespace = b.join("."), t.rnamespace = t.namespace ? RegExp("(^|\\.)" + b.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = n), i = null == i ? [t] : T.makeArray(i, [t]), p = T.event.special[g] || {}, o || !p.trigger || !1 !== p.trigger.apply(n, i))) {
                if (!o && !p.noBubble && !m(n)) {
                    for (l = p.delegateType || g, At.test(l + g) || (r = r.parentNode); r; r = r.parentNode) v.push(r), a = r;
                    a === (n.ownerDocument || y) && v.push(a.defaultView || a.parentWindow || e)
                }
                for (s = 0;
                    (r = v[s++]) && !t.isPropagationStopped();) h = r, t.type = 1 < s ? l : p.bindType || g, (u = (oe.get(r, "events") || Object.create(null))[t.type] && oe.get(r, "handle")) && u.apply(r, i), (u = d && r[d]) && u.apply && ie(r) && (t.result = u.apply(r, i), !1 === t.result && t.preventDefault());
                return t.type = g, o || t.isDefaultPrevented() || p._default && !1 !== p._default.apply(v.pop(), i) || !ie(n) || d && f(n[g]) && !m(n) && ((a = n[d]) && (n[d] = null), T.event.triggered = g, t.isPropagationStopped() && h.addEventListener(g, Lt), n[g](), t.isPropagationStopped() && h.removeEventListener(g, Lt), T.event.triggered = void 0, a && (n[d] = a)), t.result
            }
        },
        simulate: function(e, t, i) {
            var n = T.extend(new T.Event, i, {
                type: e,
                isSimulated: !0
            });
            T.event.trigger(n, null, t)
        }
    }), T.fn.extend({
        trigger: function(e, t) {
            return this.each(function() {
                T.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var i = this[0];
            if (i) return T.event.trigger(e, t, i, !0)
        }
    });
    var Pt = /\[\]$/,
        Dt = /\r?\n/g,
        Ot = /^(?:submit|button|image|reset|file)$/i,
        It = /^(?:input|select|textarea|keygen)/i;

    function qt(e, t, i, n) {
        var o;
        if (Array.isArray(t)) T.each(t, function(t, o) {
            i || Pt.test(e) ? n(e, o) : qt(e + "[" + ("object" == typeof o && null != o ? t : "") + "]", o, i, n)
        });
        else if (i || "object" !== b(t)) n(e, t);
        else
            for (o in t) qt(e + "[" + o + "]", t[o], i, n)
    }
    T.param = function(e, t) {
        var i, n = [],
            o = function(e, t) {
                var i = f(t) ? t() : t;
                n[n.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == i ? "" : i)
            };
        if (null == e) return "";
        if (Array.isArray(e) || e.jquery && !T.isPlainObject(e)) T.each(e, function() {
            o(this.name, this.value)
        });
        else
            for (i in e) qt(i, e[i], t, o);
        return n.join("&")
    }, T.fn.extend({
        serialize: function() {
            return T.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = T.prop(this, "elements");
                return e ? T.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !T(this).is(":disabled") && It.test(this.nodeName) && !Ot.test(e) && (this.checked || !Se.test(e))
            }).map(function(e, t) {
                var i = T(this).val();
                return null == i ? null : Array.isArray(i) ? T.map(i, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(Dt, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: i.replace(Dt, "\r\n")
                }
            }).get()
        }
    });
    var Mt = /%20/g,
        Ht = /#.*$/,
        Bt = /([?&])_=[^&]*/,
        jt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Nt = /^(?:GET|HEAD)$/,
        Rt = /^\/\//,
        _t = {},
        Wt = {},
        Ft = "*/".concat("*"),
        zt = y.createElement("a");

    function Ut(e) {
        return function(t, i) {
            "string" != typeof t && (i = t, t = "*");
            var n, o = 0,
                s = t.toLowerCase().match(z) || [];
            if (f(i))
                for (; n = s[o++];) "+" === n[0] ? (e[n = n.slice(1) || "*"] = e[n] || []).unshift(i) : (e[n] = e[n] || []).push(i)
        }
    }

    function Vt(e, t, i, n) {
        var o = {},
            s = e === Wt;

        function r(a) {
            var l;
            return o[a] = !0, T.each(e[a] || [], function(e, a) {
                var d = a(t, i, n);
                return "string" != typeof d || s || o[d] ? s ? !(l = d) : void 0 : (t.dataTypes.unshift(d), r(d), !1)
            }), l
        }
        return r(t.dataTypes[0]) || !o["*"] && r("*")
    }

    function Xt(e, t) {
        var i, n, o = T.ajaxSettings.flatOptions || {};
        for (i in t) void 0 !== t[i] && ((o[i] ? e : n || (n = {}))[i] = t[i]);
        return n && T.extend(!0, e, n), e
    }
    zt.href = Ct.href, T.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Ct.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Ct.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Ft,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": T.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? Xt(Xt(e, T.ajaxSettings), t) : Xt(T.ajaxSettings, e)
        },
        ajaxPrefilter: Ut(_t),
        ajaxTransport: Ut(Wt),
        ajax: function(t, i) {
            "object" == typeof t && (i = t, t = void 0), i = i || {};
            var n, o, s, r, a, l, d, c, u, p, h = T.ajaxSetup({}, i),
                f = h.context || h,
                m = h.context && (f.nodeType || f.jquery) ? T(f) : T.event,
                v = T.Deferred(),
                g = T.Callbacks("once memory"),
                b = h.statusCode || {},
                w = {},
                S = {},
                x = "canceled",
                k = {
                    readyState: 0,
                    getResponseHeader: function(e) {
                        var t;
                        if (d) {
                            if (!r)
                                for (r = {}; t = jt.exec(s);) r[t[1].toLowerCase() + " "] = (r[t[1].toLowerCase() + " "] || []).concat(t[2]);
                            t = r[e.toLowerCase() + " "]
                        }
                        return null == t ? null : t.join(", ")
                    },
                    getAllResponseHeaders: function() {
                        return d ? s : null
                    },
                    setRequestHeader: function(e, t) {
                        return null == d && (w[e = S[e.toLowerCase()] = S[e.toLowerCase()] || e] = t), this
                    },
                    overrideMimeType: function(e) {
                        return null == d && (h.mimeType = e), this
                    },
                    statusCode: function(e) {
                        var t;
                        if (e)
                            if (d) k.always(e[k.status]);
                            else
                                for (t in e) b[t] = [b[t], e[t]];
                        return this
                    },
                    abort: function(e) {
                        var t = e || x;
                        return n && n.abort(t), C(0, t), this
                    }
                };
            if (v.promise(k), h.url = ((t || h.url || Ct.href) + "").replace(Rt, Ct.protocol + "//"), h.type = i.method || i.type || h.method || h.type, h.dataTypes = (h.dataType || "*").toLowerCase().match(z) || [""], null == h.crossDomain) {
                l = y.createElement("a");
                try {
                    l.href = h.url, l.href = l.href, h.crossDomain = zt.protocol + "//" + zt.host != l.protocol + "//" + l.host
                } catch (e) {
                    h.crossDomain = !0
                }
            }
            if (h.data && h.processData && "string" != typeof h.data && (h.data = T.param(h.data, h.traditional)), Vt(_t, h, i, k), d) return k;
            for (u in (c = T.event && h.global) && 0 == T.active++ && T.event.trigger("ajaxStart"), h.type = h.type.toUpperCase(), h.hasContent = !Nt.test(h.type), o = h.url.replace(Ht, ""), h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(Mt, "+")) : (p = h.url.slice(o.length), h.data && (h.processData || "string" == typeof h.data) && (o += (Et.test(o) ? "&" : "?") + h.data, delete h.data), !1 === h.cache && (o = o.replace(Bt, "$1"), p = (Et.test(o) ? "&" : "?") + "_=" + $t.guid++ + p), h.url = o + p), h.ifModified && (T.lastModified[o] && k.setRequestHeader("If-Modified-Since", T.lastModified[o]), T.etag[o] && k.setRequestHeader("If-None-Match", T.etag[o])), (h.data && h.hasContent && !1 !== h.contentType || i.contentType) && k.setRequestHeader("Content-Type", h.contentType), k.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + Ft + "; q=0.01" : "") : h.accepts["*"]), h.headers) k.setRequestHeader(u, h.headers[u]);
            if (h.beforeSend && (!1 === h.beforeSend.call(f, k, h) || d)) return k.abort();
            if (x = "abort", g.add(h.complete), k.done(h.success), k.fail(h.error), n = Vt(Wt, h, i, k)) {
                if (k.readyState = 1, c && m.trigger("ajaxSend", [k, h]), d) return k;
                h.async && 0 < h.timeout && (a = e.setTimeout(function() {
                    k.abort("timeout")
                }, h.timeout));
                try {
                    d = !1, n.send(w, C)
                } catch (e) {
                    if (d) throw e;
                    C(-1, e)
                }
            } else C(-1, "No Transport");

            function C(t, i, r, l) {
                var u, p, y, w, S, x = i;
                d || (d = !0, a && e.clearTimeout(a), n = void 0, s = l || "", k.readyState = 0 < t ? 4 : 0, u = 200 <= t && t < 300 || 304 === t, r && (w = function(e, t, i) {
                    for (var n, o, s, r, a = e.contents, l = e.dataTypes;
                        "*" === l[0];) l.shift(), void 0 === n && (n = e.mimeType || t.getResponseHeader("Content-Type"));
                    if (n)
                        for (o in a)
                            if (a[o] && a[o].test(n)) {
                                l.unshift(o);
                                break
                            } if (l[0] in i) s = l[0];
                    else {
                        for (o in i) {
                            if (!l[0] || e.converters[o + " " + l[0]]) {
                                s = o;
                                break
                            }
                            r || (r = o)
                        }
                        s = s || r
                    }
                    if (s) return s !== l[0] && l.unshift(s), i[s]
                }(h, k, r)), !u && -1 < T.inArray("script", h.dataTypes) && 0 > T.inArray("json", h.dataTypes) && (h.converters["text script"] = function() {}), w = function(e, t, i, n) {
                    var o, s, r, a, l, d = {},
                        c = e.dataTypes.slice();
                    if (c[1])
                        for (r in e.converters) d[r.toLowerCase()] = e.converters[r];
                    for (s = c.shift(); s;)
                        if (e.responseFields[s] && (i[e.responseFields[s]] = t), !l && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = s, s = c.shift())
                            if ("*" === s) s = l;
                            else if ("*" !== l && l !== s) {
                        if (!(r = d[l + " " + s] || d["* " + s]))
                            for (o in d)
                                if ((a = o.split(" "))[1] === s && (r = d[l + " " + a[0]] || d["* " + a[0]])) {
                                    !0 === r ? r = d[o] : !0 !== d[o] && (s = a[0], c.unshift(a[1]));
                                    break
                                } if (!0 !== r)
                            if (r && e.throws) t = r(t);
                            else try {
                                t = r(t)
                            } catch (e) {
                                return {
                                    state: "parsererror",
                                    error: r ? e : "No conversion from " + l + " to " + s
                                }
                            }
                    }
                    return {
                        state: "success",
                        data: t
                    }
                }(h, w, k, u), u ? (h.ifModified && ((S = k.getResponseHeader("Last-Modified")) && (T.lastModified[o] = S), (S = k.getResponseHeader("etag")) && (T.etag[o] = S)), 204 === t || "HEAD" === h.type ? x = "nocontent" : 304 === t ? x = "notmodified" : (x = w.state, p = w.data, u = !(y = w.error))) : (y = x, !t && x || (x = "error", t < 0 && (t = 0))), k.status = t, k.statusText = (i || x) + "", u ? v.resolveWith(f, [p, x, k]) : v.rejectWith(f, [k, x, y]), k.statusCode(b), b = void 0, c && m.trigger(u ? "ajaxSuccess" : "ajaxError", [k, h, u ? p : y]), g.fireWith(f, [k, x]), c && (m.trigger("ajaxComplete", [k, h]), --T.active || T.event.trigger("ajaxStop")))
            }
            return k
        },
        getJSON: function(e, t, i) {
            return T.get(e, t, i, "json")
        },
        getScript: function(e, t) {
            return T.get(e, void 0, t, "script")
        }
    }), T.each(["get", "post"], function(e, t) {
        T[t] = function(e, i, n, o) {
            return f(i) && (o = o || n, n = i, i = void 0), T.ajax(T.extend({
                url: e,
                type: t,
                dataType: o,
                data: i,
                success: n
            }, T.isPlainObject(e) && e))
        }
    }), T.ajaxPrefilter(function(e) {
        var t;
        for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "")
    }), T._evalUrl = function(e, t, i) {
        return T.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
                "text script": function() {}
            },
            dataFilter: function(e) {
                T.globalEval(e, t, i)
            }
        })
    }, T.fn.extend({
        wrapAll: function(e) {
            var t;
            return this[0] && (f(e) && (e = e.call(this[0])), t = T(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
                for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                return e
            }).append(this)), this
        },
        wrapInner: function(e) {
            return f(e) ? this.each(function(t) {
                T(this).wrapInner(e.call(this, t))
            }) : this.each(function() {
                var t = T(this),
                    i = t.contents();
                i.length ? i.wrapAll(e) : t.append(e)
            })
        },
        wrap: function(e) {
            var t = f(e);
            return this.each(function(i) {
                T(this).wrapAll(t ? e.call(this, i) : e)
            })
        },
        unwrap: function(e) {
            return this.parent(e).not("body").each(function() {
                T(this).replaceWith(this.childNodes)
            }), this
        }
    }), T.expr.pseudos.hidden = function(e) {
        return !T.expr.pseudos.visible(e)
    }, T.expr.pseudos.visible = function(e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
    }, T.ajaxSettings.xhr = function() {
        try {
            return new e.XMLHttpRequest
        } catch (e) {}
    };
    var Yt = {
            0: 200,
            1223: 204
        },
        Gt = T.ajaxSettings.xhr();
    h.cors = !!Gt && "withCredentials" in Gt, h.ajax = Gt = !!Gt, T.ajaxTransport(function(t) {
        var i, n;
        if (h.cors || Gt && !t.crossDomain) return {
            send: function(o, s) {
                var r, a = t.xhr();
                if (a.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)
                    for (r in t.xhrFields) a[r] = t.xhrFields[r];
                for (r in t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType), t.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest"), o) a.setRequestHeader(r, o[r]);
                i = function(e) {
                    return function() {
                        i && (i = n = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null, "abort" === e ? a.abort() : "error" === e ? "number" != typeof a.status ? s(0, "error") : s(a.status, a.statusText) : s(Yt[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                            binary: a.response
                        } : {
                            text: a.responseText
                        }, a.getAllResponseHeaders()))
                    }
                }, a.onload = i(), n = a.onerror = a.ontimeout = i("error"), void 0 !== a.onabort ? a.onabort = n : a.onreadystatechange = function() {
                    4 === a.readyState && e.setTimeout(function() {
                        i && n()
                    })
                }, i = i("abort");
                try {
                    a.send(t.hasContent && t.data || null)
                } catch (e) {
                    if (i) throw e
                }
            },
            abort: function() {
                i && i()
            }
        }
    }), T.ajaxPrefilter(function(e) {
        e.crossDomain && (e.contents.script = !1)
    }), T.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(e) {
                return T.globalEval(e), e
            }
        }
    }), T.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
    }), T.ajaxTransport("script", function(e) {
        var t, i;
        if (e.crossDomain || e.scriptAttrs) return {
            send: function(n, o) {
                t = T("<script>").attr(e.scriptAttrs || {}).prop({
                    charset: e.scriptCharset,
                    src: e.url
                }).on("load error", i = function(e) {
                    t.remove(), i = null, e && o("error" === e.type ? 404 : 200, e.type)
                }), y.head.appendChild(t[0])
            },
            abort: function() {
                i && i()
            }
        }
    });
    var Qt, Kt = [],
        Jt = /(=)\?(?=&|$)|\?\?/;
    T.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = Kt.pop() || T.expando + "_" + $t.guid++;
            return this[e] = !0, e
        }
    }), T.ajaxPrefilter("json jsonp", function(t, i, n) {
        var o, s, r, a = !1 !== t.jsonp && (Jt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Jt.test(t.data) && "data");
        if (a || "jsonp" === t.dataTypes[0]) return o = t.jsonpCallback = f(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, a ? t[a] = t[a].replace(Jt, "$1" + o) : !1 !== t.jsonp && (t.url += (Et.test(t.url) ? "&" : "?") + t.jsonp + "=" + o), t.converters["script json"] = function() {
            return r || T.error(o + " was not called"), r[0]
        }, t.dataTypes[0] = "json", s = e[o], e[o] = function() {
            r = arguments
        }, n.always(function() {
            void 0 === s ? T(e).removeProp(o) : e[o] = s, t[o] && (t.jsonpCallback = i.jsonpCallback, Kt.push(o)), r && f(s) && s(r[0]), r = s = void 0
        }), "script"
    }), h.createHTMLDocument = ((Qt = y.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === Qt.childNodes.length), T.parseHTML = function(e, t, i) {
        var n, o, s;
        return "string" != typeof e ? [] : ("boolean" == typeof t && (i = t, t = !1), t || (h.createHTMLDocument ? ((n = (t = y.implementation.createHTMLDocument("")).createElement("base")).href = y.location.href, t.head.appendChild(n)) : t = y), s = !i && [], (o = B.exec(e)) ? [t.createElement(o[1])] : (o = Ae([e], t, s), s && s.length && T(s).remove(), T.merge([], o.childNodes)))
    }, T.fn.load = function(e, t, i) {
        var n, o, s, r = this,
            a = e.indexOf(" ");
        return -1 < a && (n = St(e.slice(a)), e = e.slice(0, a)), f(t) ? (i = t, t = void 0) : t && "object" == typeof t && (o = "POST"), 0 < r.length && T.ajax({
            url: e,
            type: o || "GET",
            dataType: "html",
            data: t
        }).done(function(e) {
            s = arguments, r.html(n ? T("<div>").append(T.parseHTML(e)).find(n) : e)
        }).always(i && function(e, t) {
            r.each(function() {
                i.apply(this, s || [e.responseText, t, e])
            })
        }), this
    }, T.expr.pseudos.animated = function(e) {
        return T.grep(T.timers, function(t) {
            return e === t.elem
        }).length
    }, T.offset = {
        setOffset: function(e, t, i) {
            var n, o, s, r, a, l, d = T.css(e, "position"),
                c = T(e),
                u = {};
            "static" === d && (e.style.position = "relative"), a = c.offset(), s = T.css(e, "top"), l = T.css(e, "left"), ("absolute" === d || "fixed" === d) && -1 < (s + l).indexOf("auto") ? (r = (n = c.position()).top, o = n.left) : (r = parseFloat(s) || 0, o = parseFloat(l) || 0), f(t) && (t = t.call(e, i, T.extend({}, a))), null != t.top && (u.top = t.top - a.top + r), null != t.left && (u.left = t.left - a.left + o), "using" in t ? t.using.call(e, u) : c.css(u)
        }
    }, T.fn.extend({
        offset: function(e) {
            if (arguments.length) return void 0 === e ? this : this.each(function(t) {
                T.offset.setOffset(this, e, t)
            });
            var t, i, n = this[0];
            return n ? n.getClientRects().length ? (t = n.getBoundingClientRect(), i = n.ownerDocument.defaultView, {
                top: t.top + i.pageYOffset,
                left: t.left + i.pageXOffset
            }) : {
                top: 0,
                left: 0
            } : void 0
        },
        position: function() {
            if (this[0]) {
                var e, t, i, n = this[0],
                    o = {
                        top: 0,
                        left: 0
                    };
                if ("fixed" === T.css(n, "position")) t = n.getBoundingClientRect();
                else {
                    for (t = this.offset(), i = n.ownerDocument, e = n.offsetParent || i.documentElement; e && (e === i.body || e === i.documentElement) && "static" === T.css(e, "position");) e = e.parentNode;
                    e && e !== n && 1 === e.nodeType && ((o = T(e).offset()).top += T.css(e, "borderTopWidth", !0), o.left += T.css(e, "borderLeftWidth", !0))
                }
                return {
                    top: t.top - o.top - T.css(n, "marginTop", !0),
                    left: t.left - o.left - T.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var e = this.offsetParent; e && "static" === T.css(e, "position");) e = e.offsetParent;
                return e || pe
            })
        }
    }), T.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(e, t) {
        var i = "pageYOffset" === t;
        T.fn[e] = function(n) {
            return K(this, function(e, n, o) {
                var s;
                if (m(e) ? s = e : 9 === e.nodeType && (s = e.defaultView), void 0 === o) return s ? s[t] : e[n];
                s ? s.scrollTo(i ? s.pageXOffset : o, i ? o : s.pageYOffset) : e[n] = o
            }, e, n, arguments.length)
        }
    }), T.each(["top", "left"], function(e, t) {
        T.cssHooks[t] = Ge(h.pixelPosition, function(e, i) {
            if (i) return i = Ye(e, t), Fe.test(i) ? T(e).position()[t] + "px" : i
        })
    }), T.each({
        Height: "height",
        Width: "width"
    }, function(e, t) {
        T.each({
            padding: "inner" + e,
            content: t,
            "": "outer" + e
        }, function(i, n) {
            T.fn[n] = function(o, s) {
                var r = arguments.length && (i || "boolean" != typeof o),
                    a = i || (!0 === o || !0 === s ? "margin" : "border");
                return K(this, function(t, i, o) {
                    var s;
                    return m(t) ? 0 === n.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (s = t.documentElement, Math.max(t.body["scroll" + e], s["scroll" + e], t.body["offset" + e], s["offset" + e], s["client" + e])) : void 0 === o ? T.css(t, i, a) : T.style(t, i, o, a)
                }, t, r ? o : void 0, r)
            }
        })
    }), T.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        T.fn[t] = function(e) {
            return this.on(t, e)
        }
    }), T.fn.extend({
        bind: function(e, t, i) {
            return this.on(e, null, t, i)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, i, n) {
            return this.on(t, e, i, n)
        },
        undelegate: function(e, t, i) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", i)
        },
        hover: function(e, t) {
            return this.on("mouseenter", e).on("mouseleave", t || e)
        }
    }), T.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, t) {
        T.fn[t] = function(e, i) {
            return 0 < arguments.length ? this.on(t, null, e, i) : this.trigger(t)
        }
    });
    var Zt = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    T.proxy = function(e, t) {
        var i, n, s;
        if ("string" == typeof t && (i = e[t], t = e, e = i), f(e)) return n = o.call(arguments, 2), (s = function() {
            return e.apply(t || this, n.concat(o.call(arguments)))
        }).guid = e.guid = e.guid || T.guid++, s
    }, T.holdReady = function(e) {
        e ? T.readyWait++ : T.ready(!0)
    }, T.isArray = Array.isArray, T.parseJSON = JSON.parse, T.nodeName = k, T.isFunction = f, T.isWindow = m, T.camelCase = te, T.type = b, T.now = Date.now, T.isNumeric = function(e) {
        var t = T.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
    }, T.trim = function(e) {
        return null == e ? "" : (e + "").replace(Zt, "$1")
    }, "function" == typeof define && define.amd && define("jquery", [], function() {
        return T
    });
    var ei = e.jQuery,
        ti = e.$;
    return T.noConflict = function(t) {
        return e.$ === T && (e.$ = ti), t && e.jQuery === T && (e.jQuery = ei), T
    }, void 0 === t && (e.jQuery = e.$ = T), T
}),
function(e) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof exports ? module.exports = e(require("jquery")) : e(jQuery)
}(function(e) {
    "use strict";
    var t, i = window.Slick;
    (t = 0, i = function(i, n) {
        var o, s = this;
        s.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: e(i),
            appendDots: e(i),
            arrows: !0,
            asNavFor: null,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function(t, i) {
                return e('<button type="button" />').text(i + 1)
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: .35,
            fade: !1,
            focusOnSelect: !1,
            focusOnChange: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: "ondemand",
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3
        }, s.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            scrolling: !1,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            swiping: !1,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1
        }, e.extend(s, s.initials), s.activeBreakpoint = null, s.animType = null, s.animProp = null, s.breakpoints = [], s.breakpointSettings = [], s.cssTransitions = !1, s.focussed = !1, s.interrupted = !1, s.hidden = "hidden", s.paused = !0, s.positionProp = null, s.respondTo = null, s.rowCount = 1, s.shouldClick = !0, s.$slider = e(i), s.$slidesCache = null, s.transformType = null, s.transitionType = null, s.visibilityChange = "visibilitychange", s.windowWidth = 0, s.windowTimer = null, o = e(i).data("slick") || {}, s.options = e.extend({}, s.defaults, n, o), s.currentSlide = s.options.initialSlide, s.originalSettings = s.options, void 0 !== document.mozHidden ? (s.hidden = "mozHidden", s.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (s.hidden = "webkitHidden", s.visibilityChange = "webkitvisibilitychange"), s.autoPlay = e.proxy(s.autoPlay, s), s.autoPlayClear = e.proxy(s.autoPlayClear, s), s.autoPlayIterator = e.proxy(s.autoPlayIterator, s), s.changeSlide = e.proxy(s.changeSlide, s), s.clickHandler = e.proxy(s.clickHandler, s), s.selectHandler = e.proxy(s.selectHandler, s), s.setPosition = e.proxy(s.setPosition, s), s.swipeHandler = e.proxy(s.swipeHandler, s), s.dragHandler = e.proxy(s.dragHandler, s), s.keyHandler = e.proxy(s.keyHandler, s), s.instanceUid = t++, s.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, s.registerBreakpoints(), s.init(!0)
    }).prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }, i.prototype.addSlide = i.prototype.slickAdd = function(t, i, n) {
        var o = this;
        if ("boolean" == typeof i) n = i, i = null;
        else if (i < 0 || i >= o.slideCount) return !1;
        o.unload(), "number" == typeof i ? 0 === i && 0 === o.$slides.length ? e(t).appendTo(o.$slideTrack) : n ? e(t).insertBefore(o.$slides.eq(i)) : e(t).insertAfter(o.$slides.eq(i)) : !0 === n ? e(t).prependTo(o.$slideTrack) : e(t).appendTo(o.$slideTrack), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slides.each(function(t, i) {
            e(i).attr("data-slick-index", t)
        }), o.$slidesCache = o.$slides, o.reinit()
    }, i.prototype.animateHeight = function() {
        if (1 === this.options.slidesToShow && !0 === this.options.adaptiveHeight && !1 === this.options.vertical) {
            var e = this.$slides.eq(this.currentSlide).outerHeight(!0);
            this.$list.animate({
                height: e
            }, this.options.speed)
        }
    }, i.prototype.animateSlide = function(t, i) {
        var n = {},
            o = this;
        o.animateHeight(), !0 === o.options.rtl && !1 === o.options.vertical && (t = -t), !1 === o.transformsEnabled ? !1 === o.options.vertical ? o.$slideTrack.animate({
            left: t
        }, o.options.speed, o.options.easing, i) : o.$slideTrack.animate({
            top: t
        }, o.options.speed, o.options.easing, i) : !1 === o.cssTransitions ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft), e({
            animStart: o.currentLeft
        }).animate({
            animStart: t
        }, {
            duration: o.options.speed,
            easing: o.options.easing,
            step: function(e) {
                e = Math.ceil(e), !1 === o.options.vertical ? (n[o.animType] = "translate(" + e + "px, 0px)", o.$slideTrack.css(n)) : (n[o.animType] = "translate(0px," + e + "px)", o.$slideTrack.css(n))
            },
            complete: function() {
                i && i.call()
            }
        })) : (o.applyTransition(), t = Math.ceil(t), !1 === o.options.vertical ? n[o.animType] = "translate3d(" + t + "px, 0px, 0px)" : n[o.animType] = "translate3d(0px," + t + "px, 0px)", o.$slideTrack.css(n), i && setTimeout(function() {
            o.disableTransition(), i.call()
        }, o.options.speed))
    }, i.prototype.getNavTarget = function() {
        var t = this.options.asNavFor;
        return t && null !== t && (t = e(t).not(this.$slider)), t
    }, i.prototype.asNavFor = function(t) {
        var i = this.getNavTarget();
        null !== i && "object" == typeof i && i.each(function() {
            var i = e(this).slick("getSlick");
            i.unslicked || i.slideHandler(t, !0)
        })
    }, i.prototype.applyTransition = function(e) {
        var t = this,
            i = {};
        !1 === t.options.fade ? i[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase : i[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase, !1 === t.options.fade ? t.$slideTrack.css(i) : t.$slides.eq(e).css(i)
    }, i.prototype.autoPlay = function() {
        var e = this;
        e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed))
    }, i.prototype.autoPlayClear = function() {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer)
    }, i.prototype.autoPlayIterator = function() {
        var e = this,
            t = e.currentSlide + e.options.slidesToScroll;
        e.paused || e.interrupted || e.focussed || (!1 === e.options.infinite && (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? e.direction = 0 : 0 === e.direction && (t = e.currentSlide - e.options.slidesToScroll, e.currentSlide - 1 == 0 && (e.direction = 1))), e.slideHandler(t))
    }, i.prototype.buildArrows = function() {
        var t = this;
        !0 === t.options.arrows && (t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow"), t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow"), t.slideCount > t.options.slidesToShow ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows), !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, i.prototype.buildDots = function() {
        var t, i, n = this;
        if (!0 === n.options.dots) {
            for (n.$slider.addClass("slick-dotted"), i = e("<ul />").addClass(n.options.dotsClass), t = 0; t <= n.getDotCount(); t += 1) i.append(e("<li />").append(n.options.customPaging.call(this, n, t)));
            n.$dots = i.appendTo(n.options.appendDots), n.$dots.find("li").first().addClass("slick-active")
        }
    }, i.prototype.buildOut = function() {
        var t = this;
        t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), t.slideCount = t.$slides.length, t.$slides.each(function(t, i) {
            e(i).attr("data-slick-index", t).data("originalStyling", e(i).attr("style") || "")
        }), t.$slider.addClass("slick-slider"), t.$slideTrack = 0 === t.slideCount ? e('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent(), t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent(), t.$slideTrack.css("opacity", 0), !0 !== t.options.centerMode && !0 !== t.options.swipeToSlide || (t.options.slidesToScroll = 1), e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"), t.setupInfinite(), t.buildArrows(), t.buildDots(), t.updateDots(), t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0), !0 === t.options.draggable && t.$list.addClass("draggable")
    }, i.prototype.buildRows = function() {
        var e, t, i, n, o, s, r;
        if (n = document.createDocumentFragment(), s = this.$slider.children(), this.options.rows > 1) {
            for (r = this.options.slidesPerRow * this.options.rows, o = Math.ceil(s.length / r), e = 0; e < o; e++) {
                var a = document.createElement("div");
                for (t = 0; t < this.options.rows; t++) {
                    var l = document.createElement("div");
                    for (i = 0; i < this.options.slidesPerRow; i++) {
                        var d = e * r + (t * this.options.slidesPerRow + i);
                        s.get(d) && l.appendChild(s.get(d))
                    }
                    a.appendChild(l)
                }
                n.appendChild(a)
            }
            this.$slider.empty().append(n), this.$slider.children().children().children().css({
                width: 100 / this.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, i.prototype.checkResponsive = function(t, i) {
        var n, o, s, r = this,
            a = !1,
            l = r.$slider.width(),
            d = window.innerWidth || e(window).width();
        if ("window" === r.respondTo ? s = d : "slider" === r.respondTo ? s = l : "min" === r.respondTo && (s = Math.min(d, l)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
            for (n in o = null, r.breakpoints) r.breakpoints.hasOwnProperty(n) && (!1 === r.originalSettings.mobileFirst ? s < r.breakpoints[n] && (o = r.breakpoints[n]) : s > r.breakpoints[n] && (o = r.breakpoints[n]));
            null !== o ? null !== r.activeBreakpoint ? (o !== r.activeBreakpoint || i) && (r.activeBreakpoint = o, "unslick" === r.breakpointSettings[o] ? r.unslick(o) : (r.options = e.extend({}, r.originalSettings, r.breakpointSettings[o]), !0 === t && (r.currentSlide = r.options.initialSlide), r.refresh(t)), a = o) : (r.activeBreakpoint = o, "unslick" === r.breakpointSettings[o] ? r.unslick(o) : (r.options = e.extend({}, r.originalSettings, r.breakpointSettings[o]), !0 === t && (r.currentSlide = r.options.initialSlide), r.refresh(t)), a = o) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === t && (r.currentSlide = r.options.initialSlide), r.refresh(t), a = o), t || !1 === a || r.$slider.trigger("breakpoint", [r, a])
        }
    }, i.prototype.changeSlide = function(t, i) {
        var n, o, s = e(t.currentTarget);
        switch (s.is("a") && t.preventDefault(), s.is("li") || (s = s.closest("li")), n = this.slideCount % this.options.slidesToScroll != 0 ? 0 : (this.slideCount - this.currentSlide) % this.options.slidesToScroll, t.data.message) {
            case "previous":
                o = 0 === n ? this.options.slidesToScroll : this.options.slidesToShow - n, this.slideCount > this.options.slidesToShow && this.slideHandler(this.currentSlide - o, !1, i);
                break;
            case "next":
                o = 0 === n ? this.options.slidesToScroll : n, this.slideCount > this.options.slidesToShow && this.slideHandler(this.currentSlide + o, !1, i);
                break;
            case "index":
                var r = 0 === t.data.index ? 0 : t.data.index || s.index() * this.options.slidesToScroll;
                this.slideHandler(this.checkNavigable(r), !1, i), s.children().trigger("focus");
                break;
            default:
                return
        }
    }, i.prototype.checkNavigable = function(e) {
        var t, i;
        if (i = 0, e > (t = this.getNavigableIndexes())[t.length - 1]) e = t[t.length - 1];
        else
            for (var n in t) {
                if (e < t[n]) {
                    e = i;
                    break
                }
                i = t[n]
            }
        return e
    }, i.prototype.cleanUpEvents = function() {
        this.options.dots && null !== this.$dots && (e("li", this.$dots).off("click.slick", this.changeSlide).off("mouseenter.slick", e.proxy(this.interrupt, this, !0)).off("mouseleave.slick", e.proxy(this.interrupt, this, !1)), !0 === this.options.accessibility && this.$dots.off("keydown.slick", this.keyHandler)), this.$slider.off("focus.slick blur.slick"), !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow && this.$prevArrow.off("click.slick", this.changeSlide), this.$nextArrow && this.$nextArrow.off("click.slick", this.changeSlide), !0 === this.options.accessibility && (this.$prevArrow && this.$prevArrow.off("keydown.slick", this.keyHandler), this.$nextArrow && this.$nextArrow.off("keydown.slick", this.keyHandler))), this.$list.off("touchstart.slick mousedown.slick", this.swipeHandler), this.$list.off("touchmove.slick mousemove.slick", this.swipeHandler), this.$list.off("touchend.slick mouseup.slick", this.swipeHandler), this.$list.off("touchcancel.slick mouseleave.slick", this.swipeHandler), this.$list.off("click.slick", this.clickHandler), e(document).off(this.visibilityChange, this.visibility), this.cleanUpSlideEvents(), !0 === this.options.accessibility && this.$list.off("keydown.slick", this.keyHandler), !0 === this.options.focusOnSelect && e(this.$slideTrack).children().off("click.slick", this.selectHandler), e(window).off("orientationchange.slick.slick-" + this.instanceUid, this.orientationChange), e(window).off("resize.slick.slick-" + this.instanceUid, this.resize), e("[draggable!=true]", this.$slideTrack).off("dragstart", this.preventDefault), e(window).off("load.slick.slick-" + this.instanceUid, this.setPosition)
    }, i.prototype.cleanUpSlideEvents = function() {
        this.$list.off("mouseenter.slick", e.proxy(this.interrupt, this, !0)), this.$list.off("mouseleave.slick", e.proxy(this.interrupt, this, !1))
    }, i.prototype.cleanUpRows = function() {
        var e;
        this.options.rows > 1 && ((e = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(e))
    }, i.prototype.clickHandler = function(e) {
        !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault())
    }, i.prototype.destroy = function(t) {
        var i = this;
        i.autoPlayClear(), i.touchObject = {}, i.cleanUpEvents(), e(".slick-cloned", i.$slider).detach(), i.$dots && i.$dots.remove(), i.$prevArrow && i.$prevArrow.length && (i.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()), i.$nextArrow && i.$nextArrow.length && (i.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()), i.$slides && (i.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            e(this).attr("style", e(this).data("originalStyling"))
        }), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.detach(), i.$list.detach(), i.$slider.append(i.$slides)), i.cleanUpRows(), i.$slider.removeClass("slick-slider"), i.$slider.removeClass("slick-initialized"), i.$slider.removeClass("slick-dotted"), i.unslicked = !0, t || i.$slider.trigger("destroy", [i])
    }, i.prototype.disableTransition = function(e) {
        var t = this,
            i = {};
        i[t.transitionType] = "", !1 === t.options.fade ? t.$slideTrack.css(i) : t.$slides.eq(e).css(i)
    }, i.prototype.fadeSlide = function(e, t) {
        var i = this;
        !1 === i.cssTransitions ? (i.$slides.eq(e).css({
            zIndex: i.options.zIndex
        }), i.$slides.eq(e).animate({
            opacity: 1
        }, i.options.speed, i.options.easing, t)) : (i.applyTransition(e), i.$slides.eq(e).css({
            opacity: 1,
            zIndex: i.options.zIndex
        }), t && setTimeout(function() {
            i.disableTransition(e), t.call()
        }, i.options.speed))
    }, i.prototype.fadeSlideOut = function(e) {
        !1 === this.cssTransitions ? this.$slides.eq(e).animate({
            opacity: 0,
            zIndex: this.options.zIndex - 2
        }, this.options.speed, this.options.easing) : (this.applyTransition(e), this.$slides.eq(e).css({
            opacity: 0,
            zIndex: this.options.zIndex - 2
        }))
    }, i.prototype.filterSlides = i.prototype.slickFilter = function(e) {
        var t = this;
        null !== e && (t.$slidesCache = t.$slides, t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit())
    }, i.prototype.focusHandler = function() {
        var t = this;
        t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function(i) {
            i.stopImmediatePropagation();
            var n = e(this);
            setTimeout(function() {
                t.options.pauseOnFocus && (t.focussed = n.is(":focus"), t.autoPlay())
            }, 0)
        })
    }, i.prototype.getCurrent = i.prototype.slickCurrentSlide = function() {
        return this.currentSlide
    }, i.prototype.getDotCount = function() {
        var e = 0,
            t = 0,
            i = 0;
        if (!0 === this.options.infinite)
            if (this.slideCount <= this.options.slidesToShow) ++i;
            else
                for (; e < this.slideCount;) ++i, e = t + this.options.slidesToScroll, t += this.options.slidesToScroll <= this.options.slidesToShow ? this.options.slidesToScroll : this.options.slidesToShow;
        else if (!0 === this.options.centerMode) i = this.slideCount;
        else if (this.options.asNavFor)
            for (; e < this.slideCount;) ++i, e = t + this.options.slidesToScroll, t += this.options.slidesToScroll <= this.options.slidesToShow ? this.options.slidesToScroll : this.options.slidesToShow;
        else i = 1 + Math.ceil((this.slideCount - this.options.slidesToShow) / this.options.slidesToScroll);
        return i - 1
    }, i.prototype.getLeft = function(e) {
        var t, i, n, o, s = this,
            r = 0;
        return s.slideOffset = 0, i = s.$slides.first().outerHeight(!0), !0 === s.options.infinite ? (s.slideCount > s.options.slidesToShow && (s.slideOffset = -s.slideWidth * s.options.slidesToShow * 1, o = -1, !0 === s.options.vertical && !0 === s.options.centerMode && (2 === s.options.slidesToShow ? o = -1.5 : 1 === s.options.slidesToShow && (o = -2)), r = i * s.options.slidesToShow * o), s.slideCount % s.options.slidesToScroll != 0 && e + s.options.slidesToScroll > s.slideCount && s.slideCount > s.options.slidesToShow && (e > s.slideCount ? (s.slideOffset = -(s.options.slidesToShow - (e - s.slideCount)) * s.slideWidth * 1, r = -(s.options.slidesToShow - (e - s.slideCount)) * i * 1) : (s.slideOffset = -s.slideCount % s.options.slidesToScroll * s.slideWidth * 1, r = -s.slideCount % s.options.slidesToScroll * i * 1))) : e + s.options.slidesToShow > s.slideCount && (s.slideOffset = (e + s.options.slidesToShow - s.slideCount) * s.slideWidth, r = (e + s.options.slidesToShow - s.slideCount) * i), s.slideCount <= s.options.slidesToShow && (s.slideOffset = 0, r = 0), !0 === s.options.centerMode && s.slideCount <= s.options.slidesToShow ? s.slideOffset = s.slideWidth * Math.floor(s.options.slidesToShow) / 2 - s.slideWidth * s.slideCount / 2 : !0 === s.options.centerMode && !0 === s.options.infinite ? s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2) - s.slideWidth : !0 === s.options.centerMode && (s.slideOffset = 0, s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2)), t = !1 === s.options.vertical ? -e * s.slideWidth * 1 + s.slideOffset : -e * i * 1 + r, !0 === s.options.variableWidth && (n = s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite ? s.$slideTrack.children(".slick-slide").eq(e) : s.$slideTrack.children(".slick-slide").eq(e + s.options.slidesToShow), t = !0 === s.options.rtl ? n[0] ? -1 * (s.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0, !0 === s.options.centerMode && (n = s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite ? s.$slideTrack.children(".slick-slide").eq(e) : s.$slideTrack.children(".slick-slide").eq(e + s.options.slidesToShow + 1), t = !0 === s.options.rtl ? n[0] ? -1 * (s.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0, t += (s.$list.width() - n.outerWidth()) / 2)), t
    }, i.prototype.getOption = i.prototype.slickGetOption = function(e) {
        return this.options[e]
    }, i.prototype.getNavigableIndexes = function() {
        var e, t = 0,
            i = 0,
            n = [];
        for (!1 === this.options.infinite ? e = this.slideCount : (t = -1 * this.options.slidesToScroll, i = -1 * this.options.slidesToScroll, e = 2 * this.slideCount); t < e;) n.push(t), t = i + this.options.slidesToScroll, i += this.options.slidesToScroll <= this.options.slidesToShow ? this.options.slidesToScroll : this.options.slidesToShow;
        return n
    }, i.prototype.getSlick = function() {
        return this
    }, i.prototype.getSlideCount = function() {
        var t, i, n = this;
        return i = !0 === n.options.centerMode ? n.slideWidth * Math.floor(n.options.slidesToShow / 2) : 0, !0 === n.options.swipeToSlide ? (n.$slideTrack.find(".slick-slide").each(function(o, s) {
            if (s.offsetLeft - i + e(s).outerWidth() / 2 > -1 * n.swipeLeft) return t = s, !1
        }), Math.abs(e(t).attr("data-slick-index") - n.currentSlide) || 1) : n.options.slidesToScroll
    }, i.prototype.goTo = i.prototype.slickGoTo = function(e, t) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(e)
            }
        }, t)
    }, i.prototype.init = function(t) {
        var i = this;
        e(i.$slider).hasClass("slick-initialized") || (e(i.$slider).addClass("slick-initialized"), i.buildRows(), i.buildOut(), i.setProps(), i.startLoad(), i.loadSlider(), i.initializeEvents(), i.updateArrows(), i.updateDots(), i.checkResponsive(!0), i.focusHandler()), t && i.$slider.trigger("init", [i]), !0 === i.options.accessibility && i.initADA(), i.options.autoplay && (i.paused = !1, i.autoPlay())
    }, i.prototype.initADA = function() {
        var t = this,
            i = Math.ceil(t.slideCount / t.options.slidesToShow),
            n = t.getNavigableIndexes().filter(function(e) {
                return e >= 0 && e < t.slideCount
            });
        t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }), null !== t.$dots && (t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function(i) {
            var o = n.indexOf(i);
            e(this).attr({
                role: "tabpanel",
                id: "slick-slide" + t.instanceUid + i,
                tabindex: -1
            }), -1 !== o && e(this).attr({
                "aria-describedby": "slick-slide-control" + t.instanceUid + o
            })
        }), t.$dots.attr("role", "tablist").find("li").each(function(o) {
            var s = n[o];
            e(this).attr({
                role: "presentation"
            }), e(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + t.instanceUid + o,
                "aria-controls": "slick-slide" + t.instanceUid + s,
                "aria-label": o + 1 + " of " + i,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(t.currentSlide).find("button").attr({
            "aria-selected": "true",
            tabindex: "0"
        }).end());
        for (var o = t.currentSlide, s = o + t.options.slidesToShow; o < s; o++) t.$slides.eq(o).attr("tabindex", 0);
        t.activateADA()
    }, i.prototype.initArrowEvents = function() {
        !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, this.changeSlide), this.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, this.changeSlide), !0 === this.options.accessibility && (this.$prevArrow.on("keydown.slick", this.keyHandler), this.$nextArrow.on("keydown.slick", this.keyHandler)))
    }, i.prototype.initDotEvents = function() {
        !0 === this.options.dots && (e("li", this.$dots).on("click.slick", {
            message: "index"
        }, this.changeSlide), !0 === this.options.accessibility && this.$dots.on("keydown.slick", this.keyHandler)), !0 === this.options.dots && !0 === this.options.pauseOnDotsHover && e("li", this.$dots).on("mouseenter.slick", e.proxy(this.interrupt, this, !0)).on("mouseleave.slick", e.proxy(this.interrupt, this, !1))
    }, i.prototype.initSlideEvents = function() {
        this.options.pauseOnHover && (this.$list.on("mouseenter.slick", e.proxy(this.interrupt, this, !0)), this.$list.on("mouseleave.slick", e.proxy(this.interrupt, this, !1)))
    }, i.prototype.initializeEvents = function() {
        this.initArrowEvents(), this.initDotEvents(), this.initSlideEvents(), this.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, this.swipeHandler), this.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, this.swipeHandler), this.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, this.swipeHandler), this.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, this.swipeHandler), this.$list.on("click.slick", this.clickHandler), e(document).on(this.visibilityChange, e.proxy(this.visibility, this)), !0 === this.options.accessibility && this.$list.on("keydown.slick", this.keyHandler), !0 === this.options.focusOnSelect && e(this.$slideTrack).children().on("click.slick", this.selectHandler), e(window).on("orientationchange.slick.slick-" + this.instanceUid, e.proxy(this.orientationChange, this)), e(window).on("resize.slick.slick-" + this.instanceUid, e.proxy(this.resize, this)), e("[draggable!=true]", this.$slideTrack).on("dragstart", this.preventDefault), e(window).on("load.slick.slick-" + this.instanceUid, this.setPosition), e(this.setPosition)
    }, i.prototype.initUI = function() {
        !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.show(), this.$nextArrow.show()), !0 === this.options.dots && this.slideCount > this.options.slidesToShow && this.$dots.show()
    }, i.prototype.keyHandler = function(e) {
        e.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === e.keyCode && !0 === this.options.accessibility ? this.changeSlide({
            data: {
                message: !0 === this.options.rtl ? "next" : "previous"
            }
        }) : 39 === e.keyCode && !0 === this.options.accessibility && this.changeSlide({
            data: {
                message: !0 === this.options.rtl ? "previous" : "next"
            }
        }))
    }, i.prototype.lazyLoad = function() {
        function t(t) {
            e("img[data-lazy]", t).each(function() {
                var t = e(this),
                    i = e(this).attr("data-lazy"),
                    n = e(this).attr("data-srcset"),
                    o = e(this).attr("data-sizes") || s.$slider.attr("data-sizes"),
                    r = document.createElement("img");
                r.onload = function() {
                    t.animate({
                        opacity: 0
                    }, 100, function() {
                        n && (t.attr("srcset", n), o && t.attr("sizes", o)), t.attr("src", i).animate({
                            opacity: 1
                        }, 200, function() {
                            t.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }), s.$slider.trigger("lazyLoaded", [s, t, i])
                    })
                }, r.onerror = function() {
                    t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), s.$slider.trigger("lazyLoadError", [s, t, i])
                }, r.src = i
            })
        }
        var i, n, o, s = this;
        if (!0 === s.options.centerMode ? !0 === s.options.infinite ? o = (n = s.currentSlide + (s.options.slidesToShow / 2 + 1)) + s.options.slidesToShow + 2 : (n = Math.max(0, s.currentSlide - (s.options.slidesToShow / 2 + 1)), o = s.options.slidesToShow / 2 + 1 + 2 + s.currentSlide) : (o = Math.ceil((n = s.options.infinite ? s.options.slidesToShow + s.currentSlide : s.currentSlide) + s.options.slidesToShow), !0 === s.options.fade && (n > 0 && n--, o <= s.slideCount && o++)), i = s.$slider.find(".slick-slide").slice(n, o), "anticipated" === s.options.lazyLoad)
            for (var r = n - 1, a = o, l = s.$slider.find(".slick-slide"), d = 0; d < s.options.slidesToScroll; d++) r < 0 && (r = s.slideCount - 1), i = (i = i.add(l.eq(r))).add(l.eq(a)), r--, a++;
        t(i), s.slideCount <= s.options.slidesToShow ? t(s.$slider.find(".slick-slide")) : s.currentSlide >= s.slideCount - s.options.slidesToShow ? t(s.$slider.find(".slick-cloned").slice(0, s.options.slidesToShow)) : 0 === s.currentSlide && t(s.$slider.find(".slick-cloned").slice(-1 * s.options.slidesToShow))
    }, i.prototype.loadSlider = function() {
        this.setPosition(), this.$slideTrack.css({
            opacity: 1
        }), this.$slider.removeClass("slick-loading"), this.initUI(), "progressive" === this.options.lazyLoad && this.progressiveLazyLoad()
    }, i.prototype.next = i.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    }, i.prototype.orientationChange = function() {
        this.checkResponsive(), this.setPosition()
    }, i.prototype.pause = i.prototype.slickPause = function() {
        this.autoPlayClear(), this.paused = !0
    }, i.prototype.play = i.prototype.slickPlay = function() {
        var e = this;
        e.autoPlay(), e.options.autoplay = !0, e.paused = !1, e.focussed = !1, e.interrupted = !1
    }, i.prototype.postSlide = function(t) {
        var i = this;
        i.unslicked || (i.$slider.trigger("afterChange", [i, t]), i.animating = !1, i.slideCount > i.options.slidesToShow && i.setPosition(), i.swipeLeft = null, i.options.autoplay && i.autoPlay(), !0 === i.options.accessibility && (i.initADA(), i.options.focusOnChange && e(i.$slides.get(i.currentSlide)).attr("tabindex", 0).focus()))
    }, i.prototype.prev = i.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    }, i.prototype.preventDefault = function(e) {
        e.preventDefault()
    }, i.prototype.progressiveLazyLoad = function(t) {
        t = t || 1;
        var i, n, o, s, r, a = this,
            l = e("img[data-lazy]", a.$slider);
        l.length ? (n = (i = l.first()).attr("data-lazy"), o = i.attr("data-srcset"), s = i.attr("data-sizes") || a.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function() {
            o && (i.attr("srcset", o), s && i.attr("sizes", s)), i.attr("src", n).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === a.options.adaptiveHeight && a.setPosition(), a.$slider.trigger("lazyLoaded", [a, i, n]), a.progressiveLazyLoad()
        }, r.onerror = function() {
            t < 3 ? setTimeout(function() {
                a.progressiveLazyLoad(t + 1)
            }, 500) : (i.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), a.$slider.trigger("lazyLoadError", [a, i, n]), a.progressiveLazyLoad())
        }, r.src = n) : a.$slider.trigger("allImagesLoaded", [a])
    }, i.prototype.refresh = function(t) {
        var i, n, o = this;
        n = o.slideCount - o.options.slidesToShow, !o.options.infinite && o.currentSlide > n && (o.currentSlide = n), o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0), i = o.currentSlide, o.destroy(!0), e.extend(o, o.initials, {
            currentSlide: i
        }), o.init(), t || o.changeSlide({
            data: {
                message: "index",
                index: i
            }
        }, !1)
    }, i.prototype.registerBreakpoints = function() {
        var t, i, n, o = this,
            s = o.options.responsive || null;
        if ("array" === e.type(s) && s.length) {
            for (t in o.respondTo = o.options.respondTo || "window", s)
                if (n = o.breakpoints.length - 1, s.hasOwnProperty(t)) {
                    for (i = s[t].breakpoint; n >= 0;) o.breakpoints[n] && o.breakpoints[n] === i && o.breakpoints.splice(n, 1), n--;
                    o.breakpoints.push(i), o.breakpointSettings[i] = s[t].settings
                } o.breakpoints.sort(function(e, t) {
                return o.options.mobileFirst ? e - t : t - e
            })
        }
    }, i.prototype.reinit = function() {
        var t = this;
        t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide"), t.slideCount = t.$slides.length, t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll), t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0), t.registerBreakpoints(), t.setProps(), t.setupInfinite(), t.buildArrows(), t.updateArrows(), t.initArrowEvents(), t.buildDots(), t.updateDots(), t.initDotEvents(), t.cleanUpSlideEvents(), t.initSlideEvents(), t.checkResponsive(!1, !0), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler), t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0), t.setPosition(), t.focusHandler(), t.paused = !t.options.autoplay, t.autoPlay(), t.$slider.trigger("reInit", [t])
    }, i.prototype.resize = function() {
        var t = this;
        e(window).width() !== t.windowWidth && (clearTimeout(t.windowDelay), t.windowDelay = window.setTimeout(function() {
            t.windowWidth = e(window).width(), t.checkResponsive(), t.unslicked || t.setPosition()
        }, 50))
    }, i.prototype.removeSlide = i.prototype.slickRemove = function(e, t, i) {
        var n = this;
        if (e = "boolean" == typeof e ? !0 === (t = e) ? 0 : n.slideCount - 1 : !0 === t ? --e : e, n.slideCount < 1 || e < 0 || e > n.slideCount - 1) return !1;
        n.unload(), !0 === i ? n.$slideTrack.children().remove() : n.$slideTrack.children(this.options.slide).eq(e).remove(), n.$slides = n.$slideTrack.children(this.options.slide), n.$slideTrack.children(this.options.slide).detach(), n.$slideTrack.append(n.$slides), n.$slidesCache = n.$slides, n.reinit()
    }, i.prototype.setCSS = function(e) {
        var t, i, n = this,
            o = {};
        !0 === n.options.rtl && (e = -e), t = "left" == n.positionProp ? Math.ceil(e) + "px" : "0px", i = "top" == n.positionProp ? Math.ceil(e) + "px" : "0px", o[n.positionProp] = e, !1 === n.transformsEnabled ? n.$slideTrack.css(o) : (o = {}, !1 === n.cssTransitions ? (o[n.animType] = "translate(" + t + ", " + i + ")", n.$slideTrack.css(o)) : (o[n.animType] = "translate3d(" + t + ", " + i + ", 0px)", n.$slideTrack.css(o)))
    }, i.prototype.setDimensions = function() {
        var e = this;
        !1 === e.options.vertical ? !0 === e.options.centerMode && e.$list.css({
            padding: "0px " + e.options.centerPadding
        }) : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({
            padding: e.options.centerPadding + " 0px"
        })), e.listWidth = e.$list.width(), e.listHeight = e.$list.height(), !1 === e.options.vertical && !1 === e.options.variableWidth ? (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length))) : !0 === e.options.variableWidth ? e.$slideTrack.width(5e3 * e.slideCount) : (e.slideWidth = Math.ceil(e.listWidth), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
        var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
        !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t)
    }, i.prototype.setFade = function() {
        var t, i = this;
        i.$slides.each(function(n, o) {
            t = -i.slideWidth * n * 1, !0 === i.options.rtl ? e(o).css({
                position: "relative",
                right: t,
                top: 0,
                zIndex: i.options.zIndex - 2,
                opacity: 0
            }) : e(o).css({
                position: "relative",
                left: t,
                top: 0,
                zIndex: i.options.zIndex - 2,
                opacity: 0
            })
        }), i.$slides.eq(i.currentSlide).css({
            zIndex: i.options.zIndex - 1,
            opacity: 1
        })
    }, i.prototype.setHeight = function() {
        if (1 === this.options.slidesToShow && !0 === this.options.adaptiveHeight && !1 === this.options.vertical) {
            var e = this.$slides.eq(this.currentSlide).outerHeight(!0);
            this.$list.css("height", e)
        }
    }, i.prototype.setOption = i.prototype.slickSetOption = function() {
        var t, i, n, o, s, r = this,
            a = !1;
        if ("object" === e.type(arguments[0]) ? (n = arguments[0], a = arguments[1], s = "multiple") : "string" === e.type(arguments[0]) && (n = arguments[0], o = arguments[1], a = arguments[2], "responsive" === arguments[0] && "array" === e.type(arguments[1]) ? s = "responsive" : void 0 !== arguments[1] && (s = "single")), "single" === s) r.options[n] = o;
        else if ("multiple" === s) e.each(n, function(e, t) {
            r.options[e] = t
        });
        else if ("responsive" === s)
            for (i in o)
                if ("array" !== e.type(r.options.responsive)) r.options.responsive = [o[i]];
                else {
                    for (t = r.options.responsive.length - 1; t >= 0;) r.options.responsive[t].breakpoint === o[i].breakpoint && r.options.responsive.splice(t, 1), t--;
                    r.options.responsive.push(o[i])
                } a && (r.unload(), r.reinit())
    }, i.prototype.setPosition = function() {
        this.setDimensions(), this.setHeight(), !1 === this.options.fade ? this.setCSS(this.getLeft(this.currentSlide)) : this.setFade(), this.$slider.trigger("setPosition", [this])
    }, i.prototype.setProps = function() {
        var e = this,
            t = document.body.style;
        e.positionProp = !0 === e.options.vertical ? "top" : "left", "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"), void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition || !0 === e.options.useCSS && (e.cssTransitions = !0), e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : e.options.zIndex = e.defaults.zIndex), void 0 !== t.OTransform && (e.animType = "OTransform", e.transformType = "-o-transform", e.transitionType = "OTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.MozTransform && (e.animType = "MozTransform", e.transformType = "-moz-transform", e.transitionType = "MozTransition", void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)), void 0 !== t.webkitTransform && (e.animType = "webkitTransform", e.transformType = "-webkit-transform", e.transitionType = "webkitTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.msTransform && (e.animType = "msTransform", e.transformType = "-ms-transform", e.transitionType = "msTransition", void 0 === t.msTransform && (e.animType = !1)), void 0 !== t.transform && !1 !== e.animType && (e.animType = "transform", e.transformType = "transform", e.transitionType = "transition"), e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType
    }, i.prototype.setSlideClasses = function(e) {
        var t, i, n, o;
        if (i = this.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), this.$slides.eq(e).addClass("slick-current"), !0 === this.options.centerMode) {
            var s = this.options.slidesToShow % 2 == 0 ? 1 : 0;
            t = Math.floor(this.options.slidesToShow / 2), !0 === this.options.infinite && (e >= t && e <= this.slideCount - 1 - t ? this.$slides.slice(e - t + s, e + t + 1).addClass("slick-active").attr("aria-hidden", "false") : (n = this.options.slidesToShow + e, i.slice(n - t + 1 + s, n + t + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === e ? i.eq(i.length - 1 - this.options.slidesToShow).addClass("slick-center") : e === this.slideCount - 1 && i.eq(this.options.slidesToShow).addClass("slick-center")), this.$slides.eq(e).addClass("slick-center")
        } else e >= 0 && e <= this.slideCount - this.options.slidesToShow ? this.$slides.slice(e, e + this.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : i.length <= this.options.slidesToShow ? i.addClass("slick-active").attr("aria-hidden", "false") : (o = this.slideCount % this.options.slidesToShow, n = !0 === this.options.infinite ? this.options.slidesToShow + e : e, this.options.slidesToShow == this.options.slidesToScroll && this.slideCount - e < this.options.slidesToShow ? i.slice(n - (this.options.slidesToShow - o), n + o).addClass("slick-active").attr("aria-hidden", "false") : i.slice(n, n + this.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
        "ondemand" !== this.options.lazyLoad && "anticipated" !== this.options.lazyLoad || this.lazyLoad()
    }, i.prototype.setupInfinite = function() {
        var t, i, n, o = this;
        if (!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && (i = null, o.slideCount > o.options.slidesToShow)) {
            for (n = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, t = o.slideCount; t > o.slideCount - n; t -= 1) i = t - 1, e(o.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i - o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");
            for (t = 0; t < n + o.slideCount; t += 1) i = t, e(o.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i + o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");
            o.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                e(this).attr("id", "")
            })
        }
    }, i.prototype.interrupt = function(e) {
        e || this.autoPlay(), this.interrupted = e
    }, i.prototype.selectHandler = function(t) {
        var i = parseInt((e(t.target).is(".slick-slide") ? e(t.target) : e(t.target).parents(".slick-slide")).attr("data-slick-index"));
        i || (i = 0), this.slideCount <= this.options.slidesToShow ? this.slideHandler(i, !1, !0) : this.slideHandler(i)
    }, i.prototype.slideHandler = function(e, t, i) {
        var n, o, s, r, a, l = null,
            d = this;
        if (t = t || !1, !(!0 === d.animating && !0 === d.options.waitForAnimate || !0 === d.options.fade && d.currentSlide === e))
            if (!1 === t && d.asNavFor(e), n = e, l = d.getLeft(n), r = d.getLeft(d.currentSlide), d.currentLeft = null === d.swipeLeft ? r : d.swipeLeft, !1 === d.options.infinite && !1 === d.options.centerMode && (e < 0 || e > d.getDotCount() * d.options.slidesToScroll)) !1 === d.options.fade && (n = d.currentSlide, !0 !== i ? d.animateSlide(r, function() {
                d.postSlide(n)
            }) : d.postSlide(n));
            else if (!1 === d.options.infinite && !0 === d.options.centerMode && (e < 0 || e > d.slideCount - d.options.slidesToScroll)) !1 === d.options.fade && (n = d.currentSlide, !0 !== i ? d.animateSlide(r, function() {
            d.postSlide(n)
        }) : d.postSlide(n));
        else {
            if (d.options.autoplay && clearInterval(d.autoPlayTimer), o = n < 0 ? d.slideCount % d.options.slidesToScroll != 0 ? d.slideCount - d.slideCount % d.options.slidesToScroll : d.slideCount + n : n >= d.slideCount ? d.slideCount % d.options.slidesToScroll != 0 ? 0 : n - d.slideCount : n, d.animating = !0, d.$slider.trigger("beforeChange", [d, d.currentSlide, o]), s = d.currentSlide, d.currentSlide = o, d.setSlideClasses(d.currentSlide), d.options.asNavFor && (a = (a = d.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(d.currentSlide), d.updateDots(), d.updateArrows(), !0 === d.options.fade) return !0 !== i ? (d.fadeSlideOut(s), d.fadeSlide(o, function() {
                d.postSlide(o)
            })) : d.postSlide(o), void d.animateHeight();
            !0 !== i ? d.animateSlide(l, function() {
                d.postSlide(o)
            }) : d.postSlide(o)
        }
    }, i.prototype.startLoad = function() {
        !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.hide(), this.$nextArrow.hide()), !0 === this.options.dots && this.slideCount > this.options.slidesToShow && this.$dots.hide(), this.$slider.addClass("slick-loading")
    }, i.prototype.swipeDirection = function() {
        var e, t;
        return e = this.touchObject.startX - this.touchObject.curX, (t = Math.round(180 * Math.atan2(this.touchObject.startY - this.touchObject.curY, e) / Math.PI)) < 0 && (t = 360 - Math.abs(t)), t <= 45 && t >= 0 || t <= 360 && t >= 315 ? !1 === this.options.rtl ? "left" : "right" : t >= 135 && t <= 225 ? !1 === this.options.rtl ? "right" : "left" : !0 === this.options.verticalSwiping ? t >= 35 && t <= 135 ? "down" : "up" : "vertical"
    }, i.prototype.swipeEnd = function(e) {
        var t, i, n = this;
        if (n.dragging = !1, n.swiping = !1, n.scrolling) return n.scrolling = !1, !1;
        if (n.interrupted = !1, n.shouldClick = !(n.touchObject.swipeLength > 10), void 0 === n.touchObject.curX) return !1;
        if (!0 === n.touchObject.edgeHit && n.$slider.trigger("edge", [n, n.swipeDirection()]), n.touchObject.swipeLength >= n.touchObject.minSwipe) {
            switch (i = n.swipeDirection()) {
                case "left":
                case "down":
                    t = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide + n.getSlideCount()) : n.currentSlide + n.getSlideCount(), n.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    t = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide - n.getSlideCount()) : n.currentSlide - n.getSlideCount(), n.currentDirection = 1
            }
            "vertical" != i && (n.slideHandler(t), n.touchObject = {}, n.$slider.trigger("swipe", [n, i]))
        } else n.touchObject.startX !== n.touchObject.curX && (n.slideHandler(n.currentSlide), n.touchObject = {})
    }, i.prototype.swipeHandler = function(e) {
        var t = this;
        if (!(!1 === t.options.swipe || "ontouchend" in document && !1 === t.options.swipe || !1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))) switch (t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1, t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold, !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold), e.data.action) {
            case "start":
                t.swipeStart(e);
                break;
            case "move":
                t.swipeMove(e);
                break;
            case "end":
                t.swipeEnd(e)
        }
    }, i.prototype.swipeMove = function(e) {
        var t, i, n, o, s, r, a = this;
        return s = void 0 !== e.originalEvent ? e.originalEvent.touches : null, !(!a.dragging || a.scrolling || s && 1 !== s.length) && (t = a.getLeft(a.currentSlide), a.touchObject.curX = void 0 !== s ? s[0].pageX : e.clientX, a.touchObject.curY = void 0 !== s ? s[0].pageY : e.clientY, a.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(a.touchObject.curX - a.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(a.touchObject.curY - a.touchObject.startY, 2))), !a.options.verticalSwiping && !a.swiping && r > 4 ? (a.scrolling = !0, !1) : (!0 === a.options.verticalSwiping && (a.touchObject.swipeLength = r), i = a.swipeDirection(), void 0 !== e.originalEvent && a.touchObject.swipeLength > 4 && (a.swiping = !0, e.preventDefault()), o = (!1 === a.options.rtl ? 1 : -1) * (a.touchObject.curX > a.touchObject.startX ? 1 : -1), !0 === a.options.verticalSwiping && (o = a.touchObject.curY > a.touchObject.startY ? 1 : -1), n = a.touchObject.swipeLength, a.touchObject.edgeHit = !1, !1 === a.options.infinite && (0 === a.currentSlide && "right" === i || a.currentSlide >= a.getDotCount() && "left" === i) && (n = a.touchObject.swipeLength * a.options.edgeFriction, a.touchObject.edgeHit = !0), !1 === a.options.vertical ? a.swipeLeft = t + n * o : a.swipeLeft = t + n * (a.$list.height() / a.listWidth) * o, !0 === a.options.verticalSwiping && (a.swipeLeft = t + n * o), !0 !== a.options.fade && !1 !== a.options.touchMove && (!0 === a.animating ? (a.swipeLeft = null, !1) : void a.setCSS(a.swipeLeft))))
    }, i.prototype.swipeStart = function(e) {
        var t, i = this;
        if (i.interrupted = !0, 1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow) return i.touchObject = {}, !1;
        void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]), i.touchObject.startX = i.touchObject.curX = void 0 !== t ? t.pageX : e.clientX, i.touchObject.startY = i.touchObject.curY = void 0 !== t ? t.pageY : e.clientY, i.dragging = !0
    }, i.prototype.unfilterSlides = i.prototype.slickUnfilter = function() {
        null !== this.$slidesCache && (this.unload(), this.$slideTrack.children(this.options.slide).detach(), this.$slidesCache.appendTo(this.$slideTrack), this.reinit())
    }, i.prototype.unload = function() {
        e(".slick-cloned", this.$slider).remove(), this.$dots && this.$dots.remove(), this.$prevArrow && this.htmlExpr.test(this.options.prevArrow) && this.$prevArrow.remove(), this.$nextArrow && this.htmlExpr.test(this.options.nextArrow) && this.$nextArrow.remove(), this.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, i.prototype.unslick = function(e) {
        this.$slider.trigger("unslick", [this, e]), this.destroy()
    }, i.prototype.updateArrows = function() {
        this.options.slidesToShow, !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && !this.options.infinite && (this.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), this.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === this.currentSlide ? (this.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), this.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : (this.currentSlide >= this.slideCount - this.options.slidesToShow && !1 === this.options.centerMode || this.currentSlide >= this.slideCount - 1 && !0 === this.options.centerMode) && (this.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), this.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, i.prototype.updateDots = function() {
        null !== this.$dots && (this.$dots.find("li").removeClass("slick-active").end(), this.$dots.find("li").eq(Math.floor(this.currentSlide / this.options.slidesToScroll)).addClass("slick-active"))
    }, i.prototype.visibility = function() {
        var e = this;
        e.options.autoplay && (document[e.hidden] ? e.interrupted = !0 : e.interrupted = !1)
    }, e.fn.slick = function() {
        var e, t, n = this,
            o = arguments[0],
            s = Array.prototype.slice.call(arguments, 1),
            r = n.length;
        for (e = 0; e < r; e++)
            if ("object" == typeof o || void 0 === o ? n[e].slick = new i(n[e], o) : t = n[e].slick[o].apply(n[e].slick, s), void 0 !== t) return t;
        return n
    }
}), $(".video_slider .slider-button").css("display", "block").attr("style", function(e, t) {
    return t + " display: block !important;"
}), $("#close-support").on("click", function() {
    $(".cont-details").css("display", "none")
}), document.querySelectorAll('[id^="Details-"] summary').forEach(e => {
    e.setAttribute("role", "button"), e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open")), e.nextElementSibling.getAttribute("id") && e.setAttribute("aria-controls", e.nextElementSibling.id), e.addEventListener("click", e => {
        e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"))
    }), e.closest("header-drawer, menu-drawer") || e.parentElement.addEventListener("keyup", onKeyUpEscape)
});
const trapFocusHandlers = {};

function trapFocus(e, t = e) {
    var i = getFocusableElements(e),
        n = i[0],
        o = i[i.length - 1];
    removeTrapFocus(), trapFocusHandlers.focusin = t => {
        (t.target === e || t.target === o || t.target === n) && document.addEventListener("keydown", trapFocusHandlers.keydown)
    }, trapFocusHandlers.focusout = function() {
        document.removeEventListener("keydown", trapFocusHandlers.keydown)
    }, trapFocusHandlers.keydown = function(t) {
        "TAB" === t.code.toUpperCase() && (t.target !== o || t.shiftKey || (t.preventDefault(), n.focus()), (t.target === e || t.target === n) && t.shiftKey && (t.preventDefault(), o.focus()))
    }, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), t.focus(), "INPUT" === t.tagName && ["search", "text", "email", "url"].includes(t.type) && t.value && t.setSelectionRange(0, t.value.length)
}
try {
    document.querySelector(":focus-visible")
} catch (e) {
    focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
    let e = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"],
        t = null,
        i = null;
    window.addEventListener("keydown", t => {
        e.includes(t.code.toUpperCase()) && (i = !1)
    }), window.addEventListener("mousedown", e => {
        i = !0
    }), window.addEventListener("focus", () => {
        t && t.classList.remove("focused"), i || (t = document.activeElement).classList.add("focused")
    }, !0)
}

function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach(e => {
        e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
    }), document.querySelectorAll(".js-vimeo").forEach(e => {
        e.contentWindow.postMessage('{"method":"pause"}', "*")
    }), document.querySelectorAll("video").forEach(e => e.pause()), document.querySelectorAll("product-model").forEach(e => {
        e.modelViewerUI && e.modelViewerUI.pause()
    })
}

function removeTrapFocus(e = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), e && e.focus()
}

function onKeyUpEscape(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    let t = e.target.closest("details[open]");
    if (!t) return;
    let i = t.querySelector("summary");
    t.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus()
}
class QuantityInput extends HTMLElement {
    constructor() {
        super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
            bubbles: !0
        }), this.input.addEventListener("change", this.onInputChange.bind(this)), this.querySelectorAll("button").forEach(e => e.addEventListener("click", this.onButtonClick.bind(this)))
    }
    quantityUpdateUnsubscriber = void 0;
    connectedCallback() {
        this.validateQtyRules(), this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))
    }
    disconnectedCallback() {
        this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber()
    }
    onInputChange(e) {
        this.validateQtyRules()
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = this.input.value;
        "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent)
    }
    validateQtyRules() {
        let e = parseInt(this.input.value);
        if (this.input.min) {
            let t = parseInt(this.input.min);
            this.querySelector(".quantity__button[name='minus']").classList.toggle("disabled", e <= t)
        }
        if (this.input.max) {
            let t = parseInt(this.input.max);
            this.querySelector(".quantity__button[name='plus']").classList.toggle("disabled", e >= t)
        }
    }
}

function debounce(e, t) {
    let i;
    return (...n) => {
        clearTimeout(i), i = setTimeout(() => e.apply(this, n), t)
    }
}

function throttle(e, t) {
    let i = 0;
    return function(...n) {
        let o = (new Date).getTime();
        if (!(o - i < t)) return i = o, e(...n)
    }
}

function fetchConfig(e = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${e}`
        }
    }
}
customElements.define("quantity-input", QuantityInput), void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function(e, t) {
    return function() {
        return e.apply(t, arguments)
    }
}, Shopify.setSelectorByValue = function(e, t) {
    for (var i = 0, n = e.options.length; i < n; i++) {
        var o = e.options[i];
        if (t == o.value || t == o.innerHTML) return e.selectedIndex = i, i
    }
}, Shopify.addListener = function(e, t, i) {
    e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i)
}, Shopify.postLink = function(e, t) {
    var i = (t = t || {}).method || "post",
        n = t.parameters || {},
        o = document.createElement("form");
    for (var s in o.setAttribute("method", i), o.setAttribute("action", e), n) {
        var r = document.createElement("input");
        r.setAttribute("type", "hidden"), r.setAttribute("name", s), r.setAttribute("value", n[s]), o.appendChild(r)
    }
    document.body.appendChild(o), o.submit(), document.body.removeChild(o)
}, Shopify.CountryProvinceSelector = function(e, t, i) {
    this.countryEl = document.getElementById(e), this.provinceEl = document.getElementById(t), this.provinceContainer = document.getElementById(i.hideElement || t), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
}, Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var e = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler()
    },
    initProvince: function() {
        var e = this.provinceEl.getAttribute("data-default");
        e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e)
    },
    countryHandler: function(e) {
        var t = this.countryEl.options[this.countryEl.selectedIndex],
            i = JSON.parse(t.getAttribute("data-provinces"));
        if (this.clearOptions(this.provinceEl), i && 0 == i.length) this.provinceContainer.style.display = "none";
        else {
            for (var n = 0; n < i.length; n++)(t = document.createElement("option")).value = i[n][0], t.innerHTML = i[n][1], this.provinceEl.appendChild(t);
            this.provinceContainer.style.display = ""
        }
    },
    clearOptions: function(e) {
        for (; e.firstChild;) e.removeChild(e.firstChild)
    },
    setOptions: function(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = document.createElement("option");
            n.value = t[i], n.innerHTML = t[i], e.appendChild(n)
        }
        t.length
    }
};
class MenuDrawer extends HTMLElement {
    constructor() {
        super(), this.mainDetailsToggle = this.querySelector("details"), this.addEventListener("keyup", this.onKeyUp.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.bindEvents()
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach(e => e.addEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll("button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)").forEach(e => e.addEventListener("click", this.onCloseButtonClick.bind(this)))
    }
    onKeyUp(e) {
        if ("ESCAPE" !== e.code.toUpperCase()) return;
        let t = e.target.closest("details[open]");
        t && (t === this.mainDetailsToggle ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(t))
    }
    onSummaryClick(e) {
        let t = e.currentTarget,
            i = t.parentNode,
            n = i.closest(".has-submenu"),
            o = i.hasAttribute("open"),
            s = window.matchMedia("(prefers-reduced-motion: reduce)");

        function r() {
            trapFocus(t.nextElementSibling, i.querySelector("button")), t.nextElementSibling.removeEventListener("transitionend", r)
        }
        i === this.mainDetailsToggle ? (o && e.preventDefault(), o ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t), window.matchMedia("(max-width: 990px)") && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)) : setTimeout(() => {
            i.classList.add("menu-opening"), t.setAttribute("aria-expanded", !0), n && n.classList.add("submenu-open"), !s || s.matches ? r() : t.nextElementSibling.addEventListener("transitionend", r)
        }, 100)
    }
    openMenuDrawer(e) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening")
        }), e.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, e), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
    closeMenuDrawer(e, t = !1) {
        void 0 !== e && (this.mainDetailsToggle.classList.remove("menu-opening"), this.mainDetailsToggle.querySelectorAll("details").forEach(e => {
            e.removeAttribute("open"), e.classList.remove("menu-opening")
        }), this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach(e => {
            e.classList.remove("submenu-open")
        }), document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`), removeTrapFocus(t), this.closeAnimation(this.mainDetailsToggle), e instanceof KeyboardEvent && t?.setAttribute("aria-expanded", !1))
    }
    onFocusOut() {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer()
        })
    }
    onCloseButtonClick(e) {
        let t = e.currentTarget.closest("details");
        this.closeSubmenu(t)
    }
    closeSubmenu(e) {
        let t = e.closest(".submenu-open");
        t && t.classList.remove("submenu-open"), e.classList.remove("menu-opening"), e.querySelector("summary").setAttribute("aria-expanded", !1), removeTrapFocus(e.querySelector("summary")), this.closeAnimation(e)
    }
    closeAnimation(e) {
        let t, i = n => {
            void 0 === t && (t = n), n - t < 400 ? window.requestAnimationFrame(i) : (e.removeAttribute("open"), e.closest("details[open]") && trapFocus(e.closest("details[open]"), e.querySelector("summary")))
        };
        window.requestAnimationFrame(i)
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super()
    }
    openMenuDrawer(e) {
        this.header = this.header || document.querySelector(".section-header"), this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0, document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`), this.header.classList.add("menu-open"), setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening")
        }), e.setAttribute("aria-expanded", !0), window.addEventListener("resize", this.onResize), trapFocus(this.mainDetailsToggle, e), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
    closeMenuDrawer(e, t) {
        t && (super.closeMenuDrawer(e, t), this.header.classList.remove("menu-open"), window.removeEventListener("resize", this.onResize))
    }
    onResize = () => {
        this.header && document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`), document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)
    }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
    constructor() {
        super(), this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)), this.addEventListener("keyup", e => {
            "ESCAPE" === e.code.toUpperCase() && this.hide()
        }), this.classList.contains("media-modal") ? this.addEventListener("pointerup", e => {
            "mouse" !== e.pointerType || e.target.closest("deferred-media, product-model") || this.hide()
        }) : this.addEventListener("click", e => {
            e.target === this && this.hide()
        })
    }
    connectedCallback() {
        this.moved || (this.moved = !0, document.body.appendChild(this))
    }
    show(e) {
        this.openedBy = e;
        let t = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), t && t.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia()
    }
    hide() {
        document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia()
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        let e = this.querySelector("button");
        e && e.addEventListener("click", () => {
            let t = document.querySelector(this.getAttribute("data-modal"));
            t && t.show(e)
        })
    }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        let e = this.querySelector('[id^="Deferred-Poster-"]');
        e && e.addEventListener("click", this.loadContent.bind(this))
    }
    loadContent(e = !0) {
        if (window.pauseAllMedia(), !this.getAttribute("loaded")) {
            let t = document.createElement("div");
            t.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
            let i = this.appendChild(t.querySelector("video, model-viewer, iframe"));
            e && i.focus(), "VIDEO" == i.nodeName && i.getAttribute("autoplay") && i.play()
        }
    }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector('[id^="Slider-"]'), this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.enableSliderLooping = !1, this.currentPageElement = this.querySelector(".slider-counter--current"), this.pageTotalElement = this.querySelector(".slider-counter--total"), this.prevButton = this.querySelector('button[name="previous"]'), this.nextButton = this.querySelector('button[name="next"]'), this.slider && this.nextButton && (this.initPages(), new ResizeObserver(e => this.initPages()).observe(this.slider), this.slider.addEventListener("scroll", this.update.bind(this)), this.prevButton.addEventListener("click", this.onButtonClick.bind(this)), this.nextButton.addEventListener("click", this.onButtonClick.bind(this)))
    }
    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(e => e.clientWidth > 0), this.sliderItemsToShow.length < 2 || (this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft, this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset), this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1, this.update())
    }
    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.initPages()
    }
    update() {
        if (!this.slider || !this.nextButton) return;
        let e = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1, this.currentPageElement && this.pageTotalElement && (this.currentPageElement.textContent = this.currentPage, this.pageTotalElement.textContent = this.totalPages), this.currentPage != e && this.dispatchEvent(new CustomEvent("slideChanged", {
            detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1]
            }
        })), this.enableSliderLooping || (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"), this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled"))
    }
    isSlideVisible(e, t = 0) {
        let i = this.slider.clientWidth + this.slider.scrollLeft - t;
        return e.offsetLeft + e.clientWidth <= i && e.offsetLeft >= this.slider.scrollLeft
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = e.currentTarget.dataset.step || 1;
        this.slideScrollPosition = "next" === e.currentTarget.name ? this.slider.scrollLeft + t * this.sliderItemOffset : this.slider.scrollLeft - t * this.sliderItemOffset, this.setSlidePosition(this.slideScrollPosition)
    }
    setSlidePosition(e) {
        this.slider.scrollTo({
            left: e
        })
    }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
    constructor() {
        super(), this.sliderControlWrapper = this.querySelector(".slider-buttons"), this.enableSliderLooping = !0, this.sliderControlWrapper && (this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide"), this.sliderItemsToShow.length > 0 && (this.currentPage = 1), this.announcementBarSlider = this.querySelector(".announcement-bar-slider"), this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0, this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link")), this.sliderControlLinksArray.forEach(e => e.addEventListener("click", this.linkToSlide.bind(this))), this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)), this.setSlideVisibility(), this.announcementBarSlider && (this.announcementBarArrowButtonWasClicked = !1, this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)"), this.reducedMotion.addEventListener("change", () => {
            "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay()
        }), [this.prevButton, this.nextButton].forEach(e => {
            e.addEventListener("click", () => {
                this.announcementBarArrowButtonWasClicked = !0
            }, {
                once: !0
            })
        })), "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay())
    }
    setAutoPlay() {
        this.autoplaySpeed = 1e3 * this.slider.dataset.speed, this.addEventListener("mouseover", this.focusInHandling.bind(this)), this.addEventListener("mouseleave", this.focusOutHandling.bind(this)), this.addEventListener("focusin", this.focusInHandling.bind(this)), this.addEventListener("focusout", this.focusOutHandling.bind(this)), this.querySelector(".slideshow__autoplay") ? (this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay"), this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)), this.autoplayButtonIsSetToPlay = !0, this.play()) : this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play()
    }
    onButtonClick(e) {
        super.onButtonClick(e), this.wasClicked = !0;
        let t = 1 === this.currentPage,
            i = this.currentPage === this.sliderItemsToShow.length;
        t || i ? (t && "previous" === e.currentTarget.name ? this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length : i && "next" === e.currentTarget.name && (this.slideScrollPosition = 0), this.setSlidePosition(this.slideScrollPosition), this.applyAnimationToAnnouncementBar(e.currentTarget.name)) : this.applyAnimationToAnnouncementBar(e.currentTarget.name)
    }
    setSlidePosition(e) {
        this.setPositionTimeout && clearTimeout(this.setPositionTimeout), this.setPositionTimeout = setTimeout(() => {
            this.slider.scrollTo({
                left: e
            })
        }, this.announcerBarAnimationDelay)
    }
    update() {
        super.update(), this.sliderControlButtons = this.querySelectorAll(".slider-counter__link"), this.prevButton.removeAttribute("disabled"), this.sliderControlButtons.length && (this.sliderControlButtons.forEach(e => {
            e.classList.remove("slider-counter__link--active"), e.removeAttribute("aria-current")
        }), this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"), this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0))
    }
    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
    }
    focusOutHandling(e) {
        if (this.sliderAutoplayButton) {
            let t = e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target);
            this.autoplayButtonIsSetToPlay && !t && this.play()
        } else this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || this.play()
    }
    focusInHandling(e) {
        this.sliderAutoplayButton ? (e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target)) && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause() : this.announcementBarSlider.contains(e.target) && this.pause()
    }
    play() {
        this.slider.setAttribute("aria-live", "off"), clearInterval(this.autoplay), this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
    }
    pause() {
        this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay)
    }
    togglePlayButtonState(e) {
        e ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow)) : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow))
    }
    autoRotateSlides() {
        let e = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
        this.setSlidePosition(e), this.applyAnimationToAnnouncementBar()
    }
    setSlideVisibility(e) {
        this.sliderItemsToShow.forEach((e, t) => {
            let i = e.querySelectorAll("a");
            t === this.currentPage - 1 ? (i.length && i.forEach(e => {
                e.removeAttribute("tabindex")
            }), e.setAttribute("aria-hidden", "false"), e.removeAttribute("tabindex")) : (i.length && i.forEach(e => {
                e.setAttribute("tabindex", "-1")
            }), e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", "-1"))
        }), this.wasClicked = !1
    }
    applyAnimationToAnnouncementBar(e = "next") {
        if (!this.announcementBarSlider) return;
        let t = this.sliderItems.length,
            i = this.currentPage - 1,
            n = (i + ("next" === e ? 1 : -1)) % t;
        n = -1 === n ? t - 1 : n;
        let o = this.sliderItems[n],
            s = this.sliderItems[i],
            r = "announcement-bar-slider--fade-in",
            a = "announcement-bar-slider--fade-out",
            l = "next" === e && i !== t - 1 || "previous" === e && 0 === i ? "next" : "previous";
        s.classList.add(`${a}-${l}`), o.classList.add(`${r}-${l}`), setTimeout(() => {
            s.classList.remove(`${a}-${l}`), o.classList.remove(`${r}-${l}`)
        }, 2 * this.announcerBarAnimationDelay)
    }
    linkToSlide(e) {
        e.preventDefault();
        let t = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(e.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: t
        })
    }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", this.onVariantChange)
    }
    onVariantChange(e) {
        this.updateOptions(), this.updateMasterId(), this.updateSelectedSwatchValue(e), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.removeErrorMessage(), this.updateVariantStatuses(), this.currentVariant ? (this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable())
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select, fieldset"), e => "SELECT" === e.tagName ? e.value : "FIELDSET" === e.tagName ? Array.from(e.querySelectorAll("input")).find(e => e.checked)?.value : void 0)
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find(e => !e.options.map((e, t) => this.options[t] === e).includes(!1))
    }
    updateSelectedSwatchValue({
        target: e
    }) {
        let {
            name: t,
            value: i,
            tagName: n
        } = e;
        if ("SELECT" === n && e.selectedOptions.length) {
            let i = e.selectedOptions[0].dataset.optionSwatchValue,
                n = this.querySelector(`[data-selected-dropdown-swatch="${t}"] > .swatch`);
            if (!n) return;
            i ? (n.style.setProperty("--swatch--background", i), n.classList.remove("swatch--unavailable")) : (n.style.setProperty("--swatch--background", "unset"), n.classList.add("swatch--unavailable"))
        } else if ("INPUT" === n && "radio" === e.type) {
            let e = this.querySelector(`[data-selected-swatch-value="${t}"]`);
            e && (e.innerHTML = i)
        }
    }
    updateMedia() {
        let e = this.currentVariant.options,
            t = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (t.hasAttribute("media-grouping-enabled") && (t.querySelectorAll("[data-media-group]").forEach(e => e.classList.add("hide-media")), e.forEach(e => {
                t.querySelectorAll(`[data-media-group="${e}"]`).forEach(e => e.classList.remove("hide-media"))
            }), t.querySelectorAll("slider-component").forEach(e => {
                e.initPages()
            })), !this.currentVariant || !this.currentVariant.featured_media) return;
        document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`).forEach(e => e.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !0));
        let i = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!i) return;
        let n = i.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        i.prepend(n)
    }
    updateURL() {
        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
    updateShareUrl() {
        let e = document.getElementById(`Share-${this.dataset.section}`);
        e && e.updateUrl && e.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
    updateVariantInput() {
        document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach(e => {
            let t = e.querySelector('input[name="id"]');
            t.value = this.currentVariant.id, t.dispatchEvent(new Event("change", {
                bubbles: !0
            }))
        })
    }
    updateVariantStatuses() {
        let e = this.variantData.filter(e => this.querySelector(":checked").value === e.option1),
            t = [...this.querySelectorAll(".product-form__input")];
        t.forEach((i, n) => {
            if (0 === n) return;
            let o = [...i.querySelectorAll('input[type="radio"], option')],
                s = t[n - 1].querySelector(":checked").value,
                r = e.filter(e => e.available && e[`option${n}`] === s).map(e => e[`option${n + 1}`]);
            this.setInputAvailability(o, r)
        })
    }
    setInputAvailability(e, t) {
        e.forEach(e => {
            let i = e.getAttribute("value"),
                n = t.includes(i);
            "INPUT" === e.tagName ? e.classList.toggle("disabled", !n) : "OPTION" === e.tagName && (e.innerText = n ? i : window.variantStrings.unavailable_with_option.replace("[value]", i))
        })
    }
    updatePickupAvailability() {
        let e = document.querySelector("pickup-availability");
        e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), e.innerHTML = ""))
    }
    removeErrorMessage() {
        let e = this.closest("section");
        if (!e) return;
        let t = e.querySelector("product-form");
        t && t.handleErrorMessage()
    }
    renderProductInfo() {
        let e = this.currentVariant.id,
            t = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        fetch(`${this.dataset.url}?variant=${e}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`).then(e => e.text()).then(i => {
            if (this.currentVariant.id !== e) return;
            let n = (new DOMParser).parseFromString(i, "text/html"),
                o = document.getElementById(`price-${this.dataset.section}`),
                s = n.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
                r = n.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
                a = document.getElementById(`Sku-${this.dataset.section}`),
                l = n.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
                d = document.getElementById(`Inventory-${this.dataset.section}`),
                c = n.getElementById(`Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
                u = document.getElementById(`Price-Per-Item-${this.dataset.section}`),
                p = n.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
                h = document.getElementById(`Volume-${this.dataset.section}`),
                f = document.getElementById(`Quantity-Rules-${this.dataset.section}`),
                m = document.getElementById(`Volume-Note-${this.dataset.section}`);
            m && m.classList.remove("hidden"), h && h.classList.remove("hidden"), f && f.classList.remove("hidden"), s && o && (o.innerHTML = s.innerHTML), l && d && (d.innerHTML = l.innerHTML), r && a && (a.innerHTML = r.innerHTML, a.classList.toggle("hidden", r.classList.contains("hidden"))), c && h && (h.innerHTML = c.innerHTML), p && u && (u.innerHTML = p.innerHTML, u.classList.toggle("hidden", p.classList.contains("hidden")));
            let y = document.getElementById(`price-${this.dataset.section}`);
            y && y.classList.remove("hidden"), d && d.classList.toggle("hidden", "" === l.innerText);
            let v = n.getElementById(`ProductSubmitButton-${t}`);
            this.toggleAddButton(!v || v.hasAttribute("disabled"), window.variantStrings.soldOut), publish(PUB_SUB_EVENTS.variantChange, {
                data: {
                    sectionId: t,
                    html: n,
                    variant: this.currentVariant
                }
            })
        })
    }
    Ram_Rom() {
        var e = this.currentVariant.option3;
        document.getElementById("render_ram_rom").innerText = e
    }
    emiCalculation() {
        var e = this.currentVariant.price / 100,
            t = e.toFixed(2),
            i = t,
            n = Math.pow(1.0099, 24),
            o = (.0099 * i * n / (n - 1)).toFixed(0);
        $("#emi-output").text(" ₹" + o), $("#emi-output-3").text(" ₹" + o), $("#emi-output-offer").text(" ₹" + o);
        var s = (2 * e / 100).toFixed(0);
        $("#discount-price-upi").text(" -₹" + s), i = t, $.each([{
            tableBodyId: "#emi-table-body-axis",
            interestRate: .16,
            durations: [3, 6, 9, 12]
        }, {
            tableBodyId: "#emi-table-body-hsbc",
            interestRate: .15,
            durations: [3, 6, 9, 12, 18]
        }, {
            tableBodyId: "#emi-table-body-kotak",
            interestRate: .16,
            durations: [3, 6, 9, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-rbi",
            interestRate: .13,
            durations: [3, 6, 9, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-scb",
            interestRate: .1188,
            durations: [3, 6, 9, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-yes",
            interestRate: .16,
            durations: [3, 6, 9, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-au",
            interestRate: .16,
            durations: [3, 6, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-bob",
            interestRate: .16,
            durations: [3, 6, 9, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-canara",
            interestRate: .14,
            durations: [3, 6, 9, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-federal",
            interestRate: .16,
            durations: [3, 6, 9, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-icici",
            interestRate: .16,
            durations: [3, 6, 9, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-idbi",
            interestRate: .13,
            durations: [3, 6, 9, 12]
        }, {
            tableBodyId: "#emi-table-body-idfc",
            interestRate: .15,
            durations: [3, 6, 9, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-indusind",
            interestRate: .16,
            durations: [3, 6, 9, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-onecard",
            interestRate: .16,
            durations: [3, 6, 9, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-sbi",
            interestRate: .16,
            durations: [3, 6, 9, 12, 18, 24]
        }, {
            tableBodyId: "#emi-table-body-snapmint",
            interestRate: 0.0000001,
            durations: [3, 6, 9]
        }, {
            tableBodyId: "#emi-table-body-indusind",
            interestRate: .16,
            durations: [3, 6, 9, 12, 18, 24, 36]
        }], function(e, t) {
            var n, o, s, r, a;
            n = t.tableBodyId, o = t.interestRate, s = t.durations, r = $(n), a = 1 / 0, r.empty(), $.each(s, function(e, t) {
                var n, s, l, d, c = (o < 0.001) ? Math.round(i / t) : Math.round((n = t, i * (s = o / 12) * Math.pow(1 + s, n) / (Math.pow(1 + s, n) - 1)));
                var rateText = (o < 0.001) ? '0%' : (100 * o).toFixed(2) + '%';
                c < a && (a = c), r.append(`\n        <tr>\n            <td class="bold">₹${l = c}</td>\n            <td class="grey-text">${d = t} months</td>\n            <td class="grey-text">${rateText}</td>\n            <td class="bold">₹${Math.round(l * d)}</td>\n        </tr>\n    `)
            }), $(`${n}-lowest-cost-emi`).text(`₹${a}`)
        })
    }
    toggleAddButton(e = !0, t, i = !0) {
        let n = document.getElementById(`product-form-${this.dataset.section}`);
        if (!n) return;
        let o = n.querySelector('[name="add"]'),
            s = n.querySelector('[name="add"] > span');
        !o || (e ? (o.setAttribute("disabled", "disabled"), t && (s.textContent = t)) : (o.removeAttribute("disabled"), s.textContent = window.variantStrings.addToCart))
    }
    setUnavailable() {
        let e = document.getElementById(`product-form-${this.dataset.section}`),
            t = e.querySelector('[name="add"]'),
            i = e.querySelector('[name="add"] > span'),
            n = document.getElementById(`price-${this.dataset.section}`),
            o = document.getElementById(`Inventory-${this.dataset.section}`),
            s = document.getElementById(`Sku-${this.dataset.section}`),
            r = document.getElementById(`Price-Per-Item-${this.dataset.section}`),
            a = document.getElementById(`Volume-Note-${this.dataset.section}`),
            l = document.getElementById(`Volume-${this.dataset.section}`),
            d = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        t && (i.textContent = window.variantStrings.unavailable, n && n.classList.add("hidden"), o && o.classList.add("hidden"), s && s.classList.add("hidden"), r && r.classList.add("hidden"), a && a.classList.add("hidden"), l && l.classList.add("hidden"), d && d.classList.add("hidden"))
    }
    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
    }
}
customElements.define("variant-selects", VariantSelects);
class ProductRecommendations extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        new IntersectionObserver(((e, t) => {
            e[0].isIntersecting && (t.unobserve(this), fetch(this.dataset.url).then(e => e.text()).then(e => {
                let t = document.createElement("div");
                t.innerHTML = e;
                let i = t.querySelector("product-recommendations");
                i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML), !this.querySelector("slideshow-component") && this.classList.contains("complementary-products") && this.remove(), t.querySelector(".grid__item") && this.classList.add("product-recommendations--loaded")
            }).catch(e => {
                console.error(e)
            }))
        }).bind(this), {
            rootMargin: "0px 0px 400px 0px"
        }).observe(this)
    }
}
customElements.define("product-recommendations", ProductRecommendations), $(document).ready(function() {
    $("#footerContent").click(function() {
        $(".mainContent").toggleClass("expanded"), $(".mainContent").hasClass("expanded") && $("html, body").animate({
            scrollTop: $(document).height()
        }, "slow")
    })
}), $(document).ready(function() {
    $("#footerContentt").click(function() {
        $(".mainContentt").toggleClass("expanded"), $(".mainContentt").hasClass("expanded") ? $(".css-hhor9v").css("padding-bottom", "30px") : $(".css-hhor9v").css("padding-bottom", "")
    })
});
var activeConditionElements = document.querySelectorAll(".active-Condition");
activeConditionElements.forEach(function(e) {
    e.classList.add("active")
}), $(".video_slider:not(.video_slider_autoplay) .video_slide_list").length && ($(".video_slider .video_slider_block").removeClass("hidden"), $(".video_slider:not(.video_slider_autoplay) .video_slide_list").each(function(e) {
    var t = $(this);
    t.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: !1,
        prevArrow: t.parents(".video_slider").find(".prev_arrow"),
        nextArrow: t.parents(".video_slider").find(".next_arrow"),
        responsive: [{
            breakpoint: 989,
            settings: {
                slidesToShow: 4
            }
        }, {
            breakpoint: 749,
            settings: {
                slidesToShow: 2
            }
        }]
    })
})), $(document).on("click", ".video_slider .video_slide_list .video_block .play_btn", function() {
    $(this).parents(".video_block").removeClass("play_btn_show"), $(this).parents(".video_block").find("img").addClass("hidden"), $(this).parents(".video_block").find("video").trigger("play")
}), $(document).on("click", ".video_slider .video_slide_list .video_block .pause_btn", function() {
    $(this).parents(".video_block").addClass("play_btn_show"), $(this).parents(".video_block").find("video").trigger("pause")
}), document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".accordion-header").forEach(e => {
        e.addEventListener("click", function() {
            let e = this.parentNode,
                t = e.classList.contains("active");
            e.classList.toggle("active"), e.querySelector(".accordion-content").style.display = t ? "none" : "block"
        })
    })
}), $(document).ready(function() {
    let e = 0,
        t = !1;

    function i() {
        e <= 30 && ($("#counter").text(e), e++, setTimeout(i, 100))
    }

    function n() {
        let e = $("#counter")[0];
        if (!e) return;
        let n = e.getBoundingClientRect();
        n.top >= 0 && n.bottom <= $(window).height() && !t && (t = !0, setTimeout(i, 500))
    }
    $(window).on("scroll", n), n()
}), $(document).ready(function() {
    $(".gm-submenu p").hide()
}), $(document).ready(function() {
    $("ul.list-menu--inline").attr("style", "justify-content: space-between !important;")
}), $(document).ready(function() {
    $(".reelUp_verified").each(function() {
        var e = $(this).attr("style");
        e ? $(this).attr("style", e.trim() + " display: none !important;") : $(this).attr("style", "display: none !important;")
    })
}), $(document).ready(function() {
    let e = $("#dynamicPlaceholder"),
        t = ["Vivo", "Samsung", "Oneplus", "Realme", "Xiaomi", "More"],
        i = 0,
        n = 0,
        o = !1;
    if (!document.getElementById("typewriter-cursor-style")) {
        let e = document.createElement("style");
        e.id = "typewriter-cursor-style", e.innerHTML = "@keyframes blink { 0%, 50% { opacity: 1; } 51%, 100% { opacity: 0; } }", document.head.appendChild(e)
    }! function s() {
        let r = t[i];
        !o && n <= r.length ? (e.html(r.substring(0, n) + '<span style="animation: blink 1s infinite;">|</span>'), n++, setTimeout(s, 100)) : !o && n > r.length ? (o = !0, setTimeout(s, 2e3)) : o && n >= 0 ? (e.html(r.substring(0, n) + '<span style="animation: blink 1s infinite;">|</span>'), n--, setTimeout(s, 50)) : o && n < 0 && (o = !1, i = (i + 1) % t.length, n = 0, setTimeout(s, 200))
    }()
}), $(document).ready(function() {
    let e = $("#dynamicPlaceholderr"),
        t = ["Vivo", "Samsung", "Oneplus", "Realme", "Xiaomi", "More"],
        i = 0,
        n = 0,
        o = !1;
    ! function s() {
        let r = t[i];
        !o && n <= r.length ? (e.html(r.substring(0, n) + '<span style="animation: blink 1s infinite;">|</span>'), n++, setTimeout(s, 100)) : !o && n > r.length ? (o = !0, setTimeout(s, 2e3)) : o && n >= 0 ? (e.html(r.substring(0, n) + '<span style="animation: blink 1s infinite;">|</span>'), n--, setTimeout(s, 50)) : o && n < 0 && (o = !1, i = (i + 1) % t.length, n = 0, setTimeout(s, 200))
    }()
}), $(document).ready(function() {
    $(".reelUp_verified").each(function() {
        var e = $(this).attr("style");
        e ? $(this).attr("style", e.trim() + " display: none !important;") : $(this).attr("style", "display: none !important;")
    })
}), $(document).ready(function() {
    $(".openButton1").click(function() {
        $("body").css("overflow", "hidden"), $(".closebutton-condition1").css("display", "block"), $("#overlay1").show(), $("#popup1").addClass("slide-in-bottom").fadeIn(300)
    }), $("#closeButton1").click(function() {
        $("body").css("overflow", "auto"), $("#overlay1").hide(), $(".closebutton-condition1").css("display", "none"), $("#popup1").removeClass("slide-in-bottom").addClass("slide-out-bottom").fadeOut(300, function() {
            $(this).removeClass("slide-out-bottom")
        })
    })
}), $(document).ready(function() {
    $("#openPopupBtn3").click(function() {
        $("#overlay3").css("display", "block"), $("body").css("overflow", "hidden"), $("#closePopupBtn3").addClass("block"), $("#emiOfferPopup").css("display", "block"), 768 >= $(window).width() ? $("#emiOfferPopup").addClass("slide-in-bottom").fadeIn(300) : $("#emiOfferPopup").addClass("slide-in-right").fadeIn(300)
    }), $("#closePopupBtn3").click(function() {
        $("#overlay3").css("display", "none"), $("body").css("overflow", "auto"), $("#closePopupBtn3").removeClass("block"), $("#emiOfferPopup").css("display", "none"), 768 >= $(window).width() ? $("#emiOfferPopup").removeClass("slide-in-bottom").addClass("slide-out-bottom").fadeOut(300, function() {
            $(this).removeClass("slide-out-bottom")
        }) : $("#emiOfferPopup").removeClass("slide-in-right").addClass("slide-out-right").fadeOut(300, function() {
            $(this).removeClass("slide-out-right")
        })
    }), $("#overlay3").click(function(e) {
        "overlay3" === e.target.id && ($("#overlay3").css("display", "none"), $("body").css("overflow", "auto"), $("#emiOfferPopup").css("display", "none"), $("#closePopupBtn3").removeClass("block"), 768 >= $(window).width() ? $("#emiOfferPopup").removeClass("slide-in-bottom").addClass("slide-out-bottom").fadeOut(300, function() {
            $(this).removeClass("slide-out-bottom")
        }) : $("#emiOfferPopup").removeClass("slide-in-right").addClass("slide-out-right").fadeOut(300, function() {
            $(this).removeClass("slide-out-right")
        }))
    }), $("#openPopupBtn3-offer").click(function() {
        $("#overlay3").css("display", "block"), $("body").css("overflow", "hidden"), $("#closePopupBtn3").addClass("block"), $("#emiOfferPopup").css("display", "block"), 768 >= $(window).width() ? $("#emiOfferPopup").addClass("slide-in-bottom").fadeIn(300) : $("#emiOfferPopup").addClass("slide-in-right").fadeIn(300)
    })
}), $(document).ready(function() {
    $(".accordion-header").click(function() {
        var e = $(this).next(".accordion-body"),
            t = $(this).find(".accordion-toggle");
        e.is(":visible") ? (e.slideUp(), t.text("+")) : ($(".accordion-body").slideUp(), $(".accordion-toggle").text("+"), e.slideDown(), t.text("−"))
    })
}), $(window).on("load", function() {
    setTimeout(function() {
        let e = $("#swatch-option1 legend");
        e.length ? e.append('<button id="openButton">View details</button>') : console.error("Legend element not found inside #swatch-option1")
    }, 1e3)
}), window.onload = function() {
    setTimeout(() => {
        document.querySelectorAll(".swatch-button.swatch-selector").forEach(e => {
            let t, i = 0;
            e.addEventListener("click", () => {
                i++, clearTimeout(t), t = setTimeout(() => {
                    i = 0
                }, 500), 3 === i && (document.querySelector("#popup").style.display = "block", document.querySelector(".closebutton-condition").style.display = "block", document.querySelector("#overlay").style.display = "block", i = 0)
            })
        })
    }, 1002)
}, $(window).on("load", function() {
    setTimeout(function() {
        $("#openButton").click(function() {
            $("body").css("overflow", "hidden"), $(".closebutton-condition").css("display", "block"), $("#overlay").show(), 768 >= $(window).width() ? $("#popup").addClass("slide-in-bottom").fadeIn(300) : $("#popup").addClass("slide-in-right").fadeIn(300)
        }), $("#closeButton").click(function() {
            $("body").css("overflow", "auto"), $("#overlay").hide(), $(".closebutton-condition").css("display", "none"), 768 >= $(window).width() ? $("#popup").removeClass("slide-in-bottom").addClass("slide-out-bottom").fadeOut(300, function() {
                $(this).removeClass("slide-out-bottom")
            }) : $("#popup").removeClass("slide-in-right").addClass("slide-out-right").fadeOut(300, function() {
                $(this).removeClass("slide-out-right")
            })
        }), $(document).on("click", ".tab", function() {
            var e = $(this).closest(".conditions-explained");
            $(this).addClass("active").siblings().removeClass("active");
            var t = $(this).data("content");
            e.find(".content").hide(), $("#" + t).show()
        }), $(document).mouseup(function(e) {
            var t = $("#popup");
            t.is(e.target) || 0 !== t.has(e.target).length || 1 !== e.which || ($("body").css("overflow", "auto"), $("#overlay").hide(), $(".closebutton-condition").css("display", "none"), 768 >= $(window).width() ? $("#popup").removeClass("slide-in-bottom").addClass("slide-out-bottom").fadeOut(300, function() {
                $(this).removeClass("slide-out-bottom")
            }) : $("#popup").removeClass("slide-in-right").addClass("slide-out-right").fadeOut(300, function() {
                $(this).removeClass("slide-out-right")
            }))
        })
    }, 1500)
}), $(document).ready(function() {
    $(".openButton22").click(function() {
        $("body").css("overflow", "hidden"), $(".closebutton-condition22").css("display", "block"), $("#overlay1").show(), $("#popup22").addClass("slide-in-bottom").fadeIn(300)
    }), $("#closeButton22").click(function() {
        $("body").css("overflow", "auto"), $("#overlay1").hide(), $(".closebutton-condition22").css("display", "none"), $("#popup22").removeClass("slide-in-bottom").addClass("slide-out-bottom").fadeOut(300, function() {
            $(this).removeClass("slide-out-bottom")
        })
    })
});
const trigger2 = document.querySelector("#trigger2"),
    trigger = document.querySelector("#trigger"),
    Overlay2 = document.querySelector(".overlay2"),
    Overlay = document.querySelector(".overlay"),
    DrawerBottom2 = document.querySelector(".drawerbottom2"),
    DrawerBottom = document.querySelector(".drawerbottom"),
    closeBtn = document.querySelector(".close"),
    closeBtn2 = document.querySelector(".close2");

function openModal() {
    Overlay.classList.add("active"), DrawerBottom.classList.add("active")
}

function openModal2() {
    Overlay2.classList.add("active"), DrawerBottom2.classList.add("active")
}

function closeModal() {
    Overlay.classList.remove("active"), DrawerBottom.classList.remove("active")
}

function closeModal2() {
    Overlay2.classList.remove("active"), DrawerBottom2.classList.remove("active")
}
trigger?.addEventListener("click", function() {
    openModal()
}), trigger2?.addEventListener("click", function() {
    openModal2()
}), closeBtn?.addEventListener("click", function() {
    closeModal()
}), closeBtn2?.addEventListener("click", function() {
    closeModal2()
}), Overlay2?.addEventListener("click", function(e) {
    e.target === this && closeModal2()
}), Overlay?.addEventListener("click", function(e) {
    e.target === this && closeModal()
}), document.addEventListener("keydown", function(e) {
    "Escape" === e.key && closeModal()
}), document.addEventListener("keydown", function(e) {
    "Escape" === e.key && closeModal2()
});